/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UpgradesRouteImport } from './routes/upgrades'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as MeetingEndRouteImport } from './routes/meeting-end'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as CalendarCallbackRouteImport } from './routes/calendar-callback'
import { Route as AcceptInvitationTokenRouteImport } from './routes/accept-invitation-token'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as SplatRouteImport } from './routes/$'
import { Route as PrototypeRouteRouteImport } from './routes/prototype/route'
import { Route as CustomerRouteRouteImport } from './routes/customer/route'
import { Route as OauthRouteRouteImport } from './routes/_oauth/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PrototypeIndexRouteImport } from './routes/prototype/index'
import { Route as ItxframeIndexRouteImport } from './routes/itxframe/index'
import { Route as VideoPublicIdRouteImport } from './routes/video/$publicId'
import { Route as VSecretRouteImport } from './routes/v/$secret'
import { Route as UnsubscribeEmailEmailRouteImport } from './routes/unsubscribe-email/$email'
import { Route as RecordingShareRouteImport } from './routes/recording/share'
import { Route as RecordMeetingIdRouteImport } from './routes/record/$meetingId'
import { Route as OfferTokenRouteImport } from './routes/offer/$token'
import { Route as OauthErrorRouteImport } from './routes/oauth/error'
import { Route as MeetingSummaryTokenRouteImport } from './routes/meeting-summary/$token'
import { Route as JoinMeetingIdRouteImport } from './routes/join/$meetingId'
import { Route as FormsSlugRouteImport } from './routes/forms/$slug'
import { Route as CustomerResetPasswordRouteImport } from './routes/customer/reset-password'
import { Route as CustomerLoginRouteImport } from './routes/customer/login'
import { Route as CustomerForgotPasswordRouteImport } from './routes/customer/forgot-password'
import { Route as CancelBookingSlugRouteImport } from './routes/cancel-booking/$slug'
import { Route as BookMeetingSlugRouteImport } from './routes/book-meeting/$slug'
import { Route as AuthenticatedPracticeCallRouteImport } from './routes/_authenticated/practice-call'
import { Route as AuthenticatedLinkAccountRouteImport } from './routes/_authenticated/link-account'
import { Route as AuthenticatedCreateCompanyRouteImport } from './routes/_authenticated/create-company'
import { Route as AuthenticatedConnectedCompaniesRouteImport } from './routes/_authenticated/connected-companies'
import { Route as DotwellKnownChangePasswordRouteImport } from './routes/[.]well-known/change-password'
import { Route as CustomerCustomerAuthenticatedRouteRouteImport } from './routes/customer/_customer-authenticated/route'
import { Route as AuthenticatedSuperAdminRouteRouteImport } from './routes/_authenticated/super-admin/route'
import { Route as AuthenticatedAppRouteRouteImport } from './routes/_authenticated/_app/route'
import { Route as AuthenticatedSuperAdminIndexRouteImport } from './routes/_authenticated/super-admin/index'
import { Route as PrototypeSlugScreenRouteImport } from './routes/prototype/$slug.$screen'
import { Route as FormsAdditionalTokenRouteImport } from './routes/forms/additional/$token'
import { Route as CustomerCustomerAuthenticatedProfileRouteImport } from './routes/customer/_customer-authenticated/profile'
import { Route as CustomerCustomerAuthenticatedChangePasswordRouteImport } from './routes/customer/_customer-authenticated/change-password'
import { Route as OauthOauthSelectCompanyRouteImport } from './routes/_oauth/oauth/select-company'
import { Route as OauthOauthResumeRouteImport } from './routes/_oauth/oauth/resume'
import { Route as OauthOauthConsentRouteImport } from './routes/_oauth/oauth/consent'
import { Route as AuthenticatedSuperAdminUnsubscribeListRouteImport } from './routes/_authenticated/super-admin/unsubscribe-list'
import { Route as AuthenticatedSuperAdminTranscriptionMonitorRouteImport } from './routes/_authenticated/super-admin/transcription-monitor'
import { Route as AuthenticatedSuperAdminSuppressionListRouteImport } from './routes/_authenticated/super-admin/suppression-list'
import { Route as AuthenticatedSuperAdminSmsLogsRouteImport } from './routes/_authenticated/super-admin/sms-logs'
import { Route as AuthenticatedSuperAdminRecordAndSendRouteImport } from './routes/_authenticated/super-admin/record-and-send'
import { Route as AuthenticatedSuperAdminMobileAdoptionRouteImport } from './routes/_authenticated/super-admin/mobile-adoption'
import { Route as AuthenticatedSuperAdminMcpAdoptionRouteImport } from './routes/_authenticated/super-admin/mcp-adoption'
import { Route as AuthenticatedSuperAdminMcpActivityRouteImport } from './routes/_authenticated/super-admin/mcp-activity'
import { Route as AuthenticatedSuperAdminInspectionLibraryRouteImport } from './routes/_authenticated/super-admin/inspection-library'
import { Route as AuthenticatedSuperAdminImpersonationLogsRouteImport } from './routes/_authenticated/super-admin/impersonation-logs'
import { Route as AuthenticatedSuperAdminFeedbackRouteImport } from './routes/_authenticated/super-admin/feedback'
import { Route as AuthenticatedSuperAdminEmailLogsRouteImport } from './routes/_authenticated/super-admin/email-logs'
import { Route as AuthenticatedSuperAdminConnectedAppsRouteImport } from './routes/_authenticated/super-admin/connected-apps'
import { Route as AuthenticatedSuperAdminCompanyActivityRouteImport } from './routes/_authenticated/super-admin/company-activity'
import { Route as AuthenticatedSuperAdminAuditRouteImport } from './routes/_authenticated/super-admin/audit'
import { Route as AuthenticatedSuperAdminAdminsRouteImport } from './routes/_authenticated/super-admin/admins'
import { Route as AuthenticatedAppTeamLearningRouteImport } from './routes/_authenticated/_app/team-learning'
import { Route as AuthenticatedAppResourcesRouteImport } from './routes/_authenticated/_app/resources'
import { Route as AuthenticatedAppRecordingRouteImport } from './routes/_authenticated/_app/recording'
import { Route as AuthenticatedAppMeetingsRouteImport } from './routes/_authenticated/_app/meetings'
import { Route as AuthenticatedAppGettingStartedRouteImport } from './routes/_authenticated/_app/getting-started'
import { Route as AuthenticatedAppDashboardRouteImport } from './routes/_authenticated/_app/dashboard'
import { Route as AuthenticatedAppChecklistRouteImport } from './routes/_authenticated/_app/checklist'
import { Route as AuthenticatedAppCalendarRouteImport } from './routes/_authenticated/_app/calendar'
import { Route as AuthenticatedAppStaffingRouteRouteImport } from './routes/_authenticated/_app/staffing/route'
import { Route as AuthenticatedAppSettingsRouteRouteImport } from './routes/_authenticated/_app/settings/route'
import { Route as AuthenticatedAppOrdersRouteRouteImport } from './routes/_authenticated/_app/orders/route'
import { Route as AuthenticatedAppMemberPortalRouteRouteImport } from './routes/_authenticated/_app/member-portal/route'
import { Route as AuthenticatedAppInvoicingRouteRouteImport } from './routes/_authenticated/_app/invoicing/route'
import { Route as AuthenticatedAppInspectionRouteRouteImport } from './routes/_authenticated/_app/inspection/route'
import { Route as AuthenticatedAppFormsRouteRouteImport } from './routes/_authenticated/_app/forms/route'
import { Route as AuthenticatedAppCrmRouteRouteImport } from './routes/_authenticated/_app/crm/route'
import { Route as AuthenticatedAppChainRouteRouteImport } from './routes/_authenticated/_app/chain/route'
import { Route as AuthenticatedAppBookingsRouteRouteImport } from './routes/_authenticated/_app/bookings/route'
import { Route as CustomerCustomerAuthenticatedOrdersIndexRouteImport } from './routes/customer/_customer-authenticated/orders/index'
import { Route as AuthenticatedSuperAdminUsersIndexRouteImport } from './routes/_authenticated/super-admin/users/index'
import { Route as AuthenticatedSuperAdminMeetingTelemetryIndexRouteImport } from './routes/_authenticated/super-admin/meeting-telemetry/index'
import { Route as AuthenticatedSuperAdminLoginSecurityIndexRouteImport } from './routes/_authenticated/super-admin/login-security/index'
import { Route as AuthenticatedSuperAdminIndustryPresetsIndexRouteImport } from './routes/_authenticated/super-admin/industry-presets/index'
import { Route as AuthenticatedSuperAdminCompaniesIndexRouteImport } from './routes/_authenticated/super-admin/companies/index'
import { Route as AuthenticatedSuperAdminChainsIndexRouteImport } from './routes/_authenticated/super-admin/chains/index'
import { Route as AuthenticatedSuperAdminAiOpsIndexRouteImport } from './routes/_authenticated/super-admin/ai-ops/index'
import { Route as AuthenticatedAppStaffingIndexRouteImport } from './routes/_authenticated/_app/staffing/index'
import { Route as AuthenticatedAppSettingsIndexRouteImport } from './routes/_authenticated/_app/settings/index'
import { Route as AuthenticatedAppRecordAndSendIndexRouteImport } from './routes/_authenticated/_app/record-and-send/index'
import { Route as AuthenticatedAppOrdersIndexRouteImport } from './routes/_authenticated/_app/orders/index'
import { Route as AuthenticatedAppMemberPortalIndexRouteImport } from './routes/_authenticated/_app/member-portal/index'
import { Route as AuthenticatedAppInvoicingIndexRouteImport } from './routes/_authenticated/_app/invoicing/index'
import { Route as AuthenticatedAppInspectionIndexRouteImport } from './routes/_authenticated/_app/inspection/index'
import { Route as AuthenticatedAppFormsIndexRouteImport } from './routes/_authenticated/_app/forms/index'
import { Route as AuthenticatedAppCrmIndexRouteImport } from './routes/_authenticated/_app/crm/index'
import { Route as AuthenticatedAppCoursesIndexRouteImport } from './routes/_authenticated/_app/courses/index'
import { Route as AuthenticatedAppCompetenceIndexRouteImport } from './routes/_authenticated/_app/competence/index'
import { Route as AuthenticatedAppBookingsIndexRouteImport } from './routes/_authenticated/_app/bookings/index'
import { Route as CustomerCustomerAuthenticatedOrdersOrderIdRouteImport } from './routes/customer/_customer-authenticated/orders/$orderId'
import { Route as AuthenticatedSuperAdminUsersUserIdRouteImport } from './routes/_authenticated/super-admin/users/$userId'
import { Route as AuthenticatedSuperAdminMeetingTelemetryMeetingIdRouteImport } from './routes/_authenticated/super-admin/meeting-telemetry/$meetingId'
import { Route as AuthenticatedSuperAdminLoginSecuritySettingsRouteImport } from './routes/_authenticated/super-admin/login-security/settings'
import { Route as AuthenticatedSuperAdminIndustryPresetsNewRouteImport } from './routes/_authenticated/super-admin/industry-presets/new'
import { Route as AuthenticatedSuperAdminIndustryPresetsIdRouteImport } from './routes/_authenticated/super-admin/industry-presets/$id'
import { Route as AuthenticatedSuperAdminCompaniesCompanyIdRouteImport } from './routes/_authenticated/super-admin/companies/$companyId'
import { Route as AuthenticatedSuperAdminChainsParentCompanyIdRouteImport } from './routes/_authenticated/super-admin/chains/$parentCompanyId'
import { Route as AuthenticatedSuperAdminAiOpsRunsRouteImport } from './routes/_authenticated/super-admin/ai-ops/runs'
import { Route as AuthenticatedSuperAdminAiOpsCostRouteImport } from './routes/_authenticated/super-admin/ai-ops/cost'
import { Route as AuthenticatedAppStaffingSkillsRouteImport } from './routes/_authenticated/_app/staffing/skills'
import { Route as AuthenticatedAppStaffingSkillLevelsRouteImport } from './routes/_authenticated/_app/staffing/skill-levels'
import { Route as AuthenticatedAppStaffingPendingApprovalsRouteImport } from './routes/_authenticated/_app/staffing/pending-approvals'
import { Route as AuthenticatedAppStaffingMyPostingsRouteImport } from './routes/_authenticated/_app/staffing/my-postings'
import { Route as AuthenticatedAppStaffingMyInterestsRouteImport } from './routes/_authenticated/_app/staffing/my-interests'
import { Route as AuthenticatedAppStaffingCategoriesRouteImport } from './routes/_authenticated/_app/staffing/categories'
import { Route as AuthenticatedAppSettingsWhiteLabelingRouteImport } from './routes/_authenticated/_app/settings/white-labeling'
import { Route as AuthenticatedAppSettingsUsageRouteImport } from './routes/_authenticated/_app/settings/usage'
import { Route as AuthenticatedAppSettingsServiceTypesRouteImport } from './routes/_authenticated/_app/settings/service-types'
import { Route as AuthenticatedAppSettingsServiceAreaRouteImport } from './routes/_authenticated/_app/settings/service-area'
import { Route as AuthenticatedAppSettingsProfileRouteImport } from './routes/_authenticated/_app/settings/profile'
import { Route as AuthenticatedAppSettingsOrderSettingsRouteImport } from './routes/_authenticated/_app/settings/order-settings'
import { Route as AuthenticatedAppSettingsNotificationsRouteImport } from './routes/_authenticated/_app/settings/notifications'
import { Route as AuthenticatedAppSettingsMembersRouteImport } from './routes/_authenticated/_app/settings/members'
import { Route as AuthenticatedAppSettingsConnectedAppsRouteImport } from './routes/_authenticated/_app/settings/connected-apps'
import { Route as AuthenticatedAppSettingsCompanyRouteImport } from './routes/_authenticated/_app/settings/company'
import { Route as AuthenticatedAppSettingsApiKeysRouteImport } from './routes/_authenticated/_app/settings/api-keys'
import { Route as AuthenticatedAppSettingsAiSettingsRouteImport } from './routes/_authenticated/_app/settings/ai-settings'
import { Route as AuthenticatedAppSettingsAccessRouteImport } from './routes/_authenticated/_app/settings/access'
import { Route as AuthenticatedAppOrdersReportsRouteImport } from './routes/_authenticated/_app/orders/reports'
import { Route as AuthenticatedAppOrdersOrderIdRouteImport } from './routes/_authenticated/_app/orders/$orderId'
import { Route as AuthenticatedAppMyLearningRouteImport } from './routes/_authenticated/_app/my/learning'
import { Route as AuthenticatedAppMemberPortalToolsRouteImport } from './routes/_authenticated/_app/member-portal/tools'
import { Route as AuthenticatedAppMemberPortalSuppliersRouteImport } from './routes/_authenticated/_app/member-portal/suppliers'
import { Route as AuthenticatedAppMemberPortalOverviewRouteImport } from './routes/_authenticated/_app/member-portal/overview'
import { Route as AuthenticatedAppMemberPortalContactsRouteImport } from './routes/_authenticated/_app/member-portal/contacts'
import { Route as AuthenticatedAppMemberPortalCommunicationsRouteImport } from './routes/_authenticated/_app/member-portal/communications'
import { Route as AuthenticatedAppMemberPortalCampaignsRouteImport } from './routes/_authenticated/_app/member-portal/campaigns'
import { Route as AuthenticatedAppMemberPortalBrandingRouteImport } from './routes/_authenticated/_app/member-portal/branding'
import { Route as AuthenticatedAppMemberPortalAgreementsRouteImport } from './routes/_authenticated/_app/member-portal/agreements'
import { Route as AuthenticatedAppMemberPortalAboutRouteImport } from './routes/_authenticated/_app/member-portal/about'
import { Route as AuthenticatedAppInvoicingInvoiceIdRouteImport } from './routes/_authenticated/_app/invoicing/$invoiceId'
import { Route as AuthenticatedAppHistoryMeetingIDRouteImport } from './routes/_authenticated/_app/history/$meetingID'
import { Route as AuthenticatedAppCoursesCreateRouteImport } from './routes/_authenticated/_app/courses/create'
import { Route as AuthenticatedAppCoursesCourseIdRouteImport } from './routes/_authenticated/_app/courses/$courseId'
import { Route as AuthenticatedAppCompetenceTypesRouteImport } from './routes/_authenticated/_app/competence/types'
import { Route as AuthenticatedAppCompetenceMeRouteImport } from './routes/_authenticated/_app/competence/me'
import { Route as AuthenticatedAppCompetenceMatrixRouteImport } from './routes/_authenticated/_app/competence/matrix'
import { Route as AuthenticatedAppCompetenceApprovalsRouteImport } from './routes/_authenticated/_app/competence/approvals'
import { Route as AuthenticatedAppChainStaffingRouteImport } from './routes/_authenticated/_app/chain/staffing'
import { Route as AuthenticatedAppChainResourcesRouteImport } from './routes/_authenticated/_app/chain/resources'
import { Route as AuthenticatedAppChainQuickLinksRouteImport } from './routes/_authenticated/_app/chain/quick-links'
import { Route as AuthenticatedAppChainOrderPipelineRouteImport } from './routes/_authenticated/_app/chain/order-pipeline'
import { Route as AuthenticatedAppChainMyEndorsementRouteImport } from './routes/_authenticated/_app/chain/my-endorsement'
import { Route as AuthenticatedAppChainMembersRouteImport } from './routes/_authenticated/_app/chain/members'
import { Route as AuthenticatedAppChainMasterCatalogRouteImport } from './routes/_authenticated/_app/chain/master-catalog'
import { Route as AuthenticatedAppChainLearningRouteImport } from './routes/_authenticated/_app/chain/learning'
import { Route as AuthenticatedAppChainEndorsementRouteImport } from './routes/_authenticated/_app/chain/endorsement'
import { Route as AuthenticatedAppChainCoverageRouteImport } from './routes/_authenticated/_app/chain/coverage'
import { Route as AuthenticatedAppChainConfigPushesRouteImport } from './routes/_authenticated/_app/chain/config-pushes'
import { Route as AuthenticatedAppChainCompetenceRouteImport } from './routes/_authenticated/_app/chain/competence'
import { Route as AuthenticatedAppChainAnalyticsRouteImport } from './routes/_authenticated/_app/chain/analytics'
import { Route as AuthenticatedAppBookingsTrackingRouteImport } from './routes/_authenticated/_app/bookings/tracking'
import { Route as AuthenticatedAppBookingsServicesRouteImport } from './routes/_authenticated/_app/bookings/services'
import { Route as AuthenticatedAppBookingsManageRouteImport } from './routes/_authenticated/_app/bookings/manage'
import { Route as AuthenticatedAppBookingsDashboardRouteImport } from './routes/_authenticated/_app/bookings/dashboard'
import { Route as AuthenticatedAppBookingsCustomizeRouteImport } from './routes/_authenticated/_app/bookings/customize'
import { Route as AuthenticatedAppBookingsBlackoutDatesRouteImport } from './routes/_authenticated/_app/bookings/blackout-dates'
import { Route as AuthenticatedAppSettingsBillingRouteRouteImport } from './routes/_authenticated/_app/settings/billing/route'
import { Route as AuthenticatedAppSettingsAuditRouteRouteImport } from './routes/_authenticated/_app/settings/audit/route'
import { Route as AuthenticatedAppMemberPortalManageRouteRouteImport } from './routes/_authenticated/_app/member-portal/manage/route'
import { Route as AuthenticatedAppCrmSettingsRouteRouteImport } from './routes/_authenticated/_app/crm/settings/route'
import { Route as AuthenticatedAppSettingsRolesIndexRouteImport } from './routes/_authenticated/_app/settings/roles/index'
import { Route as AuthenticatedAppSettingsMeetingIndexRouteImport } from './routes/_authenticated/_app/settings/meeting/index'
import { Route as AuthenticatedAppSettingsBillingIndexRouteImport } from './routes/_authenticated/_app/settings/billing/index'
import { Route as AuthenticatedAppSettingsAuditIndexRouteImport } from './routes/_authenticated/_app/settings/audit/index'
import { Route as AuthenticatedAppMemberPortalManageIndexRouteImport } from './routes/_authenticated/_app/member-portal/manage/index'
import { Route as AuthenticatedAppInspectionUpcomingIndexRouteImport } from './routes/_authenticated/_app/inspection/upcoming/index'
import { Route as AuthenticatedAppInspectionTemplatesIndexRouteImport } from './routes/_authenticated/_app/inspection/templates/index'
import { Route as AuthenticatedAppInspectionSitesIndexRouteImport } from './routes/_authenticated/_app/inspection/sites/index'
import { Route as AuthenticatedAppInspectionLibraryIndexRouteImport } from './routes/_authenticated/_app/inspection/library/index'
import { Route as AuthenticatedAppCrmSettingsIndexRouteImport } from './routes/_authenticated/_app/crm/settings/index'
import { Route as AuthenticatedAppCrmReportingIndexRouteImport } from './routes/_authenticated/_app/crm/reporting/index'
import { Route as AuthenticatedAppCrmPipelineIndexRouteImport } from './routes/_authenticated/_app/crm/pipeline/index'
import { Route as AuthenticatedAppCrmMyWorkIndexRouteImport } from './routes/_authenticated/_app/crm/my-work/index'
import { Route as AuthenticatedAppCrmLeadsIndexRouteImport } from './routes/_authenticated/_app/crm/leads/index'
import { Route as AuthenticatedAppCrmDuplicatesIndexRouteImport } from './routes/_authenticated/_app/crm/duplicates/index'
import { Route as AuthenticatedAppCrmDealsIndexRouteImport } from './routes/_authenticated/_app/crm/deals/index'
import { Route as AuthenticatedAppCrmContactsIndexRouteImport } from './routes/_authenticated/_app/crm/contacts/index'
import { Route as AuthenticatedAppCrmCompaniesIndexRouteImport } from './routes/_authenticated/_app/crm/companies/index'
import { Route as AuthenticatedAppCrmCatalogIndexRouteImport } from './routes/_authenticated/_app/crm/catalog/index'
import { Route as AuthenticatedAppChainCoursesIndexRouteImport } from './routes/_authenticated/_app/chain/courses/index'
import { Route as AuthenticatedAppChainAnnouncementsIndexRouteImport } from './routes/_authenticated/_app/chain/announcements/index'
import { Route as AuthenticatedSuperAdminCompaniesCompanyIdRolesRouteImport } from './routes/_authenticated/super-admin/companies/$companyId_.roles'
import { Route as AuthenticatedAppStaffingPostingsNewRouteImport } from './routes/_authenticated/_app/staffing/postings/new'
import { Route as AuthenticatedAppStaffingPostingsIdRouteImport } from './routes/_authenticated/_app/staffing/postings/$id'
import { Route as AuthenticatedAppSettingsRolesNewRouteImport } from './routes/_authenticated/_app/settings/roles/new'
import { Route as AuthenticatedAppSettingsRolesRoleIdRouteImport } from './routes/_authenticated/_app/settings/roles/$roleId'
import { Route as AuthenticatedAppSettingsOrdersPipelineRouteImport } from './routes/_authenticated/_app/settings/orders/pipeline'
import { Route as AuthenticatedAppSettingsMeetingRecordingRouteImport } from './routes/_authenticated/_app/settings/meeting/recording'
import { Route as AuthenticatedAppSettingsMeetingDefaultsRouteImport } from './routes/_authenticated/_app/settings/meeting/defaults'
import { Route as AuthenticatedAppSettingsMeetingBackgroundRouteImport } from './routes/_authenticated/_app/settings/meeting/background'
import { Route as AuthenticatedAppSettingsInvoicingAccountingRouteImport } from './routes/_authenticated/_app/settings/invoicing/accounting'
import { Route as AuthenticatedAppSettingsBillingPaymentsRouteImport } from './routes/_authenticated/_app/settings/billing/payments'
import { Route as AuthenticatedAppSettingsBillingAddonsRouteImport } from './routes/_authenticated/_app/settings/billing/addons'
import { Route as AuthenticatedAppRecordAndSendVideoTypesNewRouteImport } from './routes/_authenticated/_app/record-and-send/video-types/new'
import { Route as AuthenticatedAppRecordAndSendSubmissionsSubmissionIdRouteImport } from './routes/_authenticated/_app/record-and-send/submissions/$submissionId'
import { Route as AuthenticatedAppMemberPortalToolsIdRouteImport } from './routes/_authenticated/_app/member-portal/tools.$id'
import { Route as AuthenticatedAppMemberPortalSuppliersIdRouteImport } from './routes/_authenticated/_app/member-portal/suppliers.$id'
import { Route as AuthenticatedAppMemberPortalManageToolsRouteImport } from './routes/_authenticated/_app/member-portal/manage/tools'
import { Route as AuthenticatedAppMemberPortalManageSuppliersRouteImport } from './routes/_authenticated/_app/member-portal/manage/suppliers'
import { Route as AuthenticatedAppMemberPortalManageContactsRouteImport } from './routes/_authenticated/_app/member-portal/manage/contacts'
import { Route as AuthenticatedAppMemberPortalManageCommunicationsRouteImport } from './routes/_authenticated/_app/member-portal/manage/communications'
import { Route as AuthenticatedAppMemberPortalManageCampaignsRouteImport } from './routes/_authenticated/_app/member-portal/manage/campaigns'
import { Route as AuthenticatedAppMemberPortalManageBrandingRouteImport } from './routes/_authenticated/_app/member-portal/manage/branding'
import { Route as AuthenticatedAppMemberPortalManageAgreementsRouteImport } from './routes/_authenticated/_app/member-portal/manage/agreements'
import { Route as AuthenticatedAppMemberPortalManageAboutRouteImport } from './routes/_authenticated/_app/member-portal/manage/about'
import { Route as AuthenticatedAppMemberPortalCommunicationsIdRouteImport } from './routes/_authenticated/_app/member-portal/communications.$id'
import { Route as AuthenticatedAppMemberPortalCampaignsSlugRouteImport } from './routes/_authenticated/_app/member-portal/campaigns.$slug'
import { Route as AuthenticatedAppMemberPortalBrandingIdRouteImport } from './routes/_authenticated/_app/member-portal/branding_.$id'
import { Route as AuthenticatedAppMemberPortalAgreementsIdRouteImport } from './routes/_authenticated/_app/member-portal/agreements.$id'
import { Route as AuthenticatedAppInvoicingPrepareOrderIdRouteImport } from './routes/_authenticated/_app/invoicing/prepare.$orderId'
import { Route as AuthenticatedAppInspectionTemplatesTemplateIdRouteImport } from './routes/_authenticated/_app/inspection/templates/$templateId'
import { Route as AuthenticatedAppInspectionSitesSiteIdRouteImport } from './routes/_authenticated/_app/inspection/sites/$siteId'
import { Route as AuthenticatedAppFormsFormIdSubmissionsRouteImport } from './routes/_authenticated/_app/forms/$formId/submissions'
import { Route as AuthenticatedAppFormsFormIdDesignerRouteImport } from './routes/_authenticated/_app/forms/$formId/designer'
import { Route as AuthenticatedAppFormsFormIdAnalyticsRouteImport } from './routes/_authenticated/_app/forms/$formId/analytics'
import { Route as AuthenticatedAppCrmSettingsOrderPipelineRouteImport } from './routes/_authenticated/_app/crm/settings/order-pipeline'
import { Route as AuthenticatedAppCrmSettingsOfferDefaultsRouteImport } from './routes/_authenticated/_app/crm/settings/offer-defaults'
import { Route as AuthenticatedAppCrmSettingsLostReasonsRouteImport } from './routes/_authenticated/_app/crm/settings/lost-reasons'
import { Route as AuthenticatedAppCrmSettingsDealFieldsRouteImport } from './routes/_authenticated/_app/crm/settings/deal-fields'
import { Route as AuthenticatedAppCrmSettingsContactFieldsRouteImport } from './routes/_authenticated/_app/crm/settings/contact-fields'
import { Route as AuthenticatedAppCrmSettingsCompanyFieldsRouteImport } from './routes/_authenticated/_app/crm/settings/company-fields'
import { Route as AuthenticatedAppCrmPipelinePipelineIdRouteImport } from './routes/_authenticated/_app/crm/pipeline/$pipelineId'
import { Route as AuthenticatedAppCrmLeadsLeadIdRouteImport } from './routes/_authenticated/_app/crm/leads/$leadId'
import { Route as AuthenticatedAppCrmDealsDealIdRouteImport } from './routes/_authenticated/_app/crm/deals/$dealId'
import { Route as AuthenticatedAppCrmContactsContactIdRouteImport } from './routes/_authenticated/_app/crm/contacts/$contactId'
import { Route as AuthenticatedAppCrmCompaniesIdRouteImport } from './routes/_authenticated/_app/crm/companies/$id'
import { Route as AuthenticatedAppCrmChainPipelineRouteImport } from './routes/_authenticated/_app/crm/chain/pipeline'
import { Route as AuthenticatedAppCrmChainParentIncomingRouteImport } from './routes/_authenticated/_app/crm/chain/parent-incoming'
import { Route as AuthenticatedAppCrmChainMembersRouteImport } from './routes/_authenticated/_app/crm/chain/members'
import { Route as AuthenticatedAppCrmChainDistributionRouteImport } from './routes/_authenticated/_app/crm/chain/distribution'
import { Route as AuthenticatedAppCoursesCourseIdEditRouteImport } from './routes/_authenticated/_app/courses/$courseId_.edit'
import { Route as AuthenticatedAppCompetenceUserUserIdRouteImport } from './routes/_authenticated/_app/competence/user.$userId'
import { Route as AuthenticatedAppChainAnnouncementsAnnouncementIdRouteImport } from './routes/_authenticated/_app/chain/announcements/$announcementId'
import { Route as AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRouteImport } from './routes/_authenticated/_app/record-and-send/video-types/$videoTypeId/route'
import { Route as AuthenticatedAppInspectionInspectionsInspectionIdRouteRouteImport } from './routes/_authenticated/_app/inspection/inspections/$inspectionId/route'
import { Route as AuthenticatedAppChainCompaniesMemberIdRouteRouteImport } from './routes/_authenticated/_app/chain/companies/$memberId/route'
import { Route as AuthenticatedAppSettingsBillingPricingIndexRouteImport } from './routes/_authenticated/_app/settings/billing/pricing/index'
import { Route as AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdIndexRouteImport } from './routes/_authenticated/_app/record-and-send/video-types/$videoTypeId/index'
import { Route as AuthenticatedAppInspectionInspectionsInspectionIdIndexRouteImport } from './routes/_authenticated/_app/inspection/inspections/$inspectionId/index'
import { Route as AuthenticatedAppCrmSettingsPipelinesIndexRouteImport } from './routes/_authenticated/_app/crm/settings/pipelines/index'
import { Route as AuthenticatedAppChainCompaniesMemberIdIndexRouteImport } from './routes/_authenticated/_app/chain/companies/$memberId/index'
import { Route as AuthenticatedAppStaffingPostingsIdEditRouteImport } from './routes/_authenticated/_app/staffing/postings/$id_.edit'
import { Route as AuthenticatedAppSettingsBillingPricingCheckoutRouteImport } from './routes/_authenticated/_app/settings/billing/pricing/checkout'
import { Route as AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdVideosRouteImport } from './routes/_authenticated/_app/record-and-send/video-types/$videoTypeId/videos'
import { Route as AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdSettingsRouteImport } from './routes/_authenticated/_app/record-and-send/video-types/$videoTypeId/settings'
import { Route as AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRequestsRouteImport } from './routes/_authenticated/_app/record-and-send/video-types/$videoTypeId/requests'
import { Route as AuthenticatedAppMemberPortalManageToolsIdRouteImport } from './routes/_authenticated/_app/member-portal/manage/tools.$id'
import { Route as AuthenticatedAppMemberPortalManageSuppliersIdRouteImport } from './routes/_authenticated/_app/member-portal/manage/suppliers.$id'
import { Route as AuthenticatedAppMemberPortalManageContactsIdRouteImport } from './routes/_authenticated/_app/member-portal/manage/contacts.$id'
import { Route as AuthenticatedAppMemberPortalManageCommunicationsIdRouteImport } from './routes/_authenticated/_app/member-portal/manage/communications.$id'
import { Route as AuthenticatedAppMemberPortalManageCampaignsIdRouteImport } from './routes/_authenticated/_app/member-portal/manage/campaigns.$id'
import { Route as AuthenticatedAppMemberPortalManageBrandingIdRouteImport } from './routes/_authenticated/_app/member-portal/manage/branding.$id'
import { Route as AuthenticatedAppMemberPortalManageAgreementsIdRouteImport } from './routes/_authenticated/_app/member-portal/manage/agreements.$id'
import { Route as AuthenticatedAppMemberPortalCampaignsByIdIdRouteImport } from './routes/_authenticated/_app/member-portal/campaigns.by-id.$id'
import { Route as AuthenticatedAppInspectionInspectionsInspectionIdProgressRouteImport } from './routes/_authenticated/_app/inspection/inspections/$inspectionId/progress'
import { Route as AuthenticatedAppInspectionInspectionsInspectionIdEvidenceRouteImport } from './routes/_authenticated/_app/inspection/inspections/$inspectionId/evidence'
import { Route as AuthenticatedAppInspectionInspectionsInspectionIdCapturesRouteImport } from './routes/_authenticated/_app/inspection/inspections/$inspectionId/captures'
import { Route as AuthenticatedAppInspectionInspectionsInspectionIdCaptureRouteImport } from './routes/_authenticated/_app/inspection/inspections/$inspectionId/capture'
import { Route as AuthenticatedAppCrmSettingsPipelinesPipelineIdRouteImport } from './routes/_authenticated/_app/crm/settings/pipelines/$pipelineId'
import { Route as AuthenticatedAppChainCoursesCourseIdManageRouteImport } from './routes/_authenticated/_app/chain/courses/$courseId.manage'
import { Route as AuthenticatedAppSettingsAuditTimelineTargetTypeTargetIdRouteImport } from './routes/_authenticated/_app/settings/audit/timeline.$targetType.$targetId'
import { Route as AuthenticatedAppCrmDealsDealIdOffersVersionIdRouteImport } from './routes/_authenticated/_app/crm/deals/$dealId_.offers.$versionId'
import { Route as AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdIndexRouteImport } from './routes/_authenticated/_app/chain/companies/$memberId/inspections/$inspectionId/index'
import { Route as AuthenticatedAppMemberPortalManageCommunicationsIdResponsesCompanyIdRouteImport } from './routes/_authenticated/_app/member-portal/manage/communications.$id_.responses.$companyId'
import { Route as AuthenticatedAppCrmDealsDealIdOffersVersionIdEditRouteImport } from './routes/_authenticated/_app/crm/deals/$dealId_.offers.$versionId_.edit'
import { Route as AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdProgressRouteImport } from './routes/_authenticated/_app/chain/companies/$memberId/inspections/$inspectionId/progress'

const UpgradesRoute = UpgradesRouteImport.update({
  id: '/upgrades',
  path: '/upgrades',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const MeetingEndRoute = MeetingEndRouteImport.update({
  id: '/meeting-end',
  path: '/meeting-end',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarCallbackRoute = CalendarCallbackRouteImport.update({
  id: '/calendar-callback',
  path: '/calendar-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationTokenRoute = AcceptInvitationTokenRouteImport.update({
  id: '/accept-invitation-token',
  path: '/accept-invitation-token',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypeRouteRoute = PrototypeRouteRouteImport.update({
  id: '/prototype',
  path: '/prototype',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerRouteRoute = CustomerRouteRouteImport.update({
  id: '/customer',
  path: '/customer',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthRouteRoute = OauthRouteRouteImport.update({
  id: '/_oauth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypeIndexRoute = PrototypeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrototypeRouteRoute,
} as any)
const ItxframeIndexRoute = ItxframeIndexRouteImport.update({
  id: '/itxframe/',
  path: '/itxframe/',
  getParentRoute: () => rootRouteImport,
} as any)
const VideoPublicIdRoute = VideoPublicIdRouteImport.update({
  id: '/video/$publicId',
  path: '/video/$publicId',
  getParentRoute: () => rootRouteImport,
} as any)
const VSecretRoute = VSecretRouteImport.update({
  id: '/v/$secret',
  path: '/v/$secret',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsubscribeEmailEmailRoute = UnsubscribeEmailEmailRouteImport.update({
  id: '/unsubscribe-email/$email',
  path: '/unsubscribe-email/$email',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordingShareRoute = RecordingShareRouteImport.update({
  id: '/recording/share',
  path: '/recording/share',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordMeetingIdRoute = RecordMeetingIdRouteImport.update({
  id: '/record/$meetingId',
  path: '/record/$meetingId',
  getParentRoute: () => rootRouteImport,
} as any)
const OfferTokenRoute = OfferTokenRouteImport.update({
  id: '/offer/$token',
  path: '/offer/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthErrorRoute = OauthErrorRouteImport.update({
  id: '/oauth/error',
  path: '/oauth/error',
  getParentRoute: () => rootRouteImport,
} as any)
const MeetingSummaryTokenRoute = MeetingSummaryTokenRouteImport.update({
  id: '/meeting-summary/$token',
  path: '/meeting-summary/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinMeetingIdRoute = JoinMeetingIdRouteImport.update({
  id: '/join/$meetingId',
  path: '/join/$meetingId',
  getParentRoute: () => rootRouteImport,
} as any)
const FormsSlugRoute = FormsSlugRouteImport.update({
  id: '/forms/$slug',
  path: '/forms/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerResetPasswordRoute = CustomerResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => CustomerRouteRoute,
} as any)
const CustomerLoginRoute = CustomerLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => CustomerRouteRoute,
} as any)
const CustomerForgotPasswordRoute = CustomerForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => CustomerRouteRoute,
} as any)
const CancelBookingSlugRoute = CancelBookingSlugRouteImport.update({
  id: '/cancel-booking/$slug',
  path: '/cancel-booking/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const BookMeetingSlugRoute = BookMeetingSlugRouteImport.update({
  id: '/book-meeting/$slug',
  path: '/book-meeting/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedPracticeCallRoute =
  AuthenticatedPracticeCallRouteImport.update({
    id: '/practice-call',
    path: '/practice-call',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLinkAccountRoute =
  AuthenticatedLinkAccountRouteImport.update({
    id: '/link-account',
    path: '/link-account',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCreateCompanyRoute =
  AuthenticatedCreateCompanyRouteImport.update({
    id: '/create-company',
    path: '/create-company',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedConnectedCompaniesRoute =
  AuthenticatedConnectedCompaniesRouteImport.update({
    id: '/connected-companies',
    path: '/connected-companies',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const DotwellKnownChangePasswordRoute =
  DotwellKnownChangePasswordRouteImport.update({
    id: '/.well-known/change-password',
    path: '/.well-known/change-password',
    getParentRoute: () => rootRouteImport,
  } as any)
const CustomerCustomerAuthenticatedRouteRoute =
  CustomerCustomerAuthenticatedRouteRouteImport.update({
    id: '/_customer-authenticated',
    getParentRoute: () => CustomerRouteRoute,
  } as any)
const AuthenticatedSuperAdminRouteRoute =
  AuthenticatedSuperAdminRouteRouteImport.update({
    id: '/super-admin',
    path: '/super-admin',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAppRouteRoute = AuthenticatedAppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSuperAdminIndexRoute =
  AuthenticatedSuperAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const PrototypeSlugScreenRoute = PrototypeSlugScreenRouteImport.update({
  id: '/$slug/$screen',
  path: '/$slug/$screen',
  getParentRoute: () => PrototypeRouteRoute,
} as any)
const FormsAdditionalTokenRoute = FormsAdditionalTokenRouteImport.update({
  id: '/forms/additional/$token',
  path: '/forms/additional/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerCustomerAuthenticatedProfileRoute =
  CustomerCustomerAuthenticatedProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => CustomerCustomerAuthenticatedRouteRoute,
  } as any)
const CustomerCustomerAuthenticatedChangePasswordRoute =
  CustomerCustomerAuthenticatedChangePasswordRouteImport.update({
    id: '/change-password',
    path: '/change-password',
    getParentRoute: () => CustomerCustomerAuthenticatedRouteRoute,
  } as any)
const OauthOauthSelectCompanyRoute = OauthOauthSelectCompanyRouteImport.update({
  id: '/oauth/select-company',
  path: '/oauth/select-company',
  getParentRoute: () => OauthRouteRoute,
} as any)
const OauthOauthResumeRoute = OauthOauthResumeRouteImport.update({
  id: '/oauth/resume',
  path: '/oauth/resume',
  getParentRoute: () => OauthRouteRoute,
} as any)
const OauthOauthConsentRoute = OauthOauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => OauthRouteRoute,
} as any)
const AuthenticatedSuperAdminUnsubscribeListRoute =
  AuthenticatedSuperAdminUnsubscribeListRouteImport.update({
    id: '/unsubscribe-list',
    path: '/unsubscribe-list',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminTranscriptionMonitorRoute =
  AuthenticatedSuperAdminTranscriptionMonitorRouteImport.update({
    id: '/transcription-monitor',
    path: '/transcription-monitor',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminSuppressionListRoute =
  AuthenticatedSuperAdminSuppressionListRouteImport.update({
    id: '/suppression-list',
    path: '/suppression-list',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminSmsLogsRoute =
  AuthenticatedSuperAdminSmsLogsRouteImport.update({
    id: '/sms-logs',
    path: '/sms-logs',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminRecordAndSendRoute =
  AuthenticatedSuperAdminRecordAndSendRouteImport.update({
    id: '/record-and-send',
    path: '/record-and-send',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminMobileAdoptionRoute =
  AuthenticatedSuperAdminMobileAdoptionRouteImport.update({
    id: '/mobile-adoption',
    path: '/mobile-adoption',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminMcpAdoptionRoute =
  AuthenticatedSuperAdminMcpAdoptionRouteImport.update({
    id: '/mcp-adoption',
    path: '/mcp-adoption',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminMcpActivityRoute =
  AuthenticatedSuperAdminMcpActivityRouteImport.update({
    id: '/mcp-activity',
    path: '/mcp-activity',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminInspectionLibraryRoute =
  AuthenticatedSuperAdminInspectionLibraryRouteImport.update({
    id: '/inspection-library',
    path: '/inspection-library',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminImpersonationLogsRoute =
  AuthenticatedSuperAdminImpersonationLogsRouteImport.update({
    id: '/impersonation-logs',
    path: '/impersonation-logs',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminFeedbackRoute =
  AuthenticatedSuperAdminFeedbackRouteImport.update({
    id: '/feedback',
    path: '/feedback',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminEmailLogsRoute =
  AuthenticatedSuperAdminEmailLogsRouteImport.update({
    id: '/email-logs',
    path: '/email-logs',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminConnectedAppsRoute =
  AuthenticatedSuperAdminConnectedAppsRouteImport.update({
    id: '/connected-apps',
    path: '/connected-apps',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminCompanyActivityRoute =
  AuthenticatedSuperAdminCompanyActivityRouteImport.update({
    id: '/company-activity',
    path: '/company-activity',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminAuditRoute =
  AuthenticatedSuperAdminAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminAdminsRoute =
  AuthenticatedSuperAdminAdminsRouteImport.update({
    id: '/admins',
    path: '/admins',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedAppTeamLearningRoute =
  AuthenticatedAppTeamLearningRouteImport.update({
    id: '/team-learning',
    path: '/team-learning',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppResourcesRoute =
  AuthenticatedAppResourcesRouteImport.update({
    id: '/resources',
    path: '/resources',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppRecordingRoute =
  AuthenticatedAppRecordingRouteImport.update({
    id: '/recording',
    path: '/recording',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppMeetingsRoute =
  AuthenticatedAppMeetingsRouteImport.update({
    id: '/meetings',
    path: '/meetings',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppGettingStartedRoute =
  AuthenticatedAppGettingStartedRouteImport.update({
    id: '/getting-started',
    path: '/getting-started',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppDashboardRoute =
  AuthenticatedAppDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppChecklistRoute =
  AuthenticatedAppChecklistRouteImport.update({
    id: '/checklist',
    path: '/checklist',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppCalendarRoute =
  AuthenticatedAppCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppStaffingRouteRoute =
  AuthenticatedAppStaffingRouteRouteImport.update({
    id: '/staffing',
    path: '/staffing',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppSettingsRouteRoute =
  AuthenticatedAppSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppOrdersRouteRoute =
  AuthenticatedAppOrdersRouteRouteImport.update({
    id: '/orders',
    path: '/orders',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalRouteRoute =
  AuthenticatedAppMemberPortalRouteRouteImport.update({
    id: '/member-portal',
    path: '/member-portal',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppInvoicingRouteRoute =
  AuthenticatedAppInvoicingRouteRouteImport.update({
    id: '/invoicing',
    path: '/invoicing',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppInspectionRouteRoute =
  AuthenticatedAppInspectionRouteRouteImport.update({
    id: '/inspection',
    path: '/inspection',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppFormsRouteRoute =
  AuthenticatedAppFormsRouteRouteImport.update({
    id: '/forms',
    path: '/forms',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppCrmRouteRoute =
  AuthenticatedAppCrmRouteRouteImport.update({
    id: '/crm',
    path: '/crm',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppChainRouteRoute =
  AuthenticatedAppChainRouteRouteImport.update({
    id: '/chain',
    path: '/chain',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppBookingsRouteRoute =
  AuthenticatedAppBookingsRouteRouteImport.update({
    id: '/bookings',
    path: '/bookings',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const CustomerCustomerAuthenticatedOrdersIndexRoute =
  CustomerCustomerAuthenticatedOrdersIndexRouteImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () => CustomerCustomerAuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminUsersIndexRoute =
  AuthenticatedSuperAdminUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminMeetingTelemetryIndexRoute =
  AuthenticatedSuperAdminMeetingTelemetryIndexRouteImport.update({
    id: '/meeting-telemetry/',
    path: '/meeting-telemetry/',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminLoginSecurityIndexRoute =
  AuthenticatedSuperAdminLoginSecurityIndexRouteImport.update({
    id: '/login-security/',
    path: '/login-security/',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminIndustryPresetsIndexRoute =
  AuthenticatedSuperAdminIndustryPresetsIndexRouteImport.update({
    id: '/industry-presets/',
    path: '/industry-presets/',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminCompaniesIndexRoute =
  AuthenticatedSuperAdminCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminChainsIndexRoute =
  AuthenticatedSuperAdminChainsIndexRouteImport.update({
    id: '/chains/',
    path: '/chains/',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminAiOpsIndexRoute =
  AuthenticatedSuperAdminAiOpsIndexRouteImport.update({
    id: '/ai-ops/',
    path: '/ai-ops/',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedAppStaffingIndexRoute =
  AuthenticatedAppStaffingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppStaffingRouteRoute,
  } as any)
const AuthenticatedAppSettingsIndexRoute =
  AuthenticatedAppSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppRecordAndSendIndexRoute =
  AuthenticatedAppRecordAndSendIndexRouteImport.update({
    id: '/record-and-send/',
    path: '/record-and-send/',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppOrdersIndexRoute =
  AuthenticatedAppOrdersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppOrdersRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalIndexRoute =
  AuthenticatedAppMemberPortalIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppMemberPortalRouteRoute,
  } as any)
const AuthenticatedAppInvoicingIndexRoute =
  AuthenticatedAppInvoicingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppInvoicingRouteRoute,
  } as any)
const AuthenticatedAppInspectionIndexRoute =
  AuthenticatedAppInspectionIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppInspectionRouteRoute,
  } as any)
const AuthenticatedAppFormsIndexRoute =
  AuthenticatedAppFormsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppFormsRouteRoute,
  } as any)
const AuthenticatedAppCrmIndexRoute =
  AuthenticatedAppCrmIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppCoursesIndexRoute =
  AuthenticatedAppCoursesIndexRouteImport.update({
    id: '/courses/',
    path: '/courses/',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppCompetenceIndexRoute =
  AuthenticatedAppCompetenceIndexRouteImport.update({
    id: '/competence/',
    path: '/competence/',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppBookingsIndexRoute =
  AuthenticatedAppBookingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppBookingsRouteRoute,
  } as any)
const CustomerCustomerAuthenticatedOrdersOrderIdRoute =
  CustomerCustomerAuthenticatedOrdersOrderIdRouteImport.update({
    id: '/orders/$orderId',
    path: '/orders/$orderId',
    getParentRoute: () => CustomerCustomerAuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminUsersUserIdRoute =
  AuthenticatedSuperAdminUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminMeetingTelemetryMeetingIdRoute =
  AuthenticatedSuperAdminMeetingTelemetryMeetingIdRouteImport.update({
    id: '/meeting-telemetry/$meetingId',
    path: '/meeting-telemetry/$meetingId',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminLoginSecuritySettingsRoute =
  AuthenticatedSuperAdminLoginSecuritySettingsRouteImport.update({
    id: '/login-security/settings',
    path: '/login-security/settings',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminIndustryPresetsNewRoute =
  AuthenticatedSuperAdminIndustryPresetsNewRouteImport.update({
    id: '/industry-presets/new',
    path: '/industry-presets/new',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminIndustryPresetsIdRoute =
  AuthenticatedSuperAdminIndustryPresetsIdRouteImport.update({
    id: '/industry-presets/$id',
    path: '/industry-presets/$id',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminCompaniesCompanyIdRoute =
  AuthenticatedSuperAdminCompaniesCompanyIdRouteImport.update({
    id: '/companies/$companyId',
    path: '/companies/$companyId',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminChainsParentCompanyIdRoute =
  AuthenticatedSuperAdminChainsParentCompanyIdRouteImport.update({
    id: '/chains/$parentCompanyId',
    path: '/chains/$parentCompanyId',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminAiOpsRunsRoute =
  AuthenticatedSuperAdminAiOpsRunsRouteImport.update({
    id: '/ai-ops/runs',
    path: '/ai-ops/runs',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedSuperAdminAiOpsCostRoute =
  AuthenticatedSuperAdminAiOpsCostRouteImport.update({
    id: '/ai-ops/cost',
    path: '/ai-ops/cost',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedAppStaffingSkillsRoute =
  AuthenticatedAppStaffingSkillsRouteImport.update({
    id: '/skills',
    path: '/skills',
    getParentRoute: () => AuthenticatedAppStaffingRouteRoute,
  } as any)
const AuthenticatedAppStaffingSkillLevelsRoute =
  AuthenticatedAppStaffingSkillLevelsRouteImport.update({
    id: '/skill-levels',
    path: '/skill-levels',
    getParentRoute: () => AuthenticatedAppStaffingRouteRoute,
  } as any)
const AuthenticatedAppStaffingPendingApprovalsRoute =
  AuthenticatedAppStaffingPendingApprovalsRouteImport.update({
    id: '/pending-approvals',
    path: '/pending-approvals',
    getParentRoute: () => AuthenticatedAppStaffingRouteRoute,
  } as any)
const AuthenticatedAppStaffingMyPostingsRoute =
  AuthenticatedAppStaffingMyPostingsRouteImport.update({
    id: '/my-postings',
    path: '/my-postings',
    getParentRoute: () => AuthenticatedAppStaffingRouteRoute,
  } as any)
const AuthenticatedAppStaffingMyInterestsRoute =
  AuthenticatedAppStaffingMyInterestsRouteImport.update({
    id: '/my-interests',
    path: '/my-interests',
    getParentRoute: () => AuthenticatedAppStaffingRouteRoute,
  } as any)
const AuthenticatedAppStaffingCategoriesRoute =
  AuthenticatedAppStaffingCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => AuthenticatedAppStaffingRouteRoute,
  } as any)
const AuthenticatedAppSettingsWhiteLabelingRoute =
  AuthenticatedAppSettingsWhiteLabelingRouteImport.update({
    id: '/white-labeling',
    path: '/white-labeling',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsUsageRoute =
  AuthenticatedAppSettingsUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsServiceTypesRoute =
  AuthenticatedAppSettingsServiceTypesRouteImport.update({
    id: '/service-types',
    path: '/service-types',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsServiceAreaRoute =
  AuthenticatedAppSettingsServiceAreaRouteImport.update({
    id: '/service-area',
    path: '/service-area',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsProfileRoute =
  AuthenticatedAppSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsOrderSettingsRoute =
  AuthenticatedAppSettingsOrderSettingsRouteImport.update({
    id: '/order-settings',
    path: '/order-settings',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsNotificationsRoute =
  AuthenticatedAppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsMembersRoute =
  AuthenticatedAppSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsConnectedAppsRoute =
  AuthenticatedAppSettingsConnectedAppsRouteImport.update({
    id: '/connected-apps',
    path: '/connected-apps',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsCompanyRoute =
  AuthenticatedAppSettingsCompanyRouteImport.update({
    id: '/company',
    path: '/company',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsApiKeysRoute =
  AuthenticatedAppSettingsApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsAiSettingsRoute =
  AuthenticatedAppSettingsAiSettingsRouteImport.update({
    id: '/ai-settings',
    path: '/ai-settings',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsAccessRoute =
  AuthenticatedAppSettingsAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppOrdersReportsRoute =
  AuthenticatedAppOrdersReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthenticatedAppOrdersRouteRoute,
  } as any)
const AuthenticatedAppOrdersOrderIdRoute =
  AuthenticatedAppOrdersOrderIdRouteImport.update({
    id: '/$orderId',
    path: '/$orderId',
    getParentRoute: () => AuthenticatedAppOrdersRouteRoute,
  } as any)
const AuthenticatedAppMyLearningRoute =
  AuthenticatedAppMyLearningRouteImport.update({
    id: '/my/learning',
    path: '/my/learning',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalToolsRoute =
  AuthenticatedAppMemberPortalToolsRouteImport.update({
    id: '/tools',
    path: '/tools',
    getParentRoute: () => AuthenticatedAppMemberPortalRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalSuppliersRoute =
  AuthenticatedAppMemberPortalSuppliersRouteImport.update({
    id: '/suppliers',
    path: '/suppliers',
    getParentRoute: () => AuthenticatedAppMemberPortalRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalOverviewRoute =
  AuthenticatedAppMemberPortalOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthenticatedAppMemberPortalRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalContactsRoute =
  AuthenticatedAppMemberPortalContactsRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => AuthenticatedAppMemberPortalRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalCommunicationsRoute =
  AuthenticatedAppMemberPortalCommunicationsRouteImport.update({
    id: '/communications',
    path: '/communications',
    getParentRoute: () => AuthenticatedAppMemberPortalRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalCampaignsRoute =
  AuthenticatedAppMemberPortalCampaignsRouteImport.update({
    id: '/campaigns',
    path: '/campaigns',
    getParentRoute: () => AuthenticatedAppMemberPortalRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalBrandingRoute =
  AuthenticatedAppMemberPortalBrandingRouteImport.update({
    id: '/branding',
    path: '/branding',
    getParentRoute: () => AuthenticatedAppMemberPortalRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalAgreementsRoute =
  AuthenticatedAppMemberPortalAgreementsRouteImport.update({
    id: '/agreements',
    path: '/agreements',
    getParentRoute: () => AuthenticatedAppMemberPortalRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalAboutRoute =
  AuthenticatedAppMemberPortalAboutRouteImport.update({
    id: '/about',
    path: '/about',
    getParentRoute: () => AuthenticatedAppMemberPortalRouteRoute,
  } as any)
const AuthenticatedAppInvoicingInvoiceIdRoute =
  AuthenticatedAppInvoicingInvoiceIdRouteImport.update({
    id: '/$invoiceId',
    path: '/$invoiceId',
    getParentRoute: () => AuthenticatedAppInvoicingRouteRoute,
  } as any)
const AuthenticatedAppHistoryMeetingIDRoute =
  AuthenticatedAppHistoryMeetingIDRouteImport.update({
    id: '/history/$meetingID',
    path: '/history/$meetingID',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppCoursesCreateRoute =
  AuthenticatedAppCoursesCreateRouteImport.update({
    id: '/courses/create',
    path: '/courses/create',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppCoursesCourseIdRoute =
  AuthenticatedAppCoursesCourseIdRouteImport.update({
    id: '/courses/$courseId',
    path: '/courses/$courseId',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppCompetenceTypesRoute =
  AuthenticatedAppCompetenceTypesRouteImport.update({
    id: '/competence/types',
    path: '/competence/types',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppCompetenceMeRoute =
  AuthenticatedAppCompetenceMeRouteImport.update({
    id: '/competence/me',
    path: '/competence/me',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppCompetenceMatrixRoute =
  AuthenticatedAppCompetenceMatrixRouteImport.update({
    id: '/competence/matrix',
    path: '/competence/matrix',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppCompetenceApprovalsRoute =
  AuthenticatedAppCompetenceApprovalsRouteImport.update({
    id: '/competence/approvals',
    path: '/competence/approvals',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppChainStaffingRoute =
  AuthenticatedAppChainStaffingRouteImport.update({
    id: '/staffing',
    path: '/staffing',
    getParentRoute: () => AuthenticatedAppChainRouteRoute,
  } as any)
const AuthenticatedAppChainResourcesRoute =
  AuthenticatedAppChainResourcesRouteImport.update({
    id: '/resources',
    path: '/resources',
    getParentRoute: () => AuthenticatedAppChainRouteRoute,
  } as any)
const AuthenticatedAppChainQuickLinksRoute =
  AuthenticatedAppChainQuickLinksRouteImport.update({
    id: '/quick-links',
    path: '/quick-links',
    getParentRoute: () => AuthenticatedAppChainRouteRoute,
  } as any)
const AuthenticatedAppChainOrderPipelineRoute =
  AuthenticatedAppChainOrderPipelineRouteImport.update({
    id: '/order-pipeline',
    path: '/order-pipeline',
    getParentRoute: () => AuthenticatedAppChainRouteRoute,
  } as any)
const AuthenticatedAppChainMyEndorsementRoute =
  AuthenticatedAppChainMyEndorsementRouteImport.update({
    id: '/my-endorsement',
    path: '/my-endorsement',
    getParentRoute: () => AuthenticatedAppChainRouteRoute,
  } as any)
const AuthenticatedAppChainMembersRoute =
  AuthenticatedAppChainMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthenticatedAppChainRouteRoute,
  } as any)
const AuthenticatedAppChainMasterCatalogRoute =
  AuthenticatedAppChainMasterCatalogRouteImport.update({
    id: '/master-catalog',
    path: '/master-catalog',
    getParentRoute: () => AuthenticatedAppChainRouteRoute,
  } as any)
const AuthenticatedAppChainLearningRoute =
  AuthenticatedAppChainLearningRouteImport.update({
    id: '/learning',
    path: '/learning',
    getParentRoute: () => AuthenticatedAppChainRouteRoute,
  } as any)
const AuthenticatedAppChainEndorsementRoute =
  AuthenticatedAppChainEndorsementRouteImport.update({
    id: '/endorsement',
    path: '/endorsement',
    getParentRoute: () => AuthenticatedAppChainRouteRoute,
  } as any)
const AuthenticatedAppChainCoverageRoute =
  AuthenticatedAppChainCoverageRouteImport.update({
    id: '/coverage',
    path: '/coverage',
    getParentRoute: () => AuthenticatedAppChainRouteRoute,
  } as any)
const AuthenticatedAppChainConfigPushesRoute =
  AuthenticatedAppChainConfigPushesRouteImport.update({
    id: '/config-pushes',
    path: '/config-pushes',
    getParentRoute: () => AuthenticatedAppChainRouteRoute,
  } as any)
const AuthenticatedAppChainCompetenceRoute =
  AuthenticatedAppChainCompetenceRouteImport.update({
    id: '/competence',
    path: '/competence',
    getParentRoute: () => AuthenticatedAppChainRouteRoute,
  } as any)
const AuthenticatedAppChainAnalyticsRoute =
  AuthenticatedAppChainAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthenticatedAppChainRouteRoute,
  } as any)
const AuthenticatedAppBookingsTrackingRoute =
  AuthenticatedAppBookingsTrackingRouteImport.update({
    id: '/tracking',
    path: '/tracking',
    getParentRoute: () => AuthenticatedAppBookingsRouteRoute,
  } as any)
const AuthenticatedAppBookingsServicesRoute =
  AuthenticatedAppBookingsServicesRouteImport.update({
    id: '/services',
    path: '/services',
    getParentRoute: () => AuthenticatedAppBookingsRouteRoute,
  } as any)
const AuthenticatedAppBookingsManageRoute =
  AuthenticatedAppBookingsManageRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => AuthenticatedAppBookingsRouteRoute,
  } as any)
const AuthenticatedAppBookingsDashboardRoute =
  AuthenticatedAppBookingsDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedAppBookingsRouteRoute,
  } as any)
const AuthenticatedAppBookingsCustomizeRoute =
  AuthenticatedAppBookingsCustomizeRouteImport.update({
    id: '/customize',
    path: '/customize',
    getParentRoute: () => AuthenticatedAppBookingsRouteRoute,
  } as any)
const AuthenticatedAppBookingsBlackoutDatesRoute =
  AuthenticatedAppBookingsBlackoutDatesRouteImport.update({
    id: '/blackout-dates',
    path: '/blackout-dates',
    getParentRoute: () => AuthenticatedAppBookingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsBillingRouteRoute =
  AuthenticatedAppSettingsBillingRouteRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsAuditRouteRoute =
  AuthenticatedAppSettingsAuditRouteRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalManageRouteRoute =
  AuthenticatedAppMemberPortalManageRouteRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => AuthenticatedAppMemberPortalRouteRoute,
  } as any)
const AuthenticatedAppCrmSettingsRouteRoute =
  AuthenticatedAppCrmSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppSettingsRolesIndexRoute =
  AuthenticatedAppSettingsRolesIndexRouteImport.update({
    id: '/roles/',
    path: '/roles/',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsMeetingIndexRoute =
  AuthenticatedAppSettingsMeetingIndexRouteImport.update({
    id: '/meeting/',
    path: '/meeting/',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsBillingIndexRoute =
  AuthenticatedAppSettingsBillingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppSettingsBillingRouteRoute,
  } as any)
const AuthenticatedAppSettingsAuditIndexRoute =
  AuthenticatedAppSettingsAuditIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppSettingsAuditRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalManageIndexRoute =
  AuthenticatedAppMemberPortalManageIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppMemberPortalManageRouteRoute,
  } as any)
const AuthenticatedAppInspectionUpcomingIndexRoute =
  AuthenticatedAppInspectionUpcomingIndexRouteImport.update({
    id: '/upcoming/',
    path: '/upcoming/',
    getParentRoute: () => AuthenticatedAppInspectionRouteRoute,
  } as any)
const AuthenticatedAppInspectionTemplatesIndexRoute =
  AuthenticatedAppInspectionTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AuthenticatedAppInspectionRouteRoute,
  } as any)
const AuthenticatedAppInspectionSitesIndexRoute =
  AuthenticatedAppInspectionSitesIndexRouteImport.update({
    id: '/sites/',
    path: '/sites/',
    getParentRoute: () => AuthenticatedAppInspectionRouteRoute,
  } as any)
const AuthenticatedAppInspectionLibraryIndexRoute =
  AuthenticatedAppInspectionLibraryIndexRouteImport.update({
    id: '/library/',
    path: '/library/',
    getParentRoute: () => AuthenticatedAppInspectionRouteRoute,
  } as any)
const AuthenticatedAppCrmSettingsIndexRoute =
  AuthenticatedAppCrmSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppCrmSettingsRouteRoute,
  } as any)
const AuthenticatedAppCrmReportingIndexRoute =
  AuthenticatedAppCrmReportingIndexRouteImport.update({
    id: '/reporting/',
    path: '/reporting/',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppCrmPipelineIndexRoute =
  AuthenticatedAppCrmPipelineIndexRouteImport.update({
    id: '/pipeline/',
    path: '/pipeline/',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppCrmMyWorkIndexRoute =
  AuthenticatedAppCrmMyWorkIndexRouteImport.update({
    id: '/my-work/',
    path: '/my-work/',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppCrmLeadsIndexRoute =
  AuthenticatedAppCrmLeadsIndexRouteImport.update({
    id: '/leads/',
    path: '/leads/',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppCrmDuplicatesIndexRoute =
  AuthenticatedAppCrmDuplicatesIndexRouteImport.update({
    id: '/duplicates/',
    path: '/duplicates/',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppCrmDealsIndexRoute =
  AuthenticatedAppCrmDealsIndexRouteImport.update({
    id: '/deals/',
    path: '/deals/',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppCrmContactsIndexRoute =
  AuthenticatedAppCrmContactsIndexRouteImport.update({
    id: '/contacts/',
    path: '/contacts/',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppCrmCompaniesIndexRoute =
  AuthenticatedAppCrmCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppCrmCatalogIndexRoute =
  AuthenticatedAppCrmCatalogIndexRouteImport.update({
    id: '/catalog/',
    path: '/catalog/',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppChainCoursesIndexRoute =
  AuthenticatedAppChainCoursesIndexRouteImport.update({
    id: '/courses/',
    path: '/courses/',
    getParentRoute: () => AuthenticatedAppChainRouteRoute,
  } as any)
const AuthenticatedAppChainAnnouncementsIndexRoute =
  AuthenticatedAppChainAnnouncementsIndexRouteImport.update({
    id: '/announcements/',
    path: '/announcements/',
    getParentRoute: () => AuthenticatedAppChainRouteRoute,
  } as any)
const AuthenticatedSuperAdminCompaniesCompanyIdRolesRoute =
  AuthenticatedSuperAdminCompaniesCompanyIdRolesRouteImport.update({
    id: '/companies/$companyId_/roles',
    path: '/companies/$companyId/roles',
    getParentRoute: () => AuthenticatedSuperAdminRouteRoute,
  } as any)
const AuthenticatedAppStaffingPostingsNewRoute =
  AuthenticatedAppStaffingPostingsNewRouteImport.update({
    id: '/postings/new',
    path: '/postings/new',
    getParentRoute: () => AuthenticatedAppStaffingRouteRoute,
  } as any)
const AuthenticatedAppStaffingPostingsIdRoute =
  AuthenticatedAppStaffingPostingsIdRouteImport.update({
    id: '/postings/$id',
    path: '/postings/$id',
    getParentRoute: () => AuthenticatedAppStaffingRouteRoute,
  } as any)
const AuthenticatedAppSettingsRolesNewRoute =
  AuthenticatedAppSettingsRolesNewRouteImport.update({
    id: '/roles/new',
    path: '/roles/new',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsRolesRoleIdRoute =
  AuthenticatedAppSettingsRolesRoleIdRouteImport.update({
    id: '/roles/$roleId',
    path: '/roles/$roleId',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsOrdersPipelineRoute =
  AuthenticatedAppSettingsOrdersPipelineRouteImport.update({
    id: '/orders/pipeline',
    path: '/orders/pipeline',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsMeetingRecordingRoute =
  AuthenticatedAppSettingsMeetingRecordingRouteImport.update({
    id: '/meeting/recording',
    path: '/meeting/recording',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsMeetingDefaultsRoute =
  AuthenticatedAppSettingsMeetingDefaultsRouteImport.update({
    id: '/meeting/defaults',
    path: '/meeting/defaults',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsMeetingBackgroundRoute =
  AuthenticatedAppSettingsMeetingBackgroundRouteImport.update({
    id: '/meeting/background',
    path: '/meeting/background',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsInvoicingAccountingRoute =
  AuthenticatedAppSettingsInvoicingAccountingRouteImport.update({
    id: '/invoicing/accounting',
    path: '/invoicing/accounting',
    getParentRoute: () => AuthenticatedAppSettingsRouteRoute,
  } as any)
const AuthenticatedAppSettingsBillingPaymentsRoute =
  AuthenticatedAppSettingsBillingPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => AuthenticatedAppSettingsBillingRouteRoute,
  } as any)
const AuthenticatedAppSettingsBillingAddonsRoute =
  AuthenticatedAppSettingsBillingAddonsRouteImport.update({
    id: '/addons',
    path: '/addons',
    getParentRoute: () => AuthenticatedAppSettingsBillingRouteRoute,
  } as any)
const AuthenticatedAppRecordAndSendVideoTypesNewRoute =
  AuthenticatedAppRecordAndSendVideoTypesNewRouteImport.update({
    id: '/record-and-send/video-types/new',
    path: '/record-and-send/video-types/new',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppRecordAndSendSubmissionsSubmissionIdRoute =
  AuthenticatedAppRecordAndSendSubmissionsSubmissionIdRouteImport.update({
    id: '/record-and-send/submissions/$submissionId',
    path: '/record-and-send/submissions/$submissionId',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalToolsIdRoute =
  AuthenticatedAppMemberPortalToolsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedAppMemberPortalToolsRoute,
  } as any)
const AuthenticatedAppMemberPortalSuppliersIdRoute =
  AuthenticatedAppMemberPortalSuppliersIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedAppMemberPortalSuppliersRoute,
  } as any)
const AuthenticatedAppMemberPortalManageToolsRoute =
  AuthenticatedAppMemberPortalManageToolsRouteImport.update({
    id: '/tools',
    path: '/tools',
    getParentRoute: () => AuthenticatedAppMemberPortalManageRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalManageSuppliersRoute =
  AuthenticatedAppMemberPortalManageSuppliersRouteImport.update({
    id: '/suppliers',
    path: '/suppliers',
    getParentRoute: () => AuthenticatedAppMemberPortalManageRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalManageContactsRoute =
  AuthenticatedAppMemberPortalManageContactsRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => AuthenticatedAppMemberPortalManageRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalManageCommunicationsRoute =
  AuthenticatedAppMemberPortalManageCommunicationsRouteImport.update({
    id: '/communications',
    path: '/communications',
    getParentRoute: () => AuthenticatedAppMemberPortalManageRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalManageCampaignsRoute =
  AuthenticatedAppMemberPortalManageCampaignsRouteImport.update({
    id: '/campaigns',
    path: '/campaigns',
    getParentRoute: () => AuthenticatedAppMemberPortalManageRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalManageBrandingRoute =
  AuthenticatedAppMemberPortalManageBrandingRouteImport.update({
    id: '/branding',
    path: '/branding',
    getParentRoute: () => AuthenticatedAppMemberPortalManageRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalManageAgreementsRoute =
  AuthenticatedAppMemberPortalManageAgreementsRouteImport.update({
    id: '/agreements',
    path: '/agreements',
    getParentRoute: () => AuthenticatedAppMemberPortalManageRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalManageAboutRoute =
  AuthenticatedAppMemberPortalManageAboutRouteImport.update({
    id: '/about',
    path: '/about',
    getParentRoute: () => AuthenticatedAppMemberPortalManageRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalCommunicationsIdRoute =
  AuthenticatedAppMemberPortalCommunicationsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedAppMemberPortalCommunicationsRoute,
  } as any)
const AuthenticatedAppMemberPortalCampaignsSlugRoute =
  AuthenticatedAppMemberPortalCampaignsSlugRouteImport.update({
    id: '/$slug',
    path: '/$slug',
    getParentRoute: () => AuthenticatedAppMemberPortalCampaignsRoute,
  } as any)
const AuthenticatedAppMemberPortalBrandingIdRoute =
  AuthenticatedAppMemberPortalBrandingIdRouteImport.update({
    id: '/branding_/$id',
    path: '/branding/$id',
    getParentRoute: () => AuthenticatedAppMemberPortalRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalAgreementsIdRoute =
  AuthenticatedAppMemberPortalAgreementsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedAppMemberPortalAgreementsRoute,
  } as any)
const AuthenticatedAppInvoicingPrepareOrderIdRoute =
  AuthenticatedAppInvoicingPrepareOrderIdRouteImport.update({
    id: '/prepare/$orderId',
    path: '/prepare/$orderId',
    getParentRoute: () => AuthenticatedAppInvoicingRouteRoute,
  } as any)
const AuthenticatedAppInspectionTemplatesTemplateIdRoute =
  AuthenticatedAppInspectionTemplatesTemplateIdRouteImport.update({
    id: '/templates/$templateId',
    path: '/templates/$templateId',
    getParentRoute: () => AuthenticatedAppInspectionRouteRoute,
  } as any)
const AuthenticatedAppInspectionSitesSiteIdRoute =
  AuthenticatedAppInspectionSitesSiteIdRouteImport.update({
    id: '/sites/$siteId',
    path: '/sites/$siteId',
    getParentRoute: () => AuthenticatedAppInspectionRouteRoute,
  } as any)
const AuthenticatedAppFormsFormIdSubmissionsRoute =
  AuthenticatedAppFormsFormIdSubmissionsRouteImport.update({
    id: '/$formId/submissions',
    path: '/$formId/submissions',
    getParentRoute: () => AuthenticatedAppFormsRouteRoute,
  } as any)
const AuthenticatedAppFormsFormIdDesignerRoute =
  AuthenticatedAppFormsFormIdDesignerRouteImport.update({
    id: '/$formId/designer',
    path: '/$formId/designer',
    getParentRoute: () => AuthenticatedAppFormsRouteRoute,
  } as any)
const AuthenticatedAppFormsFormIdAnalyticsRoute =
  AuthenticatedAppFormsFormIdAnalyticsRouteImport.update({
    id: '/$formId/analytics',
    path: '/$formId/analytics',
    getParentRoute: () => AuthenticatedAppFormsRouteRoute,
  } as any)
const AuthenticatedAppCrmSettingsOrderPipelineRoute =
  AuthenticatedAppCrmSettingsOrderPipelineRouteImport.update({
    id: '/order-pipeline',
    path: '/order-pipeline',
    getParentRoute: () => AuthenticatedAppCrmSettingsRouteRoute,
  } as any)
const AuthenticatedAppCrmSettingsOfferDefaultsRoute =
  AuthenticatedAppCrmSettingsOfferDefaultsRouteImport.update({
    id: '/offer-defaults',
    path: '/offer-defaults',
    getParentRoute: () => AuthenticatedAppCrmSettingsRouteRoute,
  } as any)
const AuthenticatedAppCrmSettingsLostReasonsRoute =
  AuthenticatedAppCrmSettingsLostReasonsRouteImport.update({
    id: '/lost-reasons',
    path: '/lost-reasons',
    getParentRoute: () => AuthenticatedAppCrmSettingsRouteRoute,
  } as any)
const AuthenticatedAppCrmSettingsDealFieldsRoute =
  AuthenticatedAppCrmSettingsDealFieldsRouteImport.update({
    id: '/deal-fields',
    path: '/deal-fields',
    getParentRoute: () => AuthenticatedAppCrmSettingsRouteRoute,
  } as any)
const AuthenticatedAppCrmSettingsContactFieldsRoute =
  AuthenticatedAppCrmSettingsContactFieldsRouteImport.update({
    id: '/contact-fields',
    path: '/contact-fields',
    getParentRoute: () => AuthenticatedAppCrmSettingsRouteRoute,
  } as any)
const AuthenticatedAppCrmSettingsCompanyFieldsRoute =
  AuthenticatedAppCrmSettingsCompanyFieldsRouteImport.update({
    id: '/company-fields',
    path: '/company-fields',
    getParentRoute: () => AuthenticatedAppCrmSettingsRouteRoute,
  } as any)
const AuthenticatedAppCrmPipelinePipelineIdRoute =
  AuthenticatedAppCrmPipelinePipelineIdRouteImport.update({
    id: '/pipeline/$pipelineId',
    path: '/pipeline/$pipelineId',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppCrmLeadsLeadIdRoute =
  AuthenticatedAppCrmLeadsLeadIdRouteImport.update({
    id: '/leads/$leadId',
    path: '/leads/$leadId',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppCrmDealsDealIdRoute =
  AuthenticatedAppCrmDealsDealIdRouteImport.update({
    id: '/deals/$dealId',
    path: '/deals/$dealId',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppCrmContactsContactIdRoute =
  AuthenticatedAppCrmContactsContactIdRouteImport.update({
    id: '/contacts/$contactId',
    path: '/contacts/$contactId',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppCrmCompaniesIdRoute =
  AuthenticatedAppCrmCompaniesIdRouteImport.update({
    id: '/companies/$id',
    path: '/companies/$id',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppCrmChainPipelineRoute =
  AuthenticatedAppCrmChainPipelineRouteImport.update({
    id: '/chain/pipeline',
    path: '/chain/pipeline',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppCrmChainParentIncomingRoute =
  AuthenticatedAppCrmChainParentIncomingRouteImport.update({
    id: '/chain/parent-incoming',
    path: '/chain/parent-incoming',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppCrmChainMembersRoute =
  AuthenticatedAppCrmChainMembersRouteImport.update({
    id: '/chain/members',
    path: '/chain/members',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppCrmChainDistributionRoute =
  AuthenticatedAppCrmChainDistributionRouteImport.update({
    id: '/chain/distribution',
    path: '/chain/distribution',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppCoursesCourseIdEditRoute =
  AuthenticatedAppCoursesCourseIdEditRouteImport.update({
    id: '/courses/$courseId_/edit',
    path: '/courses/$courseId/edit',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppCompetenceUserUserIdRoute =
  AuthenticatedAppCompetenceUserUserIdRouteImport.update({
    id: '/competence/user/$userId',
    path: '/competence/user/$userId',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppChainAnnouncementsAnnouncementIdRoute =
  AuthenticatedAppChainAnnouncementsAnnouncementIdRouteImport.update({
    id: '/announcements/$announcementId',
    path: '/announcements/$announcementId',
    getParentRoute: () => AuthenticatedAppChainRouteRoute,
  } as any)
const AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRoute =
  AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRouteImport.update({
    id: '/record-and-send/video-types/$videoTypeId',
    path: '/record-and-send/video-types/$videoTypeId',
    getParentRoute: () => AuthenticatedAppRouteRoute,
  } as any)
const AuthenticatedAppInspectionInspectionsInspectionIdRouteRoute =
  AuthenticatedAppInspectionInspectionsInspectionIdRouteRouteImport.update({
    id: '/inspections/$inspectionId',
    path: '/inspections/$inspectionId',
    getParentRoute: () => AuthenticatedAppInspectionRouteRoute,
  } as any)
const AuthenticatedAppChainCompaniesMemberIdRouteRoute =
  AuthenticatedAppChainCompaniesMemberIdRouteRouteImport.update({
    id: '/companies/$memberId',
    path: '/companies/$memberId',
    getParentRoute: () => AuthenticatedAppChainRouteRoute,
  } as any)
const AuthenticatedAppSettingsBillingPricingIndexRoute =
  AuthenticatedAppSettingsBillingPricingIndexRouteImport.update({
    id: '/pricing/',
    path: '/pricing/',
    getParentRoute: () => AuthenticatedAppSettingsBillingRouteRoute,
  } as any)
const AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdIndexRoute =
  AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRoute,
  } as any)
const AuthenticatedAppInspectionInspectionsInspectionIdIndexRoute =
  AuthenticatedAppInspectionInspectionsInspectionIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedAppInspectionInspectionsInspectionIdRouteRoute,
  } as any)
const AuthenticatedAppCrmSettingsPipelinesIndexRoute =
  AuthenticatedAppCrmSettingsPipelinesIndexRouteImport.update({
    id: '/pipelines/',
    path: '/pipelines/',
    getParentRoute: () => AuthenticatedAppCrmSettingsRouteRoute,
  } as any)
const AuthenticatedAppChainCompaniesMemberIdIndexRoute =
  AuthenticatedAppChainCompaniesMemberIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppChainCompaniesMemberIdRouteRoute,
  } as any)
const AuthenticatedAppStaffingPostingsIdEditRoute =
  AuthenticatedAppStaffingPostingsIdEditRouteImport.update({
    id: '/postings/$id_/edit',
    path: '/postings/$id/edit',
    getParentRoute: () => AuthenticatedAppStaffingRouteRoute,
  } as any)
const AuthenticatedAppSettingsBillingPricingCheckoutRoute =
  AuthenticatedAppSettingsBillingPricingCheckoutRouteImport.update({
    id: '/pricing/checkout',
    path: '/pricing/checkout',
    getParentRoute: () => AuthenticatedAppSettingsBillingRouteRoute,
  } as any)
const AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdVideosRoute =
  AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdVideosRouteImport.update({
    id: '/videos',
    path: '/videos',
    getParentRoute: () =>
      AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRoute,
  } as any)
const AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdSettingsRoute =
  AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () =>
      AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRoute,
  } as any)
const AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRequestsRoute =
  AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRequestsRouteImport.update({
    id: '/requests',
    path: '/requests',
    getParentRoute: () =>
      AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRoute,
  } as any)
const AuthenticatedAppMemberPortalManageToolsIdRoute =
  AuthenticatedAppMemberPortalManageToolsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedAppMemberPortalManageToolsRoute,
  } as any)
const AuthenticatedAppMemberPortalManageSuppliersIdRoute =
  AuthenticatedAppMemberPortalManageSuppliersIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedAppMemberPortalManageSuppliersRoute,
  } as any)
const AuthenticatedAppMemberPortalManageContactsIdRoute =
  AuthenticatedAppMemberPortalManageContactsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedAppMemberPortalManageContactsRoute,
  } as any)
const AuthenticatedAppMemberPortalManageCommunicationsIdRoute =
  AuthenticatedAppMemberPortalManageCommunicationsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedAppMemberPortalManageCommunicationsRoute,
  } as any)
const AuthenticatedAppMemberPortalManageCampaignsIdRoute =
  AuthenticatedAppMemberPortalManageCampaignsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedAppMemberPortalManageCampaignsRoute,
  } as any)
const AuthenticatedAppMemberPortalManageBrandingIdRoute =
  AuthenticatedAppMemberPortalManageBrandingIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedAppMemberPortalManageBrandingRoute,
  } as any)
const AuthenticatedAppMemberPortalManageAgreementsIdRoute =
  AuthenticatedAppMemberPortalManageAgreementsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedAppMemberPortalManageAgreementsRoute,
  } as any)
const AuthenticatedAppMemberPortalCampaignsByIdIdRoute =
  AuthenticatedAppMemberPortalCampaignsByIdIdRouteImport.update({
    id: '/by-id/$id',
    path: '/by-id/$id',
    getParentRoute: () => AuthenticatedAppMemberPortalCampaignsRoute,
  } as any)
const AuthenticatedAppInspectionInspectionsInspectionIdProgressRoute =
  AuthenticatedAppInspectionInspectionsInspectionIdProgressRouteImport.update({
    id: '/progress',
    path: '/progress',
    getParentRoute: () =>
      AuthenticatedAppInspectionInspectionsInspectionIdRouteRoute,
  } as any)
const AuthenticatedAppInspectionInspectionsInspectionIdEvidenceRoute =
  AuthenticatedAppInspectionInspectionsInspectionIdEvidenceRouteImport.update({
    id: '/evidence',
    path: '/evidence',
    getParentRoute: () =>
      AuthenticatedAppInspectionInspectionsInspectionIdRouteRoute,
  } as any)
const AuthenticatedAppInspectionInspectionsInspectionIdCapturesRoute =
  AuthenticatedAppInspectionInspectionsInspectionIdCapturesRouteImport.update({
    id: '/captures',
    path: '/captures',
    getParentRoute: () =>
      AuthenticatedAppInspectionInspectionsInspectionIdRouteRoute,
  } as any)
const AuthenticatedAppInspectionInspectionsInspectionIdCaptureRoute =
  AuthenticatedAppInspectionInspectionsInspectionIdCaptureRouteImport.update({
    id: '/capture',
    path: '/capture',
    getParentRoute: () =>
      AuthenticatedAppInspectionInspectionsInspectionIdRouteRoute,
  } as any)
const AuthenticatedAppCrmSettingsPipelinesPipelineIdRoute =
  AuthenticatedAppCrmSettingsPipelinesPipelineIdRouteImport.update({
    id: '/pipelines/$pipelineId',
    path: '/pipelines/$pipelineId',
    getParentRoute: () => AuthenticatedAppCrmSettingsRouteRoute,
  } as any)
const AuthenticatedAppChainCoursesCourseIdManageRoute =
  AuthenticatedAppChainCoursesCourseIdManageRouteImport.update({
    id: '/courses/$courseId/manage',
    path: '/courses/$courseId/manage',
    getParentRoute: () => AuthenticatedAppChainRouteRoute,
  } as any)
const AuthenticatedAppSettingsAuditTimelineTargetTypeTargetIdRoute =
  AuthenticatedAppSettingsAuditTimelineTargetTypeTargetIdRouteImport.update({
    id: '/timeline/$targetType/$targetId',
    path: '/timeline/$targetType/$targetId',
    getParentRoute: () => AuthenticatedAppSettingsAuditRouteRoute,
  } as any)
const AuthenticatedAppCrmDealsDealIdOffersVersionIdRoute =
  AuthenticatedAppCrmDealsDealIdOffersVersionIdRouteImport.update({
    id: '/deals/$dealId_/offers/$versionId',
    path: '/deals/$dealId/offers/$versionId',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdIndexRoute =
  AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdIndexRouteImport.update(
    {
      id: '/inspections/$inspectionId/',
      path: '/inspections/$inspectionId/',
      getParentRoute: () => AuthenticatedAppChainCompaniesMemberIdRouteRoute,
    } as any,
  )
const AuthenticatedAppMemberPortalManageCommunicationsIdResponsesCompanyIdRoute =
  AuthenticatedAppMemberPortalManageCommunicationsIdResponsesCompanyIdRouteImport.update(
    {
      id: '/$id_/responses/$companyId',
      path: '/$id/responses/$companyId',
      getParentRoute: () =>
        AuthenticatedAppMemberPortalManageCommunicationsRoute,
    } as any,
  )
const AuthenticatedAppCrmDealsDealIdOffersVersionIdEditRoute =
  AuthenticatedAppCrmDealsDealIdOffersVersionIdEditRouteImport.update({
    id: '/deals/$dealId_/offers/$versionId_/edit',
    path: '/deals/$dealId/offers/$versionId/edit',
    getParentRoute: () => AuthenticatedAppCrmRouteRoute,
  } as any)
const AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdProgressRoute =
  AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdProgressRouteImport.update(
    {
      id: '/inspections/$inspectionId/progress',
      path: '/inspections/$inspectionId/progress',
      getParentRoute: () => AuthenticatedAppChainCompaniesMemberIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/customer': typeof CustomerRouteRouteWithChildren
  '/prototype': typeof PrototypeRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/accept-invitation-token': typeof AcceptInvitationTokenRoute
  '/calendar-callback': typeof CalendarCallbackRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/meeting-end': typeof MeetingEndRoute
  '/signup': typeof SignupRoute
  '/upgrades': typeof UpgradesRoute
  '/super-admin': typeof AuthenticatedSuperAdminRouteRouteWithChildren
  '/.well-known/change-password': typeof DotwellKnownChangePasswordRoute
  '/connected-companies': typeof AuthenticatedConnectedCompaniesRoute
  '/create-company': typeof AuthenticatedCreateCompanyRoute
  '/link-account': typeof AuthenticatedLinkAccountRoute
  '/practice-call': typeof AuthenticatedPracticeCallRoute
  '/book-meeting/$slug': typeof BookMeetingSlugRoute
  '/cancel-booking/$slug': typeof CancelBookingSlugRoute
  '/customer/forgot-password': typeof CustomerForgotPasswordRoute
  '/customer/login': typeof CustomerLoginRoute
  '/customer/reset-password': typeof CustomerResetPasswordRoute
  '/forms/$slug': typeof FormsSlugRoute
  '/join/$meetingId': typeof JoinMeetingIdRoute
  '/meeting-summary/$token': typeof MeetingSummaryTokenRoute
  '/oauth/error': typeof OauthErrorRoute
  '/offer/$token': typeof OfferTokenRoute
  '/record/$meetingId': typeof RecordMeetingIdRoute
  '/recording/share': typeof RecordingShareRoute
  '/unsubscribe-email/$email': typeof UnsubscribeEmailEmailRoute
  '/v/$secret': typeof VSecretRoute
  '/video/$publicId': typeof VideoPublicIdRoute
  '/itxframe/': typeof ItxframeIndexRoute
  '/prototype/': typeof PrototypeIndexRoute
  '/bookings': typeof AuthenticatedAppBookingsRouteRouteWithChildren
  '/chain': typeof AuthenticatedAppChainRouteRouteWithChildren
  '/crm': typeof AuthenticatedAppCrmRouteRouteWithChildren
  '/forms': typeof AuthenticatedAppFormsRouteRouteWithChildren
  '/inspection': typeof AuthenticatedAppInspectionRouteRouteWithChildren
  '/invoicing': typeof AuthenticatedAppInvoicingRouteRouteWithChildren
  '/member-portal': typeof AuthenticatedAppMemberPortalRouteRouteWithChildren
  '/orders': typeof AuthenticatedAppOrdersRouteRouteWithChildren
  '/settings': typeof AuthenticatedAppSettingsRouteRouteWithChildren
  '/staffing': typeof AuthenticatedAppStaffingRouteRouteWithChildren
  '/calendar': typeof AuthenticatedAppCalendarRoute
  '/checklist': typeof AuthenticatedAppChecklistRoute
  '/dashboard': typeof AuthenticatedAppDashboardRoute
  '/getting-started': typeof AuthenticatedAppGettingStartedRoute
  '/meetings': typeof AuthenticatedAppMeetingsRoute
  '/recording': typeof AuthenticatedAppRecordingRoute
  '/resources': typeof AuthenticatedAppResourcesRoute
  '/team-learning': typeof AuthenticatedAppTeamLearningRoute
  '/super-admin/admins': typeof AuthenticatedSuperAdminAdminsRoute
  '/super-admin/audit': typeof AuthenticatedSuperAdminAuditRoute
  '/super-admin/company-activity': typeof AuthenticatedSuperAdminCompanyActivityRoute
  '/super-admin/connected-apps': typeof AuthenticatedSuperAdminConnectedAppsRoute
  '/super-admin/email-logs': typeof AuthenticatedSuperAdminEmailLogsRoute
  '/super-admin/feedback': typeof AuthenticatedSuperAdminFeedbackRoute
  '/super-admin/impersonation-logs': typeof AuthenticatedSuperAdminImpersonationLogsRoute
  '/super-admin/inspection-library': typeof AuthenticatedSuperAdminInspectionLibraryRoute
  '/super-admin/mcp-activity': typeof AuthenticatedSuperAdminMcpActivityRoute
  '/super-admin/mcp-adoption': typeof AuthenticatedSuperAdminMcpAdoptionRoute
  '/super-admin/mobile-adoption': typeof AuthenticatedSuperAdminMobileAdoptionRoute
  '/super-admin/record-and-send': typeof AuthenticatedSuperAdminRecordAndSendRoute
  '/super-admin/sms-logs': typeof AuthenticatedSuperAdminSmsLogsRoute
  '/super-admin/suppression-list': typeof AuthenticatedSuperAdminSuppressionListRoute
  '/super-admin/transcription-monitor': typeof AuthenticatedSuperAdminTranscriptionMonitorRoute
  '/super-admin/unsubscribe-list': typeof AuthenticatedSuperAdminUnsubscribeListRoute
  '/oauth/consent': typeof OauthOauthConsentRoute
  '/oauth/resume': typeof OauthOauthResumeRoute
  '/oauth/select-company': typeof OauthOauthSelectCompanyRoute
  '/customer/change-password': typeof CustomerCustomerAuthenticatedChangePasswordRoute
  '/customer/profile': typeof CustomerCustomerAuthenticatedProfileRoute
  '/forms/additional/$token': typeof FormsAdditionalTokenRoute
  '/prototype/$slug/$screen': typeof PrototypeSlugScreenRoute
  '/super-admin/': typeof AuthenticatedSuperAdminIndexRoute
  '/crm/settings': typeof AuthenticatedAppCrmSettingsRouteRouteWithChildren
  '/member-portal/manage': typeof AuthenticatedAppMemberPortalManageRouteRouteWithChildren
  '/settings/audit': typeof AuthenticatedAppSettingsAuditRouteRouteWithChildren
  '/settings/billing': typeof AuthenticatedAppSettingsBillingRouteRouteWithChildren
  '/bookings/blackout-dates': typeof AuthenticatedAppBookingsBlackoutDatesRoute
  '/bookings/customize': typeof AuthenticatedAppBookingsCustomizeRoute
  '/bookings/dashboard': typeof AuthenticatedAppBookingsDashboardRoute
  '/bookings/manage': typeof AuthenticatedAppBookingsManageRoute
  '/bookings/services': typeof AuthenticatedAppBookingsServicesRoute
  '/bookings/tracking': typeof AuthenticatedAppBookingsTrackingRoute
  '/chain/analytics': typeof AuthenticatedAppChainAnalyticsRoute
  '/chain/competence': typeof AuthenticatedAppChainCompetenceRoute
  '/chain/config-pushes': typeof AuthenticatedAppChainConfigPushesRoute
  '/chain/coverage': typeof AuthenticatedAppChainCoverageRoute
  '/chain/endorsement': typeof AuthenticatedAppChainEndorsementRoute
  '/chain/learning': typeof AuthenticatedAppChainLearningRoute
  '/chain/master-catalog': typeof AuthenticatedAppChainMasterCatalogRoute
  '/chain/members': typeof AuthenticatedAppChainMembersRoute
  '/chain/my-endorsement': typeof AuthenticatedAppChainMyEndorsementRoute
  '/chain/order-pipeline': typeof AuthenticatedAppChainOrderPipelineRoute
  '/chain/quick-links': typeof AuthenticatedAppChainQuickLinksRoute
  '/chain/resources': typeof AuthenticatedAppChainResourcesRoute
  '/chain/staffing': typeof AuthenticatedAppChainStaffingRoute
  '/competence/approvals': typeof AuthenticatedAppCompetenceApprovalsRoute
  '/competence/matrix': typeof AuthenticatedAppCompetenceMatrixRoute
  '/competence/me': typeof AuthenticatedAppCompetenceMeRoute
  '/competence/types': typeof AuthenticatedAppCompetenceTypesRoute
  '/courses/$courseId': typeof AuthenticatedAppCoursesCourseIdRoute
  '/courses/create': typeof AuthenticatedAppCoursesCreateRoute
  '/history/$meetingID': typeof AuthenticatedAppHistoryMeetingIDRoute
  '/invoicing/$invoiceId': typeof AuthenticatedAppInvoicingInvoiceIdRoute
  '/member-portal/about': typeof AuthenticatedAppMemberPortalAboutRoute
  '/member-portal/agreements': typeof AuthenticatedAppMemberPortalAgreementsRouteWithChildren
  '/member-portal/branding': typeof AuthenticatedAppMemberPortalBrandingRoute
  '/member-portal/campaigns': typeof AuthenticatedAppMemberPortalCampaignsRouteWithChildren
  '/member-portal/communications': typeof AuthenticatedAppMemberPortalCommunicationsRouteWithChildren
  '/member-portal/contacts': typeof AuthenticatedAppMemberPortalContactsRoute
  '/member-portal/overview': typeof AuthenticatedAppMemberPortalOverviewRoute
  '/member-portal/suppliers': typeof AuthenticatedAppMemberPortalSuppliersRouteWithChildren
  '/member-portal/tools': typeof AuthenticatedAppMemberPortalToolsRouteWithChildren
  '/my/learning': typeof AuthenticatedAppMyLearningRoute
  '/orders/$orderId': typeof AuthenticatedAppOrdersOrderIdRoute
  '/orders/reports': typeof AuthenticatedAppOrdersReportsRoute
  '/settings/access': typeof AuthenticatedAppSettingsAccessRoute
  '/settings/ai-settings': typeof AuthenticatedAppSettingsAiSettingsRoute
  '/settings/api-keys': typeof AuthenticatedAppSettingsApiKeysRoute
  '/settings/company': typeof AuthenticatedAppSettingsCompanyRoute
  '/settings/connected-apps': typeof AuthenticatedAppSettingsConnectedAppsRoute
  '/settings/members': typeof AuthenticatedAppSettingsMembersRoute
  '/settings/notifications': typeof AuthenticatedAppSettingsNotificationsRoute
  '/settings/order-settings': typeof AuthenticatedAppSettingsOrderSettingsRoute
  '/settings/profile': typeof AuthenticatedAppSettingsProfileRoute
  '/settings/service-area': typeof AuthenticatedAppSettingsServiceAreaRoute
  '/settings/service-types': typeof AuthenticatedAppSettingsServiceTypesRoute
  '/settings/usage': typeof AuthenticatedAppSettingsUsageRoute
  '/settings/white-labeling': typeof AuthenticatedAppSettingsWhiteLabelingRoute
  '/staffing/categories': typeof AuthenticatedAppStaffingCategoriesRoute
  '/staffing/my-interests': typeof AuthenticatedAppStaffingMyInterestsRoute
  '/staffing/my-postings': typeof AuthenticatedAppStaffingMyPostingsRoute
  '/staffing/pending-approvals': typeof AuthenticatedAppStaffingPendingApprovalsRoute
  '/staffing/skill-levels': typeof AuthenticatedAppStaffingSkillLevelsRoute
  '/staffing/skills': typeof AuthenticatedAppStaffingSkillsRoute
  '/super-admin/ai-ops/cost': typeof AuthenticatedSuperAdminAiOpsCostRoute
  '/super-admin/ai-ops/runs': typeof AuthenticatedSuperAdminAiOpsRunsRoute
  '/super-admin/chains/$parentCompanyId': typeof AuthenticatedSuperAdminChainsParentCompanyIdRoute
  '/super-admin/companies/$companyId': typeof AuthenticatedSuperAdminCompaniesCompanyIdRoute
  '/super-admin/industry-presets/$id': typeof AuthenticatedSuperAdminIndustryPresetsIdRoute
  '/super-admin/industry-presets/new': typeof AuthenticatedSuperAdminIndustryPresetsNewRoute
  '/super-admin/login-security/settings': typeof AuthenticatedSuperAdminLoginSecuritySettingsRoute
  '/super-admin/meeting-telemetry/$meetingId': typeof AuthenticatedSuperAdminMeetingTelemetryMeetingIdRoute
  '/super-admin/users/$userId': typeof AuthenticatedSuperAdminUsersUserIdRoute
  '/customer/orders/$orderId': typeof CustomerCustomerAuthenticatedOrdersOrderIdRoute
  '/bookings/': typeof AuthenticatedAppBookingsIndexRoute
  '/competence/': typeof AuthenticatedAppCompetenceIndexRoute
  '/courses/': typeof AuthenticatedAppCoursesIndexRoute
  '/crm/': typeof AuthenticatedAppCrmIndexRoute
  '/forms/': typeof AuthenticatedAppFormsIndexRoute
  '/inspection/': typeof AuthenticatedAppInspectionIndexRoute
  '/invoicing/': typeof AuthenticatedAppInvoicingIndexRoute
  '/member-portal/': typeof AuthenticatedAppMemberPortalIndexRoute
  '/orders/': typeof AuthenticatedAppOrdersIndexRoute
  '/record-and-send/': typeof AuthenticatedAppRecordAndSendIndexRoute
  '/settings/': typeof AuthenticatedAppSettingsIndexRoute
  '/staffing/': typeof AuthenticatedAppStaffingIndexRoute
  '/super-admin/ai-ops/': typeof AuthenticatedSuperAdminAiOpsIndexRoute
  '/super-admin/chains/': typeof AuthenticatedSuperAdminChainsIndexRoute
  '/super-admin/companies/': typeof AuthenticatedSuperAdminCompaniesIndexRoute
  '/super-admin/industry-presets/': typeof AuthenticatedSuperAdminIndustryPresetsIndexRoute
  '/super-admin/login-security/': typeof AuthenticatedSuperAdminLoginSecurityIndexRoute
  '/super-admin/meeting-telemetry/': typeof AuthenticatedSuperAdminMeetingTelemetryIndexRoute
  '/super-admin/users/': typeof AuthenticatedSuperAdminUsersIndexRoute
  '/customer/orders/': typeof CustomerCustomerAuthenticatedOrdersIndexRoute
  '/chain/companies/$memberId': typeof AuthenticatedAppChainCompaniesMemberIdRouteRouteWithChildren
  '/inspection/inspections/$inspectionId': typeof AuthenticatedAppInspectionInspectionsInspectionIdRouteRouteWithChildren
  '/record-and-send/video-types/$videoTypeId': typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRouteWithChildren
  '/chain/announcements/$announcementId': typeof AuthenticatedAppChainAnnouncementsAnnouncementIdRoute
  '/competence/user/$userId': typeof AuthenticatedAppCompetenceUserUserIdRoute
  '/courses/$courseId/edit': typeof AuthenticatedAppCoursesCourseIdEditRoute
  '/crm/chain/distribution': typeof AuthenticatedAppCrmChainDistributionRoute
  '/crm/chain/members': typeof AuthenticatedAppCrmChainMembersRoute
  '/crm/chain/parent-incoming': typeof AuthenticatedAppCrmChainParentIncomingRoute
  '/crm/chain/pipeline': typeof AuthenticatedAppCrmChainPipelineRoute
  '/crm/companies/$id': typeof AuthenticatedAppCrmCompaniesIdRoute
  '/crm/contacts/$contactId': typeof AuthenticatedAppCrmContactsContactIdRoute
  '/crm/deals/$dealId': typeof AuthenticatedAppCrmDealsDealIdRoute
  '/crm/leads/$leadId': typeof AuthenticatedAppCrmLeadsLeadIdRoute
  '/crm/pipeline/$pipelineId': typeof AuthenticatedAppCrmPipelinePipelineIdRoute
  '/crm/settings/company-fields': typeof AuthenticatedAppCrmSettingsCompanyFieldsRoute
  '/crm/settings/contact-fields': typeof AuthenticatedAppCrmSettingsContactFieldsRoute
  '/crm/settings/deal-fields': typeof AuthenticatedAppCrmSettingsDealFieldsRoute
  '/crm/settings/lost-reasons': typeof AuthenticatedAppCrmSettingsLostReasonsRoute
  '/crm/settings/offer-defaults': typeof AuthenticatedAppCrmSettingsOfferDefaultsRoute
  '/crm/settings/order-pipeline': typeof AuthenticatedAppCrmSettingsOrderPipelineRoute
  '/forms/$formId/analytics': typeof AuthenticatedAppFormsFormIdAnalyticsRoute
  '/forms/$formId/designer': typeof AuthenticatedAppFormsFormIdDesignerRoute
  '/forms/$formId/submissions': typeof AuthenticatedAppFormsFormIdSubmissionsRoute
  '/inspection/sites/$siteId': typeof AuthenticatedAppInspectionSitesSiteIdRoute
  '/inspection/templates/$templateId': typeof AuthenticatedAppInspectionTemplatesTemplateIdRoute
  '/invoicing/prepare/$orderId': typeof AuthenticatedAppInvoicingPrepareOrderIdRoute
  '/member-portal/agreements/$id': typeof AuthenticatedAppMemberPortalAgreementsIdRoute
  '/member-portal/branding/$id': typeof AuthenticatedAppMemberPortalBrandingIdRoute
  '/member-portal/campaigns/$slug': typeof AuthenticatedAppMemberPortalCampaignsSlugRoute
  '/member-portal/communications/$id': typeof AuthenticatedAppMemberPortalCommunicationsIdRoute
  '/member-portal/manage/about': typeof AuthenticatedAppMemberPortalManageAboutRoute
  '/member-portal/manage/agreements': typeof AuthenticatedAppMemberPortalManageAgreementsRouteWithChildren
  '/member-portal/manage/branding': typeof AuthenticatedAppMemberPortalManageBrandingRouteWithChildren
  '/member-portal/manage/campaigns': typeof AuthenticatedAppMemberPortalManageCampaignsRouteWithChildren
  '/member-portal/manage/communications': typeof AuthenticatedAppMemberPortalManageCommunicationsRouteWithChildren
  '/member-portal/manage/contacts': typeof AuthenticatedAppMemberPortalManageContactsRouteWithChildren
  '/member-portal/manage/suppliers': typeof AuthenticatedAppMemberPortalManageSuppliersRouteWithChildren
  '/member-portal/manage/tools': typeof AuthenticatedAppMemberPortalManageToolsRouteWithChildren
  '/member-portal/suppliers/$id': typeof AuthenticatedAppMemberPortalSuppliersIdRoute
  '/member-portal/tools/$id': typeof AuthenticatedAppMemberPortalToolsIdRoute
  '/record-and-send/submissions/$submissionId': typeof AuthenticatedAppRecordAndSendSubmissionsSubmissionIdRoute
  '/record-and-send/video-types/new': typeof AuthenticatedAppRecordAndSendVideoTypesNewRoute
  '/settings/billing/addons': typeof AuthenticatedAppSettingsBillingAddonsRoute
  '/settings/billing/payments': typeof AuthenticatedAppSettingsBillingPaymentsRoute
  '/settings/invoicing/accounting': typeof AuthenticatedAppSettingsInvoicingAccountingRoute
  '/settings/meeting/background': typeof AuthenticatedAppSettingsMeetingBackgroundRoute
  '/settings/meeting/defaults': typeof AuthenticatedAppSettingsMeetingDefaultsRoute
  '/settings/meeting/recording': typeof AuthenticatedAppSettingsMeetingRecordingRoute
  '/settings/orders/pipeline': typeof AuthenticatedAppSettingsOrdersPipelineRoute
  '/settings/roles/$roleId': typeof AuthenticatedAppSettingsRolesRoleIdRoute
  '/settings/roles/new': typeof AuthenticatedAppSettingsRolesNewRoute
  '/staffing/postings/$id': typeof AuthenticatedAppStaffingPostingsIdRoute
  '/staffing/postings/new': typeof AuthenticatedAppStaffingPostingsNewRoute
  '/super-admin/companies/$companyId/roles': typeof AuthenticatedSuperAdminCompaniesCompanyIdRolesRoute
  '/chain/announcements/': typeof AuthenticatedAppChainAnnouncementsIndexRoute
  '/chain/courses/': typeof AuthenticatedAppChainCoursesIndexRoute
  '/crm/catalog/': typeof AuthenticatedAppCrmCatalogIndexRoute
  '/crm/companies/': typeof AuthenticatedAppCrmCompaniesIndexRoute
  '/crm/contacts/': typeof AuthenticatedAppCrmContactsIndexRoute
  '/crm/deals/': typeof AuthenticatedAppCrmDealsIndexRoute
  '/crm/duplicates/': typeof AuthenticatedAppCrmDuplicatesIndexRoute
  '/crm/leads/': typeof AuthenticatedAppCrmLeadsIndexRoute
  '/crm/my-work/': typeof AuthenticatedAppCrmMyWorkIndexRoute
  '/crm/pipeline/': typeof AuthenticatedAppCrmPipelineIndexRoute
  '/crm/reporting/': typeof AuthenticatedAppCrmReportingIndexRoute
  '/crm/settings/': typeof AuthenticatedAppCrmSettingsIndexRoute
  '/inspection/library/': typeof AuthenticatedAppInspectionLibraryIndexRoute
  '/inspection/sites/': typeof AuthenticatedAppInspectionSitesIndexRoute
  '/inspection/templates/': typeof AuthenticatedAppInspectionTemplatesIndexRoute
  '/inspection/upcoming/': typeof AuthenticatedAppInspectionUpcomingIndexRoute
  '/member-portal/manage/': typeof AuthenticatedAppMemberPortalManageIndexRoute
  '/settings/audit/': typeof AuthenticatedAppSettingsAuditIndexRoute
  '/settings/billing/': typeof AuthenticatedAppSettingsBillingIndexRoute
  '/settings/meeting/': typeof AuthenticatedAppSettingsMeetingIndexRoute
  '/settings/roles/': typeof AuthenticatedAppSettingsRolesIndexRoute
  '/chain/courses/$courseId/manage': typeof AuthenticatedAppChainCoursesCourseIdManageRoute
  '/crm/settings/pipelines/$pipelineId': typeof AuthenticatedAppCrmSettingsPipelinesPipelineIdRoute
  '/inspection/inspections/$inspectionId/capture': typeof AuthenticatedAppInspectionInspectionsInspectionIdCaptureRoute
  '/inspection/inspections/$inspectionId/captures': typeof AuthenticatedAppInspectionInspectionsInspectionIdCapturesRoute
  '/inspection/inspections/$inspectionId/evidence': typeof AuthenticatedAppInspectionInspectionsInspectionIdEvidenceRoute
  '/inspection/inspections/$inspectionId/progress': typeof AuthenticatedAppInspectionInspectionsInspectionIdProgressRoute
  '/member-portal/campaigns/by-id/$id': typeof AuthenticatedAppMemberPortalCampaignsByIdIdRoute
  '/member-portal/manage/agreements/$id': typeof AuthenticatedAppMemberPortalManageAgreementsIdRoute
  '/member-portal/manage/branding/$id': typeof AuthenticatedAppMemberPortalManageBrandingIdRoute
  '/member-portal/manage/campaigns/$id': typeof AuthenticatedAppMemberPortalManageCampaignsIdRoute
  '/member-portal/manage/communications/$id': typeof AuthenticatedAppMemberPortalManageCommunicationsIdRoute
  '/member-portal/manage/contacts/$id': typeof AuthenticatedAppMemberPortalManageContactsIdRoute
  '/member-portal/manage/suppliers/$id': typeof AuthenticatedAppMemberPortalManageSuppliersIdRoute
  '/member-portal/manage/tools/$id': typeof AuthenticatedAppMemberPortalManageToolsIdRoute
  '/record-and-send/video-types/$videoTypeId/requests': typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRequestsRoute
  '/record-and-send/video-types/$videoTypeId/settings': typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdSettingsRoute
  '/record-and-send/video-types/$videoTypeId/videos': typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdVideosRoute
  '/settings/billing/pricing/checkout': typeof AuthenticatedAppSettingsBillingPricingCheckoutRoute
  '/staffing/postings/$id/edit': typeof AuthenticatedAppStaffingPostingsIdEditRoute
  '/chain/companies/$memberId/': typeof AuthenticatedAppChainCompaniesMemberIdIndexRoute
  '/crm/settings/pipelines/': typeof AuthenticatedAppCrmSettingsPipelinesIndexRoute
  '/inspection/inspections/$inspectionId/': typeof AuthenticatedAppInspectionInspectionsInspectionIdIndexRoute
  '/record-and-send/video-types/$videoTypeId/': typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdIndexRoute
  '/settings/billing/pricing/': typeof AuthenticatedAppSettingsBillingPricingIndexRoute
  '/crm/deals/$dealId/offers/$versionId': typeof AuthenticatedAppCrmDealsDealIdOffersVersionIdRoute
  '/settings/audit/timeline/$targetType/$targetId': typeof AuthenticatedAppSettingsAuditTimelineTargetTypeTargetIdRoute
  '/chain/companies/$memberId/inspections/$inspectionId/progress': typeof AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdProgressRoute
  '/crm/deals/$dealId/offers/$versionId/edit': typeof AuthenticatedAppCrmDealsDealIdOffersVersionIdEditRoute
  '/member-portal/manage/communications/$id/responses/$companyId': typeof AuthenticatedAppMemberPortalManageCommunicationsIdResponsesCompanyIdRoute
  '/chain/companies/$memberId/inspections/$inspectionId/': typeof AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/customer': typeof CustomerRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/accept-invitation-token': typeof AcceptInvitationTokenRoute
  '/calendar-callback': typeof CalendarCallbackRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/meeting-end': typeof MeetingEndRoute
  '/signup': typeof SignupRoute
  '/upgrades': typeof UpgradesRoute
  '/.well-known/change-password': typeof DotwellKnownChangePasswordRoute
  '/connected-companies': typeof AuthenticatedConnectedCompaniesRoute
  '/create-company': typeof AuthenticatedCreateCompanyRoute
  '/link-account': typeof AuthenticatedLinkAccountRoute
  '/practice-call': typeof AuthenticatedPracticeCallRoute
  '/book-meeting/$slug': typeof BookMeetingSlugRoute
  '/cancel-booking/$slug': typeof CancelBookingSlugRoute
  '/customer/forgot-password': typeof CustomerForgotPasswordRoute
  '/customer/login': typeof CustomerLoginRoute
  '/customer/reset-password': typeof CustomerResetPasswordRoute
  '/forms/$slug': typeof FormsSlugRoute
  '/join/$meetingId': typeof JoinMeetingIdRoute
  '/meeting-summary/$token': typeof MeetingSummaryTokenRoute
  '/oauth/error': typeof OauthErrorRoute
  '/offer/$token': typeof OfferTokenRoute
  '/record/$meetingId': typeof RecordMeetingIdRoute
  '/recording/share': typeof RecordingShareRoute
  '/unsubscribe-email/$email': typeof UnsubscribeEmailEmailRoute
  '/v/$secret': typeof VSecretRoute
  '/video/$publicId': typeof VideoPublicIdRoute
  '/itxframe': typeof ItxframeIndexRoute
  '/prototype': typeof PrototypeIndexRoute
  '/chain': typeof AuthenticatedAppChainRouteRouteWithChildren
  '/calendar': typeof AuthenticatedAppCalendarRoute
  '/checklist': typeof AuthenticatedAppChecklistRoute
  '/dashboard': typeof AuthenticatedAppDashboardRoute
  '/getting-started': typeof AuthenticatedAppGettingStartedRoute
  '/meetings': typeof AuthenticatedAppMeetingsRoute
  '/recording': typeof AuthenticatedAppRecordingRoute
  '/resources': typeof AuthenticatedAppResourcesRoute
  '/team-learning': typeof AuthenticatedAppTeamLearningRoute
  '/super-admin/admins': typeof AuthenticatedSuperAdminAdminsRoute
  '/super-admin/audit': typeof AuthenticatedSuperAdminAuditRoute
  '/super-admin/company-activity': typeof AuthenticatedSuperAdminCompanyActivityRoute
  '/super-admin/connected-apps': typeof AuthenticatedSuperAdminConnectedAppsRoute
  '/super-admin/email-logs': typeof AuthenticatedSuperAdminEmailLogsRoute
  '/super-admin/feedback': typeof AuthenticatedSuperAdminFeedbackRoute
  '/super-admin/impersonation-logs': typeof AuthenticatedSuperAdminImpersonationLogsRoute
  '/super-admin/inspection-library': typeof AuthenticatedSuperAdminInspectionLibraryRoute
  '/super-admin/mcp-activity': typeof AuthenticatedSuperAdminMcpActivityRoute
  '/super-admin/mcp-adoption': typeof AuthenticatedSuperAdminMcpAdoptionRoute
  '/super-admin/mobile-adoption': typeof AuthenticatedSuperAdminMobileAdoptionRoute
  '/super-admin/record-and-send': typeof AuthenticatedSuperAdminRecordAndSendRoute
  '/super-admin/sms-logs': typeof AuthenticatedSuperAdminSmsLogsRoute
  '/super-admin/suppression-list': typeof AuthenticatedSuperAdminSuppressionListRoute
  '/super-admin/transcription-monitor': typeof AuthenticatedSuperAdminTranscriptionMonitorRoute
  '/super-admin/unsubscribe-list': typeof AuthenticatedSuperAdminUnsubscribeListRoute
  '/oauth/consent': typeof OauthOauthConsentRoute
  '/oauth/resume': typeof OauthOauthResumeRoute
  '/oauth/select-company': typeof OauthOauthSelectCompanyRoute
  '/customer/change-password': typeof CustomerCustomerAuthenticatedChangePasswordRoute
  '/customer/profile': typeof CustomerCustomerAuthenticatedProfileRoute
  '/forms/additional/$token': typeof FormsAdditionalTokenRoute
  '/prototype/$slug/$screen': typeof PrototypeSlugScreenRoute
  '/super-admin': typeof AuthenticatedSuperAdminIndexRoute
  '/bookings/blackout-dates': typeof AuthenticatedAppBookingsBlackoutDatesRoute
  '/bookings/customize': typeof AuthenticatedAppBookingsCustomizeRoute
  '/bookings/dashboard': typeof AuthenticatedAppBookingsDashboardRoute
  '/bookings/manage': typeof AuthenticatedAppBookingsManageRoute
  '/bookings/services': typeof AuthenticatedAppBookingsServicesRoute
  '/bookings/tracking': typeof AuthenticatedAppBookingsTrackingRoute
  '/chain/analytics': typeof AuthenticatedAppChainAnalyticsRoute
  '/chain/competence': typeof AuthenticatedAppChainCompetenceRoute
  '/chain/config-pushes': typeof AuthenticatedAppChainConfigPushesRoute
  '/chain/coverage': typeof AuthenticatedAppChainCoverageRoute
  '/chain/endorsement': typeof AuthenticatedAppChainEndorsementRoute
  '/chain/learning': typeof AuthenticatedAppChainLearningRoute
  '/chain/master-catalog': typeof AuthenticatedAppChainMasterCatalogRoute
  '/chain/members': typeof AuthenticatedAppChainMembersRoute
  '/chain/my-endorsement': typeof AuthenticatedAppChainMyEndorsementRoute
  '/chain/order-pipeline': typeof AuthenticatedAppChainOrderPipelineRoute
  '/chain/quick-links': typeof AuthenticatedAppChainQuickLinksRoute
  '/chain/resources': typeof AuthenticatedAppChainResourcesRoute
  '/chain/staffing': typeof AuthenticatedAppChainStaffingRoute
  '/competence/approvals': typeof AuthenticatedAppCompetenceApprovalsRoute
  '/competence/matrix': typeof AuthenticatedAppCompetenceMatrixRoute
  '/competence/me': typeof AuthenticatedAppCompetenceMeRoute
  '/competence/types': typeof AuthenticatedAppCompetenceTypesRoute
  '/courses/$courseId': typeof AuthenticatedAppCoursesCourseIdRoute
  '/courses/create': typeof AuthenticatedAppCoursesCreateRoute
  '/history/$meetingID': typeof AuthenticatedAppHistoryMeetingIDRoute
  '/invoicing/$invoiceId': typeof AuthenticatedAppInvoicingInvoiceIdRoute
  '/member-portal/about': typeof AuthenticatedAppMemberPortalAboutRoute
  '/member-portal/agreements': typeof AuthenticatedAppMemberPortalAgreementsRouteWithChildren
  '/member-portal/branding': typeof AuthenticatedAppMemberPortalBrandingRoute
  '/member-portal/campaigns': typeof AuthenticatedAppMemberPortalCampaignsRouteWithChildren
  '/member-portal/communications': typeof AuthenticatedAppMemberPortalCommunicationsRouteWithChildren
  '/member-portal/contacts': typeof AuthenticatedAppMemberPortalContactsRoute
  '/member-portal/overview': typeof AuthenticatedAppMemberPortalOverviewRoute
  '/member-portal/suppliers': typeof AuthenticatedAppMemberPortalSuppliersRouteWithChildren
  '/member-portal/tools': typeof AuthenticatedAppMemberPortalToolsRouteWithChildren
  '/my/learning': typeof AuthenticatedAppMyLearningRoute
  '/orders/$orderId': typeof AuthenticatedAppOrdersOrderIdRoute
  '/orders/reports': typeof AuthenticatedAppOrdersReportsRoute
  '/settings/access': typeof AuthenticatedAppSettingsAccessRoute
  '/settings/ai-settings': typeof AuthenticatedAppSettingsAiSettingsRoute
  '/settings/api-keys': typeof AuthenticatedAppSettingsApiKeysRoute
  '/settings/company': typeof AuthenticatedAppSettingsCompanyRoute
  '/settings/connected-apps': typeof AuthenticatedAppSettingsConnectedAppsRoute
  '/settings/members': typeof AuthenticatedAppSettingsMembersRoute
  '/settings/notifications': typeof AuthenticatedAppSettingsNotificationsRoute
  '/settings/order-settings': typeof AuthenticatedAppSettingsOrderSettingsRoute
  '/settings/profile': typeof AuthenticatedAppSettingsProfileRoute
  '/settings/service-area': typeof AuthenticatedAppSettingsServiceAreaRoute
  '/settings/service-types': typeof AuthenticatedAppSettingsServiceTypesRoute
  '/settings/usage': typeof AuthenticatedAppSettingsUsageRoute
  '/settings/white-labeling': typeof AuthenticatedAppSettingsWhiteLabelingRoute
  '/staffing/categories': typeof AuthenticatedAppStaffingCategoriesRoute
  '/staffing/my-interests': typeof AuthenticatedAppStaffingMyInterestsRoute
  '/staffing/my-postings': typeof AuthenticatedAppStaffingMyPostingsRoute
  '/staffing/pending-approvals': typeof AuthenticatedAppStaffingPendingApprovalsRoute
  '/staffing/skill-levels': typeof AuthenticatedAppStaffingSkillLevelsRoute
  '/staffing/skills': typeof AuthenticatedAppStaffingSkillsRoute
  '/super-admin/ai-ops/cost': typeof AuthenticatedSuperAdminAiOpsCostRoute
  '/super-admin/ai-ops/runs': typeof AuthenticatedSuperAdminAiOpsRunsRoute
  '/super-admin/chains/$parentCompanyId': typeof AuthenticatedSuperAdminChainsParentCompanyIdRoute
  '/super-admin/companies/$companyId': typeof AuthenticatedSuperAdminCompaniesCompanyIdRoute
  '/super-admin/industry-presets/$id': typeof AuthenticatedSuperAdminIndustryPresetsIdRoute
  '/super-admin/industry-presets/new': typeof AuthenticatedSuperAdminIndustryPresetsNewRoute
  '/super-admin/login-security/settings': typeof AuthenticatedSuperAdminLoginSecuritySettingsRoute
  '/super-admin/meeting-telemetry/$meetingId': typeof AuthenticatedSuperAdminMeetingTelemetryMeetingIdRoute
  '/super-admin/users/$userId': typeof AuthenticatedSuperAdminUsersUserIdRoute
  '/customer/orders/$orderId': typeof CustomerCustomerAuthenticatedOrdersOrderIdRoute
  '/bookings': typeof AuthenticatedAppBookingsIndexRoute
  '/competence': typeof AuthenticatedAppCompetenceIndexRoute
  '/courses': typeof AuthenticatedAppCoursesIndexRoute
  '/crm': typeof AuthenticatedAppCrmIndexRoute
  '/forms': typeof AuthenticatedAppFormsIndexRoute
  '/inspection': typeof AuthenticatedAppInspectionIndexRoute
  '/invoicing': typeof AuthenticatedAppInvoicingIndexRoute
  '/member-portal': typeof AuthenticatedAppMemberPortalIndexRoute
  '/orders': typeof AuthenticatedAppOrdersIndexRoute
  '/record-and-send': typeof AuthenticatedAppRecordAndSendIndexRoute
  '/settings': typeof AuthenticatedAppSettingsIndexRoute
  '/staffing': typeof AuthenticatedAppStaffingIndexRoute
  '/super-admin/ai-ops': typeof AuthenticatedSuperAdminAiOpsIndexRoute
  '/super-admin/chains': typeof AuthenticatedSuperAdminChainsIndexRoute
  '/super-admin/companies': typeof AuthenticatedSuperAdminCompaniesIndexRoute
  '/super-admin/industry-presets': typeof AuthenticatedSuperAdminIndustryPresetsIndexRoute
  '/super-admin/login-security': typeof AuthenticatedSuperAdminLoginSecurityIndexRoute
  '/super-admin/meeting-telemetry': typeof AuthenticatedSuperAdminMeetingTelemetryIndexRoute
  '/super-admin/users': typeof AuthenticatedSuperAdminUsersIndexRoute
  '/customer/orders': typeof CustomerCustomerAuthenticatedOrdersIndexRoute
  '/chain/announcements/$announcementId': typeof AuthenticatedAppChainAnnouncementsAnnouncementIdRoute
  '/competence/user/$userId': typeof AuthenticatedAppCompetenceUserUserIdRoute
  '/courses/$courseId/edit': typeof AuthenticatedAppCoursesCourseIdEditRoute
  '/crm/chain/distribution': typeof AuthenticatedAppCrmChainDistributionRoute
  '/crm/chain/members': typeof AuthenticatedAppCrmChainMembersRoute
  '/crm/chain/parent-incoming': typeof AuthenticatedAppCrmChainParentIncomingRoute
  '/crm/chain/pipeline': typeof AuthenticatedAppCrmChainPipelineRoute
  '/crm/companies/$id': typeof AuthenticatedAppCrmCompaniesIdRoute
  '/crm/contacts/$contactId': typeof AuthenticatedAppCrmContactsContactIdRoute
  '/crm/deals/$dealId': typeof AuthenticatedAppCrmDealsDealIdRoute
  '/crm/leads/$leadId': typeof AuthenticatedAppCrmLeadsLeadIdRoute
  '/crm/pipeline/$pipelineId': typeof AuthenticatedAppCrmPipelinePipelineIdRoute
  '/crm/settings/company-fields': typeof AuthenticatedAppCrmSettingsCompanyFieldsRoute
  '/crm/settings/contact-fields': typeof AuthenticatedAppCrmSettingsContactFieldsRoute
  '/crm/settings/deal-fields': typeof AuthenticatedAppCrmSettingsDealFieldsRoute
  '/crm/settings/lost-reasons': typeof AuthenticatedAppCrmSettingsLostReasonsRoute
  '/crm/settings/offer-defaults': typeof AuthenticatedAppCrmSettingsOfferDefaultsRoute
  '/crm/settings/order-pipeline': typeof AuthenticatedAppCrmSettingsOrderPipelineRoute
  '/forms/$formId/analytics': typeof AuthenticatedAppFormsFormIdAnalyticsRoute
  '/forms/$formId/designer': typeof AuthenticatedAppFormsFormIdDesignerRoute
  '/forms/$formId/submissions': typeof AuthenticatedAppFormsFormIdSubmissionsRoute
  '/inspection/sites/$siteId': typeof AuthenticatedAppInspectionSitesSiteIdRoute
  '/inspection/templates/$templateId': typeof AuthenticatedAppInspectionTemplatesTemplateIdRoute
  '/invoicing/prepare/$orderId': typeof AuthenticatedAppInvoicingPrepareOrderIdRoute
  '/member-portal/agreements/$id': typeof AuthenticatedAppMemberPortalAgreementsIdRoute
  '/member-portal/branding/$id': typeof AuthenticatedAppMemberPortalBrandingIdRoute
  '/member-portal/campaigns/$slug': typeof AuthenticatedAppMemberPortalCampaignsSlugRoute
  '/member-portal/communications/$id': typeof AuthenticatedAppMemberPortalCommunicationsIdRoute
  '/member-portal/manage/about': typeof AuthenticatedAppMemberPortalManageAboutRoute
  '/member-portal/manage/agreements': typeof AuthenticatedAppMemberPortalManageAgreementsRouteWithChildren
  '/member-portal/manage/branding': typeof AuthenticatedAppMemberPortalManageBrandingRouteWithChildren
  '/member-portal/manage/campaigns': typeof AuthenticatedAppMemberPortalManageCampaignsRouteWithChildren
  '/member-portal/manage/communications': typeof AuthenticatedAppMemberPortalManageCommunicationsRouteWithChildren
  '/member-portal/manage/contacts': typeof AuthenticatedAppMemberPortalManageContactsRouteWithChildren
  '/member-portal/manage/suppliers': typeof AuthenticatedAppMemberPortalManageSuppliersRouteWithChildren
  '/member-portal/manage/tools': typeof AuthenticatedAppMemberPortalManageToolsRouteWithChildren
  '/member-portal/suppliers/$id': typeof AuthenticatedAppMemberPortalSuppliersIdRoute
  '/member-portal/tools/$id': typeof AuthenticatedAppMemberPortalToolsIdRoute
  '/record-and-send/submissions/$submissionId': typeof AuthenticatedAppRecordAndSendSubmissionsSubmissionIdRoute
  '/record-and-send/video-types/new': typeof AuthenticatedAppRecordAndSendVideoTypesNewRoute
  '/settings/billing/addons': typeof AuthenticatedAppSettingsBillingAddonsRoute
  '/settings/billing/payments': typeof AuthenticatedAppSettingsBillingPaymentsRoute
  '/settings/invoicing/accounting': typeof AuthenticatedAppSettingsInvoicingAccountingRoute
  '/settings/meeting/background': typeof AuthenticatedAppSettingsMeetingBackgroundRoute
  '/settings/meeting/defaults': typeof AuthenticatedAppSettingsMeetingDefaultsRoute
  '/settings/meeting/recording': typeof AuthenticatedAppSettingsMeetingRecordingRoute
  '/settings/orders/pipeline': typeof AuthenticatedAppSettingsOrdersPipelineRoute
  '/settings/roles/$roleId': typeof AuthenticatedAppSettingsRolesRoleIdRoute
  '/settings/roles/new': typeof AuthenticatedAppSettingsRolesNewRoute
  '/staffing/postings/$id': typeof AuthenticatedAppStaffingPostingsIdRoute
  '/staffing/postings/new': typeof AuthenticatedAppStaffingPostingsNewRoute
  '/super-admin/companies/$companyId/roles': typeof AuthenticatedSuperAdminCompaniesCompanyIdRolesRoute
  '/chain/announcements': typeof AuthenticatedAppChainAnnouncementsIndexRoute
  '/chain/courses': typeof AuthenticatedAppChainCoursesIndexRoute
  '/crm/catalog': typeof AuthenticatedAppCrmCatalogIndexRoute
  '/crm/companies': typeof AuthenticatedAppCrmCompaniesIndexRoute
  '/crm/contacts': typeof AuthenticatedAppCrmContactsIndexRoute
  '/crm/deals': typeof AuthenticatedAppCrmDealsIndexRoute
  '/crm/duplicates': typeof AuthenticatedAppCrmDuplicatesIndexRoute
  '/crm/leads': typeof AuthenticatedAppCrmLeadsIndexRoute
  '/crm/my-work': typeof AuthenticatedAppCrmMyWorkIndexRoute
  '/crm/pipeline': typeof AuthenticatedAppCrmPipelineIndexRoute
  '/crm/reporting': typeof AuthenticatedAppCrmReportingIndexRoute
  '/crm/settings': typeof AuthenticatedAppCrmSettingsIndexRoute
  '/inspection/library': typeof AuthenticatedAppInspectionLibraryIndexRoute
  '/inspection/sites': typeof AuthenticatedAppInspectionSitesIndexRoute
  '/inspection/templates': typeof AuthenticatedAppInspectionTemplatesIndexRoute
  '/inspection/upcoming': typeof AuthenticatedAppInspectionUpcomingIndexRoute
  '/member-portal/manage': typeof AuthenticatedAppMemberPortalManageIndexRoute
  '/settings/audit': typeof AuthenticatedAppSettingsAuditIndexRoute
  '/settings/billing': typeof AuthenticatedAppSettingsBillingIndexRoute
  '/settings/meeting': typeof AuthenticatedAppSettingsMeetingIndexRoute
  '/settings/roles': typeof AuthenticatedAppSettingsRolesIndexRoute
  '/chain/courses/$courseId/manage': typeof AuthenticatedAppChainCoursesCourseIdManageRoute
  '/crm/settings/pipelines/$pipelineId': typeof AuthenticatedAppCrmSettingsPipelinesPipelineIdRoute
  '/inspection/inspections/$inspectionId/capture': typeof AuthenticatedAppInspectionInspectionsInspectionIdCaptureRoute
  '/inspection/inspections/$inspectionId/captures': typeof AuthenticatedAppInspectionInspectionsInspectionIdCapturesRoute
  '/inspection/inspections/$inspectionId/evidence': typeof AuthenticatedAppInspectionInspectionsInspectionIdEvidenceRoute
  '/inspection/inspections/$inspectionId/progress': typeof AuthenticatedAppInspectionInspectionsInspectionIdProgressRoute
  '/member-portal/campaigns/by-id/$id': typeof AuthenticatedAppMemberPortalCampaignsByIdIdRoute
  '/member-portal/manage/agreements/$id': typeof AuthenticatedAppMemberPortalManageAgreementsIdRoute
  '/member-portal/manage/branding/$id': typeof AuthenticatedAppMemberPortalManageBrandingIdRoute
  '/member-portal/manage/campaigns/$id': typeof AuthenticatedAppMemberPortalManageCampaignsIdRoute
  '/member-portal/manage/communications/$id': typeof AuthenticatedAppMemberPortalManageCommunicationsIdRoute
  '/member-portal/manage/contacts/$id': typeof AuthenticatedAppMemberPortalManageContactsIdRoute
  '/member-portal/manage/suppliers/$id': typeof AuthenticatedAppMemberPortalManageSuppliersIdRoute
  '/member-portal/manage/tools/$id': typeof AuthenticatedAppMemberPortalManageToolsIdRoute
  '/record-and-send/video-types/$videoTypeId/requests': typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRequestsRoute
  '/record-and-send/video-types/$videoTypeId/settings': typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdSettingsRoute
  '/record-and-send/video-types/$videoTypeId/videos': typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdVideosRoute
  '/settings/billing/pricing/checkout': typeof AuthenticatedAppSettingsBillingPricingCheckoutRoute
  '/staffing/postings/$id/edit': typeof AuthenticatedAppStaffingPostingsIdEditRoute
  '/chain/companies/$memberId': typeof AuthenticatedAppChainCompaniesMemberIdIndexRoute
  '/crm/settings/pipelines': typeof AuthenticatedAppCrmSettingsPipelinesIndexRoute
  '/inspection/inspections/$inspectionId': typeof AuthenticatedAppInspectionInspectionsInspectionIdIndexRoute
  '/record-and-send/video-types/$videoTypeId': typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdIndexRoute
  '/settings/billing/pricing': typeof AuthenticatedAppSettingsBillingPricingIndexRoute
  '/crm/deals/$dealId/offers/$versionId': typeof AuthenticatedAppCrmDealsDealIdOffersVersionIdRoute
  '/settings/audit/timeline/$targetType/$targetId': typeof AuthenticatedAppSettingsAuditTimelineTargetTypeTargetIdRoute
  '/chain/companies/$memberId/inspections/$inspectionId/progress': typeof AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdProgressRoute
  '/crm/deals/$dealId/offers/$versionId/edit': typeof AuthenticatedAppCrmDealsDealIdOffersVersionIdEditRoute
  '/member-portal/manage/communications/$id/responses/$companyId': typeof AuthenticatedAppMemberPortalManageCommunicationsIdResponsesCompanyIdRoute
  '/chain/companies/$memberId/inspections/$inspectionId': typeof AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_oauth': typeof OauthRouteRouteWithChildren
  '/customer': typeof CustomerRouteRouteWithChildren
  '/prototype': typeof PrototypeRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/accept-invitation-token': typeof AcceptInvitationTokenRoute
  '/calendar-callback': typeof CalendarCallbackRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/meeting-end': typeof MeetingEndRoute
  '/signup': typeof SignupRoute
  '/upgrades': typeof UpgradesRoute
  '/_authenticated/_app': typeof AuthenticatedAppRouteRouteWithChildren
  '/_authenticated/super-admin': typeof AuthenticatedSuperAdminRouteRouteWithChildren
  '/customer/_customer-authenticated': typeof CustomerCustomerAuthenticatedRouteRouteWithChildren
  '/.well-known/change-password': typeof DotwellKnownChangePasswordRoute
  '/_authenticated/connected-companies': typeof AuthenticatedConnectedCompaniesRoute
  '/_authenticated/create-company': typeof AuthenticatedCreateCompanyRoute
  '/_authenticated/link-account': typeof AuthenticatedLinkAccountRoute
  '/_authenticated/practice-call': typeof AuthenticatedPracticeCallRoute
  '/book-meeting/$slug': typeof BookMeetingSlugRoute
  '/cancel-booking/$slug': typeof CancelBookingSlugRoute
  '/customer/forgot-password': typeof CustomerForgotPasswordRoute
  '/customer/login': typeof CustomerLoginRoute
  '/customer/reset-password': typeof CustomerResetPasswordRoute
  '/forms/$slug': typeof FormsSlugRoute
  '/join/$meetingId': typeof JoinMeetingIdRoute
  '/meeting-summary/$token': typeof MeetingSummaryTokenRoute
  '/oauth/error': typeof OauthErrorRoute
  '/offer/$token': typeof OfferTokenRoute
  '/record/$meetingId': typeof RecordMeetingIdRoute
  '/recording/share': typeof RecordingShareRoute
  '/unsubscribe-email/$email': typeof UnsubscribeEmailEmailRoute
  '/v/$secret': typeof VSecretRoute
  '/video/$publicId': typeof VideoPublicIdRoute
  '/itxframe/': typeof ItxframeIndexRoute
  '/prototype/': typeof PrototypeIndexRoute
  '/_authenticated/_app/bookings': typeof AuthenticatedAppBookingsRouteRouteWithChildren
  '/_authenticated/_app/chain': typeof AuthenticatedAppChainRouteRouteWithChildren
  '/_authenticated/_app/crm': typeof AuthenticatedAppCrmRouteRouteWithChildren
  '/_authenticated/_app/forms': typeof AuthenticatedAppFormsRouteRouteWithChildren
  '/_authenticated/_app/inspection': typeof AuthenticatedAppInspectionRouteRouteWithChildren
  '/_authenticated/_app/invoicing': typeof AuthenticatedAppInvoicingRouteRouteWithChildren
  '/_authenticated/_app/member-portal': typeof AuthenticatedAppMemberPortalRouteRouteWithChildren
  '/_authenticated/_app/orders': typeof AuthenticatedAppOrdersRouteRouteWithChildren
  '/_authenticated/_app/settings': typeof AuthenticatedAppSettingsRouteRouteWithChildren
  '/_authenticated/_app/staffing': typeof AuthenticatedAppStaffingRouteRouteWithChildren
  '/_authenticated/_app/calendar': typeof AuthenticatedAppCalendarRoute
  '/_authenticated/_app/checklist': typeof AuthenticatedAppChecklistRoute
  '/_authenticated/_app/dashboard': typeof AuthenticatedAppDashboardRoute
  '/_authenticated/_app/getting-started': typeof AuthenticatedAppGettingStartedRoute
  '/_authenticated/_app/meetings': typeof AuthenticatedAppMeetingsRoute
  '/_authenticated/_app/recording': typeof AuthenticatedAppRecordingRoute
  '/_authenticated/_app/resources': typeof AuthenticatedAppResourcesRoute
  '/_authenticated/_app/team-learning': typeof AuthenticatedAppTeamLearningRoute
  '/_authenticated/super-admin/admins': typeof AuthenticatedSuperAdminAdminsRoute
  '/_authenticated/super-admin/audit': typeof AuthenticatedSuperAdminAuditRoute
  '/_authenticated/super-admin/company-activity': typeof AuthenticatedSuperAdminCompanyActivityRoute
  '/_authenticated/super-admin/connected-apps': typeof AuthenticatedSuperAdminConnectedAppsRoute
  '/_authenticated/super-admin/email-logs': typeof AuthenticatedSuperAdminEmailLogsRoute
  '/_authenticated/super-admin/feedback': typeof AuthenticatedSuperAdminFeedbackRoute
  '/_authenticated/super-admin/impersonation-logs': typeof AuthenticatedSuperAdminImpersonationLogsRoute
  '/_authenticated/super-admin/inspection-library': typeof AuthenticatedSuperAdminInspectionLibraryRoute
  '/_authenticated/super-admin/mcp-activity': typeof AuthenticatedSuperAdminMcpActivityRoute
  '/_authenticated/super-admin/mcp-adoption': typeof AuthenticatedSuperAdminMcpAdoptionRoute
  '/_authenticated/super-admin/mobile-adoption': typeof AuthenticatedSuperAdminMobileAdoptionRoute
  '/_authenticated/super-admin/record-and-send': typeof AuthenticatedSuperAdminRecordAndSendRoute
  '/_authenticated/super-admin/sms-logs': typeof AuthenticatedSuperAdminSmsLogsRoute
  '/_authenticated/super-admin/suppression-list': typeof AuthenticatedSuperAdminSuppressionListRoute
  '/_authenticated/super-admin/transcription-monitor': typeof AuthenticatedSuperAdminTranscriptionMonitorRoute
  '/_authenticated/super-admin/unsubscribe-list': typeof AuthenticatedSuperAdminUnsubscribeListRoute
  '/_oauth/oauth/consent': typeof OauthOauthConsentRoute
  '/_oauth/oauth/resume': typeof OauthOauthResumeRoute
  '/_oauth/oauth/select-company': typeof OauthOauthSelectCompanyRoute
  '/customer/_customer-authenticated/change-password': typeof CustomerCustomerAuthenticatedChangePasswordRoute
  '/customer/_customer-authenticated/profile': typeof CustomerCustomerAuthenticatedProfileRoute
  '/forms/additional/$token': typeof FormsAdditionalTokenRoute
  '/prototype/$slug/$screen': typeof PrototypeSlugScreenRoute
  '/_authenticated/super-admin/': typeof AuthenticatedSuperAdminIndexRoute
  '/_authenticated/_app/crm/settings': typeof AuthenticatedAppCrmSettingsRouteRouteWithChildren
  '/_authenticated/_app/member-portal/manage': typeof AuthenticatedAppMemberPortalManageRouteRouteWithChildren
  '/_authenticated/_app/settings/audit': typeof AuthenticatedAppSettingsAuditRouteRouteWithChildren
  '/_authenticated/_app/settings/billing': typeof AuthenticatedAppSettingsBillingRouteRouteWithChildren
  '/_authenticated/_app/bookings/blackout-dates': typeof AuthenticatedAppBookingsBlackoutDatesRoute
  '/_authenticated/_app/bookings/customize': typeof AuthenticatedAppBookingsCustomizeRoute
  '/_authenticated/_app/bookings/dashboard': typeof AuthenticatedAppBookingsDashboardRoute
  '/_authenticated/_app/bookings/manage': typeof AuthenticatedAppBookingsManageRoute
  '/_authenticated/_app/bookings/services': typeof AuthenticatedAppBookingsServicesRoute
  '/_authenticated/_app/bookings/tracking': typeof AuthenticatedAppBookingsTrackingRoute
  '/_authenticated/_app/chain/analytics': typeof AuthenticatedAppChainAnalyticsRoute
  '/_authenticated/_app/chain/competence': typeof AuthenticatedAppChainCompetenceRoute
  '/_authenticated/_app/chain/config-pushes': typeof AuthenticatedAppChainConfigPushesRoute
  '/_authenticated/_app/chain/coverage': typeof AuthenticatedAppChainCoverageRoute
  '/_authenticated/_app/chain/endorsement': typeof AuthenticatedAppChainEndorsementRoute
  '/_authenticated/_app/chain/learning': typeof AuthenticatedAppChainLearningRoute
  '/_authenticated/_app/chain/master-catalog': typeof AuthenticatedAppChainMasterCatalogRoute
  '/_authenticated/_app/chain/members': typeof AuthenticatedAppChainMembersRoute
  '/_authenticated/_app/chain/my-endorsement': typeof AuthenticatedAppChainMyEndorsementRoute
  '/_authenticated/_app/chain/order-pipeline': typeof AuthenticatedAppChainOrderPipelineRoute
  '/_authenticated/_app/chain/quick-links': typeof AuthenticatedAppChainQuickLinksRoute
  '/_authenticated/_app/chain/resources': typeof AuthenticatedAppChainResourcesRoute
  '/_authenticated/_app/chain/staffing': typeof AuthenticatedAppChainStaffingRoute
  '/_authenticated/_app/competence/approvals': typeof AuthenticatedAppCompetenceApprovalsRoute
  '/_authenticated/_app/competence/matrix': typeof AuthenticatedAppCompetenceMatrixRoute
  '/_authenticated/_app/competence/me': typeof AuthenticatedAppCompetenceMeRoute
  '/_authenticated/_app/competence/types': typeof AuthenticatedAppCompetenceTypesRoute
  '/_authenticated/_app/courses/$courseId': typeof AuthenticatedAppCoursesCourseIdRoute
  '/_authenticated/_app/courses/create': typeof AuthenticatedAppCoursesCreateRoute
  '/_authenticated/_app/history/$meetingID': typeof AuthenticatedAppHistoryMeetingIDRoute
  '/_authenticated/_app/invoicing/$invoiceId': typeof AuthenticatedAppInvoicingInvoiceIdRoute
  '/_authenticated/_app/member-portal/about': typeof AuthenticatedAppMemberPortalAboutRoute
  '/_authenticated/_app/member-portal/agreements': typeof AuthenticatedAppMemberPortalAgreementsRouteWithChildren
  '/_authenticated/_app/member-portal/branding': typeof AuthenticatedAppMemberPortalBrandingRoute
  '/_authenticated/_app/member-portal/campaigns': typeof AuthenticatedAppMemberPortalCampaignsRouteWithChildren
  '/_authenticated/_app/member-portal/communications': typeof AuthenticatedAppMemberPortalCommunicationsRouteWithChildren
  '/_authenticated/_app/member-portal/contacts': typeof AuthenticatedAppMemberPortalContactsRoute
  '/_authenticated/_app/member-portal/overview': typeof AuthenticatedAppMemberPortalOverviewRoute
  '/_authenticated/_app/member-portal/suppliers': typeof AuthenticatedAppMemberPortalSuppliersRouteWithChildren
  '/_authenticated/_app/member-portal/tools': typeof AuthenticatedAppMemberPortalToolsRouteWithChildren
  '/_authenticated/_app/my/learning': typeof AuthenticatedAppMyLearningRoute
  '/_authenticated/_app/orders/$orderId': typeof AuthenticatedAppOrdersOrderIdRoute
  '/_authenticated/_app/orders/reports': typeof AuthenticatedAppOrdersReportsRoute
  '/_authenticated/_app/settings/access': typeof AuthenticatedAppSettingsAccessRoute
  '/_authenticated/_app/settings/ai-settings': typeof AuthenticatedAppSettingsAiSettingsRoute
  '/_authenticated/_app/settings/api-keys': typeof AuthenticatedAppSettingsApiKeysRoute
  '/_authenticated/_app/settings/company': typeof AuthenticatedAppSettingsCompanyRoute
  '/_authenticated/_app/settings/connected-apps': typeof AuthenticatedAppSettingsConnectedAppsRoute
  '/_authenticated/_app/settings/members': typeof AuthenticatedAppSettingsMembersRoute
  '/_authenticated/_app/settings/notifications': typeof AuthenticatedAppSettingsNotificationsRoute
  '/_authenticated/_app/settings/order-settings': typeof AuthenticatedAppSettingsOrderSettingsRoute
  '/_authenticated/_app/settings/profile': typeof AuthenticatedAppSettingsProfileRoute
  '/_authenticated/_app/settings/service-area': typeof AuthenticatedAppSettingsServiceAreaRoute
  '/_authenticated/_app/settings/service-types': typeof AuthenticatedAppSettingsServiceTypesRoute
  '/_authenticated/_app/settings/usage': typeof AuthenticatedAppSettingsUsageRoute
  '/_authenticated/_app/settings/white-labeling': typeof AuthenticatedAppSettingsWhiteLabelingRoute
  '/_authenticated/_app/staffing/categories': typeof AuthenticatedAppStaffingCategoriesRoute
  '/_authenticated/_app/staffing/my-interests': typeof AuthenticatedAppStaffingMyInterestsRoute
  '/_authenticated/_app/staffing/my-postings': typeof AuthenticatedAppStaffingMyPostingsRoute
  '/_authenticated/_app/staffing/pending-approvals': typeof AuthenticatedAppStaffingPendingApprovalsRoute
  '/_authenticated/_app/staffing/skill-levels': typeof AuthenticatedAppStaffingSkillLevelsRoute
  '/_authenticated/_app/staffing/skills': typeof AuthenticatedAppStaffingSkillsRoute
  '/_authenticated/super-admin/ai-ops/cost': typeof AuthenticatedSuperAdminAiOpsCostRoute
  '/_authenticated/super-admin/ai-ops/runs': typeof AuthenticatedSuperAdminAiOpsRunsRoute
  '/_authenticated/super-admin/chains/$parentCompanyId': typeof AuthenticatedSuperAdminChainsParentCompanyIdRoute
  '/_authenticated/super-admin/companies/$companyId': typeof AuthenticatedSuperAdminCompaniesCompanyIdRoute
  '/_authenticated/super-admin/industry-presets/$id': typeof AuthenticatedSuperAdminIndustryPresetsIdRoute
  '/_authenticated/super-admin/industry-presets/new': typeof AuthenticatedSuperAdminIndustryPresetsNewRoute
  '/_authenticated/super-admin/login-security/settings': typeof AuthenticatedSuperAdminLoginSecuritySettingsRoute
  '/_authenticated/super-admin/meeting-telemetry/$meetingId': typeof AuthenticatedSuperAdminMeetingTelemetryMeetingIdRoute
  '/_authenticated/super-admin/users/$userId': typeof AuthenticatedSuperAdminUsersUserIdRoute
  '/customer/_customer-authenticated/orders/$orderId': typeof CustomerCustomerAuthenticatedOrdersOrderIdRoute
  '/_authenticated/_app/bookings/': typeof AuthenticatedAppBookingsIndexRoute
  '/_authenticated/_app/competence/': typeof AuthenticatedAppCompetenceIndexRoute
  '/_authenticated/_app/courses/': typeof AuthenticatedAppCoursesIndexRoute
  '/_authenticated/_app/crm/': typeof AuthenticatedAppCrmIndexRoute
  '/_authenticated/_app/forms/': typeof AuthenticatedAppFormsIndexRoute
  '/_authenticated/_app/inspection/': typeof AuthenticatedAppInspectionIndexRoute
  '/_authenticated/_app/invoicing/': typeof AuthenticatedAppInvoicingIndexRoute
  '/_authenticated/_app/member-portal/': typeof AuthenticatedAppMemberPortalIndexRoute
  '/_authenticated/_app/orders/': typeof AuthenticatedAppOrdersIndexRoute
  '/_authenticated/_app/record-and-send/': typeof AuthenticatedAppRecordAndSendIndexRoute
  '/_authenticated/_app/settings/': typeof AuthenticatedAppSettingsIndexRoute
  '/_authenticated/_app/staffing/': typeof AuthenticatedAppStaffingIndexRoute
  '/_authenticated/super-admin/ai-ops/': typeof AuthenticatedSuperAdminAiOpsIndexRoute
  '/_authenticated/super-admin/chains/': typeof AuthenticatedSuperAdminChainsIndexRoute
  '/_authenticated/super-admin/companies/': typeof AuthenticatedSuperAdminCompaniesIndexRoute
  '/_authenticated/super-admin/industry-presets/': typeof AuthenticatedSuperAdminIndustryPresetsIndexRoute
  '/_authenticated/super-admin/login-security/': typeof AuthenticatedSuperAdminLoginSecurityIndexRoute
  '/_authenticated/super-admin/meeting-telemetry/': typeof AuthenticatedSuperAdminMeetingTelemetryIndexRoute
  '/_authenticated/super-admin/users/': typeof AuthenticatedSuperAdminUsersIndexRoute
  '/customer/_customer-authenticated/orders/': typeof CustomerCustomerAuthenticatedOrdersIndexRoute
  '/_authenticated/_app/chain/companies/$memberId': typeof AuthenticatedAppChainCompaniesMemberIdRouteRouteWithChildren
  '/_authenticated/_app/inspection/inspections/$inspectionId': typeof AuthenticatedAppInspectionInspectionsInspectionIdRouteRouteWithChildren
  '/_authenticated/_app/record-and-send/video-types/$videoTypeId': typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRouteWithChildren
  '/_authenticated/_app/chain/announcements/$announcementId': typeof AuthenticatedAppChainAnnouncementsAnnouncementIdRoute
  '/_authenticated/_app/competence/user/$userId': typeof AuthenticatedAppCompetenceUserUserIdRoute
  '/_authenticated/_app/courses/$courseId_/edit': typeof AuthenticatedAppCoursesCourseIdEditRoute
  '/_authenticated/_app/crm/chain/distribution': typeof AuthenticatedAppCrmChainDistributionRoute
  '/_authenticated/_app/crm/chain/members': typeof AuthenticatedAppCrmChainMembersRoute
  '/_authenticated/_app/crm/chain/parent-incoming': typeof AuthenticatedAppCrmChainParentIncomingRoute
  '/_authenticated/_app/crm/chain/pipeline': typeof AuthenticatedAppCrmChainPipelineRoute
  '/_authenticated/_app/crm/companies/$id': typeof AuthenticatedAppCrmCompaniesIdRoute
  '/_authenticated/_app/crm/contacts/$contactId': typeof AuthenticatedAppCrmContactsContactIdRoute
  '/_authenticated/_app/crm/deals/$dealId': typeof AuthenticatedAppCrmDealsDealIdRoute
  '/_authenticated/_app/crm/leads/$leadId': typeof AuthenticatedAppCrmLeadsLeadIdRoute
  '/_authenticated/_app/crm/pipeline/$pipelineId': typeof AuthenticatedAppCrmPipelinePipelineIdRoute
  '/_authenticated/_app/crm/settings/company-fields': typeof AuthenticatedAppCrmSettingsCompanyFieldsRoute
  '/_authenticated/_app/crm/settings/contact-fields': typeof AuthenticatedAppCrmSettingsContactFieldsRoute
  '/_authenticated/_app/crm/settings/deal-fields': typeof AuthenticatedAppCrmSettingsDealFieldsRoute
  '/_authenticated/_app/crm/settings/lost-reasons': typeof AuthenticatedAppCrmSettingsLostReasonsRoute
  '/_authenticated/_app/crm/settings/offer-defaults': typeof AuthenticatedAppCrmSettingsOfferDefaultsRoute
  '/_authenticated/_app/crm/settings/order-pipeline': typeof AuthenticatedAppCrmSettingsOrderPipelineRoute
  '/_authenticated/_app/forms/$formId/analytics': typeof AuthenticatedAppFormsFormIdAnalyticsRoute
  '/_authenticated/_app/forms/$formId/designer': typeof AuthenticatedAppFormsFormIdDesignerRoute
  '/_authenticated/_app/forms/$formId/submissions': typeof AuthenticatedAppFormsFormIdSubmissionsRoute
  '/_authenticated/_app/inspection/sites/$siteId': typeof AuthenticatedAppInspectionSitesSiteIdRoute
  '/_authenticated/_app/inspection/templates/$templateId': typeof AuthenticatedAppInspectionTemplatesTemplateIdRoute
  '/_authenticated/_app/invoicing/prepare/$orderId': typeof AuthenticatedAppInvoicingPrepareOrderIdRoute
  '/_authenticated/_app/member-portal/agreements/$id': typeof AuthenticatedAppMemberPortalAgreementsIdRoute
  '/_authenticated/_app/member-portal/branding_/$id': typeof AuthenticatedAppMemberPortalBrandingIdRoute
  '/_authenticated/_app/member-portal/campaigns/$slug': typeof AuthenticatedAppMemberPortalCampaignsSlugRoute
  '/_authenticated/_app/member-portal/communications/$id': typeof AuthenticatedAppMemberPortalCommunicationsIdRoute
  '/_authenticated/_app/member-portal/manage/about': typeof AuthenticatedAppMemberPortalManageAboutRoute
  '/_authenticated/_app/member-portal/manage/agreements': typeof AuthenticatedAppMemberPortalManageAgreementsRouteWithChildren
  '/_authenticated/_app/member-portal/manage/branding': typeof AuthenticatedAppMemberPortalManageBrandingRouteWithChildren
  '/_authenticated/_app/member-portal/manage/campaigns': typeof AuthenticatedAppMemberPortalManageCampaignsRouteWithChildren
  '/_authenticated/_app/member-portal/manage/communications': typeof AuthenticatedAppMemberPortalManageCommunicationsRouteWithChildren
  '/_authenticated/_app/member-portal/manage/contacts': typeof AuthenticatedAppMemberPortalManageContactsRouteWithChildren
  '/_authenticated/_app/member-portal/manage/suppliers': typeof AuthenticatedAppMemberPortalManageSuppliersRouteWithChildren
  '/_authenticated/_app/member-portal/manage/tools': typeof AuthenticatedAppMemberPortalManageToolsRouteWithChildren
  '/_authenticated/_app/member-portal/suppliers/$id': typeof AuthenticatedAppMemberPortalSuppliersIdRoute
  '/_authenticated/_app/member-portal/tools/$id': typeof AuthenticatedAppMemberPortalToolsIdRoute
  '/_authenticated/_app/record-and-send/submissions/$submissionId': typeof AuthenticatedAppRecordAndSendSubmissionsSubmissionIdRoute
  '/_authenticated/_app/record-and-send/video-types/new': typeof AuthenticatedAppRecordAndSendVideoTypesNewRoute
  '/_authenticated/_app/settings/billing/addons': typeof AuthenticatedAppSettingsBillingAddonsRoute
  '/_authenticated/_app/settings/billing/payments': typeof AuthenticatedAppSettingsBillingPaymentsRoute
  '/_authenticated/_app/settings/invoicing/accounting': typeof AuthenticatedAppSettingsInvoicingAccountingRoute
  '/_authenticated/_app/settings/meeting/background': typeof AuthenticatedAppSettingsMeetingBackgroundRoute
  '/_authenticated/_app/settings/meeting/defaults': typeof AuthenticatedAppSettingsMeetingDefaultsRoute
  '/_authenticated/_app/settings/meeting/recording': typeof AuthenticatedAppSettingsMeetingRecordingRoute
  '/_authenticated/_app/settings/orders/pipeline': typeof AuthenticatedAppSettingsOrdersPipelineRoute
  '/_authenticated/_app/settings/roles/$roleId': typeof AuthenticatedAppSettingsRolesRoleIdRoute
  '/_authenticated/_app/settings/roles/new': typeof AuthenticatedAppSettingsRolesNewRoute
  '/_authenticated/_app/staffing/postings/$id': typeof AuthenticatedAppStaffingPostingsIdRoute
  '/_authenticated/_app/staffing/postings/new': typeof AuthenticatedAppStaffingPostingsNewRoute
  '/_authenticated/super-admin/companies/$companyId_/roles': typeof AuthenticatedSuperAdminCompaniesCompanyIdRolesRoute
  '/_authenticated/_app/chain/announcements/': typeof AuthenticatedAppChainAnnouncementsIndexRoute
  '/_authenticated/_app/chain/courses/': typeof AuthenticatedAppChainCoursesIndexRoute
  '/_authenticated/_app/crm/catalog/': typeof AuthenticatedAppCrmCatalogIndexRoute
  '/_authenticated/_app/crm/companies/': typeof AuthenticatedAppCrmCompaniesIndexRoute
  '/_authenticated/_app/crm/contacts/': typeof AuthenticatedAppCrmContactsIndexRoute
  '/_authenticated/_app/crm/deals/': typeof AuthenticatedAppCrmDealsIndexRoute
  '/_authenticated/_app/crm/duplicates/': typeof AuthenticatedAppCrmDuplicatesIndexRoute
  '/_authenticated/_app/crm/leads/': typeof AuthenticatedAppCrmLeadsIndexRoute
  '/_authenticated/_app/crm/my-work/': typeof AuthenticatedAppCrmMyWorkIndexRoute
  '/_authenticated/_app/crm/pipeline/': typeof AuthenticatedAppCrmPipelineIndexRoute
  '/_authenticated/_app/crm/reporting/': typeof AuthenticatedAppCrmReportingIndexRoute
  '/_authenticated/_app/crm/settings/': typeof AuthenticatedAppCrmSettingsIndexRoute
  '/_authenticated/_app/inspection/library/': typeof AuthenticatedAppInspectionLibraryIndexRoute
  '/_authenticated/_app/inspection/sites/': typeof AuthenticatedAppInspectionSitesIndexRoute
  '/_authenticated/_app/inspection/templates/': typeof AuthenticatedAppInspectionTemplatesIndexRoute
  '/_authenticated/_app/inspection/upcoming/': typeof AuthenticatedAppInspectionUpcomingIndexRoute
  '/_authenticated/_app/member-portal/manage/': typeof AuthenticatedAppMemberPortalManageIndexRoute
  '/_authenticated/_app/settings/audit/': typeof AuthenticatedAppSettingsAuditIndexRoute
  '/_authenticated/_app/settings/billing/': typeof AuthenticatedAppSettingsBillingIndexRoute
  '/_authenticated/_app/settings/meeting/': typeof AuthenticatedAppSettingsMeetingIndexRoute
  '/_authenticated/_app/settings/roles/': typeof AuthenticatedAppSettingsRolesIndexRoute
  '/_authenticated/_app/chain/courses/$courseId/manage': typeof AuthenticatedAppChainCoursesCourseIdManageRoute
  '/_authenticated/_app/crm/settings/pipelines/$pipelineId': typeof AuthenticatedAppCrmSettingsPipelinesPipelineIdRoute
  '/_authenticated/_app/inspection/inspections/$inspectionId/capture': typeof AuthenticatedAppInspectionInspectionsInspectionIdCaptureRoute
  '/_authenticated/_app/inspection/inspections/$inspectionId/captures': typeof AuthenticatedAppInspectionInspectionsInspectionIdCapturesRoute
  '/_authenticated/_app/inspection/inspections/$inspectionId/evidence': typeof AuthenticatedAppInspectionInspectionsInspectionIdEvidenceRoute
  '/_authenticated/_app/inspection/inspections/$inspectionId/progress': typeof AuthenticatedAppInspectionInspectionsInspectionIdProgressRoute
  '/_authenticated/_app/member-portal/campaigns/by-id/$id': typeof AuthenticatedAppMemberPortalCampaignsByIdIdRoute
  '/_authenticated/_app/member-portal/manage/agreements/$id': typeof AuthenticatedAppMemberPortalManageAgreementsIdRoute
  '/_authenticated/_app/member-portal/manage/branding/$id': typeof AuthenticatedAppMemberPortalManageBrandingIdRoute
  '/_authenticated/_app/member-portal/manage/campaigns/$id': typeof AuthenticatedAppMemberPortalManageCampaignsIdRoute
  '/_authenticated/_app/member-portal/manage/communications/$id': typeof AuthenticatedAppMemberPortalManageCommunicationsIdRoute
  '/_authenticated/_app/member-portal/manage/contacts/$id': typeof AuthenticatedAppMemberPortalManageContactsIdRoute
  '/_authenticated/_app/member-portal/manage/suppliers/$id': typeof AuthenticatedAppMemberPortalManageSuppliersIdRoute
  '/_authenticated/_app/member-portal/manage/tools/$id': typeof AuthenticatedAppMemberPortalManageToolsIdRoute
  '/_authenticated/_app/record-and-send/video-types/$videoTypeId/requests': typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRequestsRoute
  '/_authenticated/_app/record-and-send/video-types/$videoTypeId/settings': typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdSettingsRoute
  '/_authenticated/_app/record-and-send/video-types/$videoTypeId/videos': typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdVideosRoute
  '/_authenticated/_app/settings/billing/pricing/checkout': typeof AuthenticatedAppSettingsBillingPricingCheckoutRoute
  '/_authenticated/_app/staffing/postings/$id_/edit': typeof AuthenticatedAppStaffingPostingsIdEditRoute
  '/_authenticated/_app/chain/companies/$memberId/': typeof AuthenticatedAppChainCompaniesMemberIdIndexRoute
  '/_authenticated/_app/crm/settings/pipelines/': typeof AuthenticatedAppCrmSettingsPipelinesIndexRoute
  '/_authenticated/_app/inspection/inspections/$inspectionId/': typeof AuthenticatedAppInspectionInspectionsInspectionIdIndexRoute
  '/_authenticated/_app/record-and-send/video-types/$videoTypeId/': typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdIndexRoute
  '/_authenticated/_app/settings/billing/pricing/': typeof AuthenticatedAppSettingsBillingPricingIndexRoute
  '/_authenticated/_app/crm/deals/$dealId_/offers/$versionId': typeof AuthenticatedAppCrmDealsDealIdOffersVersionIdRoute
  '/_authenticated/_app/settings/audit/timeline/$targetType/$targetId': typeof AuthenticatedAppSettingsAuditTimelineTargetTypeTargetIdRoute
  '/_authenticated/_app/chain/companies/$memberId/inspections/$inspectionId/progress': typeof AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdProgressRoute
  '/_authenticated/_app/crm/deals/$dealId_/offers/$versionId_/edit': typeof AuthenticatedAppCrmDealsDealIdOffersVersionIdEditRoute
  '/_authenticated/_app/member-portal/manage/communications/$id_/responses/$companyId': typeof AuthenticatedAppMemberPortalManageCommunicationsIdResponsesCompanyIdRoute
  '/_authenticated/_app/chain/companies/$memberId/inspections/$inspectionId/': typeof AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/customer'
    | '/prototype'
    | '/$'
    | '/accept-invitation'
    | '/accept-invitation-token'
    | '/calendar-callback'
    | '/forgot-password'
    | '/login'
    | '/meeting-end'
    | '/signup'
    | '/upgrades'
    | '/super-admin'
    | '/.well-known/change-password'
    | '/connected-companies'
    | '/create-company'
    | '/link-account'
    | '/practice-call'
    | '/book-meeting/$slug'
    | '/cancel-booking/$slug'
    | '/customer/forgot-password'
    | '/customer/login'
    | '/customer/reset-password'
    | '/forms/$slug'
    | '/join/$meetingId'
    | '/meeting-summary/$token'
    | '/oauth/error'
    | '/offer/$token'
    | '/record/$meetingId'
    | '/recording/share'
    | '/unsubscribe-email/$email'
    | '/v/$secret'
    | '/video/$publicId'
    | '/itxframe/'
    | '/prototype/'
    | '/bookings'
    | '/chain'
    | '/crm'
    | '/forms'
    | '/inspection'
    | '/invoicing'
    | '/member-portal'
    | '/orders'
    | '/settings'
    | '/staffing'
    | '/calendar'
    | '/checklist'
    | '/dashboard'
    | '/getting-started'
    | '/meetings'
    | '/recording'
    | '/resources'
    | '/team-learning'
    | '/super-admin/admins'
    | '/super-admin/audit'
    | '/super-admin/company-activity'
    | '/super-admin/connected-apps'
    | '/super-admin/email-logs'
    | '/super-admin/feedback'
    | '/super-admin/impersonation-logs'
    | '/super-admin/inspection-library'
    | '/super-admin/mcp-activity'
    | '/super-admin/mcp-adoption'
    | '/super-admin/mobile-adoption'
    | '/super-admin/record-and-send'
    | '/super-admin/sms-logs'
    | '/super-admin/suppression-list'
    | '/super-admin/transcription-monitor'
    | '/super-admin/unsubscribe-list'
    | '/oauth/consent'
    | '/oauth/resume'
    | '/oauth/select-company'
    | '/customer/change-password'
    | '/customer/profile'
    | '/forms/additional/$token'
    | '/prototype/$slug/$screen'
    | '/super-admin/'
    | '/crm/settings'
    | '/member-portal/manage'
    | '/settings/audit'
    | '/settings/billing'
    | '/bookings/blackout-dates'
    | '/bookings/customize'
    | '/bookings/dashboard'
    | '/bookings/manage'
    | '/bookings/services'
    | '/bookings/tracking'
    | '/chain/analytics'
    | '/chain/competence'
    | '/chain/config-pushes'
    | '/chain/coverage'
    | '/chain/endorsement'
    | '/chain/learning'
    | '/chain/master-catalog'
    | '/chain/members'
    | '/chain/my-endorsement'
    | '/chain/order-pipeline'
    | '/chain/quick-links'
    | '/chain/resources'
    | '/chain/staffing'
    | '/competence/approvals'
    | '/competence/matrix'
    | '/competence/me'
    | '/competence/types'
    | '/courses/$courseId'
    | '/courses/create'
    | '/history/$meetingID'
    | '/invoicing/$invoiceId'
    | '/member-portal/about'
    | '/member-portal/agreements'
    | '/member-portal/branding'
    | '/member-portal/campaigns'
    | '/member-portal/communications'
    | '/member-portal/contacts'
    | '/member-portal/overview'
    | '/member-portal/suppliers'
    | '/member-portal/tools'
    | '/my/learning'
    | '/orders/$orderId'
    | '/orders/reports'
    | '/settings/access'
    | '/settings/ai-settings'
    | '/settings/api-keys'
    | '/settings/company'
    | '/settings/connected-apps'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/order-settings'
    | '/settings/profile'
    | '/settings/service-area'
    | '/settings/service-types'
    | '/settings/usage'
    | '/settings/white-labeling'
    | '/staffing/categories'
    | '/staffing/my-interests'
    | '/staffing/my-postings'
    | '/staffing/pending-approvals'
    | '/staffing/skill-levels'
    | '/staffing/skills'
    | '/super-admin/ai-ops/cost'
    | '/super-admin/ai-ops/runs'
    | '/super-admin/chains/$parentCompanyId'
    | '/super-admin/companies/$companyId'
    | '/super-admin/industry-presets/$id'
    | '/super-admin/industry-presets/new'
    | '/super-admin/login-security/settings'
    | '/super-admin/meeting-telemetry/$meetingId'
    | '/super-admin/users/$userId'
    | '/customer/orders/$orderId'
    | '/bookings/'
    | '/competence/'
    | '/courses/'
    | '/crm/'
    | '/forms/'
    | '/inspection/'
    | '/invoicing/'
    | '/member-portal/'
    | '/orders/'
    | '/record-and-send/'
    | '/settings/'
    | '/staffing/'
    | '/super-admin/ai-ops/'
    | '/super-admin/chains/'
    | '/super-admin/companies/'
    | '/super-admin/industry-presets/'
    | '/super-admin/login-security/'
    | '/super-admin/meeting-telemetry/'
    | '/super-admin/users/'
    | '/customer/orders/'
    | '/chain/companies/$memberId'
    | '/inspection/inspections/$inspectionId'
    | '/record-and-send/video-types/$videoTypeId'
    | '/chain/announcements/$announcementId'
    | '/competence/user/$userId'
    | '/courses/$courseId/edit'
    | '/crm/chain/distribution'
    | '/crm/chain/members'
    | '/crm/chain/parent-incoming'
    | '/crm/chain/pipeline'
    | '/crm/companies/$id'
    | '/crm/contacts/$contactId'
    | '/crm/deals/$dealId'
    | '/crm/leads/$leadId'
    | '/crm/pipeline/$pipelineId'
    | '/crm/settings/company-fields'
    | '/crm/settings/contact-fields'
    | '/crm/settings/deal-fields'
    | '/crm/settings/lost-reasons'
    | '/crm/settings/offer-defaults'
    | '/crm/settings/order-pipeline'
    | '/forms/$formId/analytics'
    | '/forms/$formId/designer'
    | '/forms/$formId/submissions'
    | '/inspection/sites/$siteId'
    | '/inspection/templates/$templateId'
    | '/invoicing/prepare/$orderId'
    | '/member-portal/agreements/$id'
    | '/member-portal/branding/$id'
    | '/member-portal/campaigns/$slug'
    | '/member-portal/communications/$id'
    | '/member-portal/manage/about'
    | '/member-portal/manage/agreements'
    | '/member-portal/manage/branding'
    | '/member-portal/manage/campaigns'
    | '/member-portal/manage/communications'
    | '/member-portal/manage/contacts'
    | '/member-portal/manage/suppliers'
    | '/member-portal/manage/tools'
    | '/member-portal/suppliers/$id'
    | '/member-portal/tools/$id'
    | '/record-and-send/submissions/$submissionId'
    | '/record-and-send/video-types/new'
    | '/settings/billing/addons'
    | '/settings/billing/payments'
    | '/settings/invoicing/accounting'
    | '/settings/meeting/background'
    | '/settings/meeting/defaults'
    | '/settings/meeting/recording'
    | '/settings/orders/pipeline'
    | '/settings/roles/$roleId'
    | '/settings/roles/new'
    | '/staffing/postings/$id'
    | '/staffing/postings/new'
    | '/super-admin/companies/$companyId/roles'
    | '/chain/announcements/'
    | '/chain/courses/'
    | '/crm/catalog/'
    | '/crm/companies/'
    | '/crm/contacts/'
    | '/crm/deals/'
    | '/crm/duplicates/'
    | '/crm/leads/'
    | '/crm/my-work/'
    | '/crm/pipeline/'
    | '/crm/reporting/'
    | '/crm/settings/'
    | '/inspection/library/'
    | '/inspection/sites/'
    | '/inspection/templates/'
    | '/inspection/upcoming/'
    | '/member-portal/manage/'
    | '/settings/audit/'
    | '/settings/billing/'
    | '/settings/meeting/'
    | '/settings/roles/'
    | '/chain/courses/$courseId/manage'
    | '/crm/settings/pipelines/$pipelineId'
    | '/inspection/inspections/$inspectionId/capture'
    | '/inspection/inspections/$inspectionId/captures'
    | '/inspection/inspections/$inspectionId/evidence'
    | '/inspection/inspections/$inspectionId/progress'
    | '/member-portal/campaigns/by-id/$id'
    | '/member-portal/manage/agreements/$id'
    | '/member-portal/manage/branding/$id'
    | '/member-portal/manage/campaigns/$id'
    | '/member-portal/manage/communications/$id'
    | '/member-portal/manage/contacts/$id'
    | '/member-portal/manage/suppliers/$id'
    | '/member-portal/manage/tools/$id'
    | '/record-and-send/video-types/$videoTypeId/requests'
    | '/record-and-send/video-types/$videoTypeId/settings'
    | '/record-and-send/video-types/$videoTypeId/videos'
    | '/settings/billing/pricing/checkout'
    | '/staffing/postings/$id/edit'
    | '/chain/companies/$memberId/'
    | '/crm/settings/pipelines/'
    | '/inspection/inspections/$inspectionId/'
    | '/record-and-send/video-types/$videoTypeId/'
    | '/settings/billing/pricing/'
    | '/crm/deals/$dealId/offers/$versionId'
    | '/settings/audit/timeline/$targetType/$targetId'
    | '/chain/companies/$memberId/inspections/$inspectionId/progress'
    | '/crm/deals/$dealId/offers/$versionId/edit'
    | '/member-portal/manage/communications/$id/responses/$companyId'
    | '/chain/companies/$memberId/inspections/$inspectionId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/customer'
    | '/$'
    | '/accept-invitation'
    | '/accept-invitation-token'
    | '/calendar-callback'
    | '/forgot-password'
    | '/login'
    | '/meeting-end'
    | '/signup'
    | '/upgrades'
    | '/.well-known/change-password'
    | '/connected-companies'
    | '/create-company'
    | '/link-account'
    | '/practice-call'
    | '/book-meeting/$slug'
    | '/cancel-booking/$slug'
    | '/customer/forgot-password'
    | '/customer/login'
    | '/customer/reset-password'
    | '/forms/$slug'
    | '/join/$meetingId'
    | '/meeting-summary/$token'
    | '/oauth/error'
    | '/offer/$token'
    | '/record/$meetingId'
    | '/recording/share'
    | '/unsubscribe-email/$email'
    | '/v/$secret'
    | '/video/$publicId'
    | '/itxframe'
    | '/prototype'
    | '/chain'
    | '/calendar'
    | '/checklist'
    | '/dashboard'
    | '/getting-started'
    | '/meetings'
    | '/recording'
    | '/resources'
    | '/team-learning'
    | '/super-admin/admins'
    | '/super-admin/audit'
    | '/super-admin/company-activity'
    | '/super-admin/connected-apps'
    | '/super-admin/email-logs'
    | '/super-admin/feedback'
    | '/super-admin/impersonation-logs'
    | '/super-admin/inspection-library'
    | '/super-admin/mcp-activity'
    | '/super-admin/mcp-adoption'
    | '/super-admin/mobile-adoption'
    | '/super-admin/record-and-send'
    | '/super-admin/sms-logs'
    | '/super-admin/suppression-list'
    | '/super-admin/transcription-monitor'
    | '/super-admin/unsubscribe-list'
    | '/oauth/consent'
    | '/oauth/resume'
    | '/oauth/select-company'
    | '/customer/change-password'
    | '/customer/profile'
    | '/forms/additional/$token'
    | '/prototype/$slug/$screen'
    | '/super-admin'
    | '/bookings/blackout-dates'
    | '/bookings/customize'
    | '/bookings/dashboard'
    | '/bookings/manage'
    | '/bookings/services'
    | '/bookings/tracking'
    | '/chain/analytics'
    | '/chain/competence'
    | '/chain/config-pushes'
    | '/chain/coverage'
    | '/chain/endorsement'
    | '/chain/learning'
    | '/chain/master-catalog'
    | '/chain/members'
    | '/chain/my-endorsement'
    | '/chain/order-pipeline'
    | '/chain/quick-links'
    | '/chain/resources'
    | '/chain/staffing'
    | '/competence/approvals'
    | '/competence/matrix'
    | '/competence/me'
    | '/competence/types'
    | '/courses/$courseId'
    | '/courses/create'
    | '/history/$meetingID'
    | '/invoicing/$invoiceId'
    | '/member-portal/about'
    | '/member-portal/agreements'
    | '/member-portal/branding'
    | '/member-portal/campaigns'
    | '/member-portal/communications'
    | '/member-portal/contacts'
    | '/member-portal/overview'
    | '/member-portal/suppliers'
    | '/member-portal/tools'
    | '/my/learning'
    | '/orders/$orderId'
    | '/orders/reports'
    | '/settings/access'
    | '/settings/ai-settings'
    | '/settings/api-keys'
    | '/settings/company'
    | '/settings/connected-apps'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/order-settings'
    | '/settings/profile'
    | '/settings/service-area'
    | '/settings/service-types'
    | '/settings/usage'
    | '/settings/white-labeling'
    | '/staffing/categories'
    | '/staffing/my-interests'
    | '/staffing/my-postings'
    | '/staffing/pending-approvals'
    | '/staffing/skill-levels'
    | '/staffing/skills'
    | '/super-admin/ai-ops/cost'
    | '/super-admin/ai-ops/runs'
    | '/super-admin/chains/$parentCompanyId'
    | '/super-admin/companies/$companyId'
    | '/super-admin/industry-presets/$id'
    | '/super-admin/industry-presets/new'
    | '/super-admin/login-security/settings'
    | '/super-admin/meeting-telemetry/$meetingId'
    | '/super-admin/users/$userId'
    | '/customer/orders/$orderId'
    | '/bookings'
    | '/competence'
    | '/courses'
    | '/crm'
    | '/forms'
    | '/inspection'
    | '/invoicing'
    | '/member-portal'
    | '/orders'
    | '/record-and-send'
    | '/settings'
    | '/staffing'
    | '/super-admin/ai-ops'
    | '/super-admin/chains'
    | '/super-admin/companies'
    | '/super-admin/industry-presets'
    | '/super-admin/login-security'
    | '/super-admin/meeting-telemetry'
    | '/super-admin/users'
    | '/customer/orders'
    | '/chain/announcements/$announcementId'
    | '/competence/user/$userId'
    | '/courses/$courseId/edit'
    | '/crm/chain/distribution'
    | '/crm/chain/members'
    | '/crm/chain/parent-incoming'
    | '/crm/chain/pipeline'
    | '/crm/companies/$id'
    | '/crm/contacts/$contactId'
    | '/crm/deals/$dealId'
    | '/crm/leads/$leadId'
    | '/crm/pipeline/$pipelineId'
    | '/crm/settings/company-fields'
    | '/crm/settings/contact-fields'
    | '/crm/settings/deal-fields'
    | '/crm/settings/lost-reasons'
    | '/crm/settings/offer-defaults'
    | '/crm/settings/order-pipeline'
    | '/forms/$formId/analytics'
    | '/forms/$formId/designer'
    | '/forms/$formId/submissions'
    | '/inspection/sites/$siteId'
    | '/inspection/templates/$templateId'
    | '/invoicing/prepare/$orderId'
    | '/member-portal/agreements/$id'
    | '/member-portal/branding/$id'
    | '/member-portal/campaigns/$slug'
    | '/member-portal/communications/$id'
    | '/member-portal/manage/about'
    | '/member-portal/manage/agreements'
    | '/member-portal/manage/branding'
    | '/member-portal/manage/campaigns'
    | '/member-portal/manage/communications'
    | '/member-portal/manage/contacts'
    | '/member-portal/manage/suppliers'
    | '/member-portal/manage/tools'
    | '/member-portal/suppliers/$id'
    | '/member-portal/tools/$id'
    | '/record-and-send/submissions/$submissionId'
    | '/record-and-send/video-types/new'
    | '/settings/billing/addons'
    | '/settings/billing/payments'
    | '/settings/invoicing/accounting'
    | '/settings/meeting/background'
    | '/settings/meeting/defaults'
    | '/settings/meeting/recording'
    | '/settings/orders/pipeline'
    | '/settings/roles/$roleId'
    | '/settings/roles/new'
    | '/staffing/postings/$id'
    | '/staffing/postings/new'
    | '/super-admin/companies/$companyId/roles'
    | '/chain/announcements'
    | '/chain/courses'
    | '/crm/catalog'
    | '/crm/companies'
    | '/crm/contacts'
    | '/crm/deals'
    | '/crm/duplicates'
    | '/crm/leads'
    | '/crm/my-work'
    | '/crm/pipeline'
    | '/crm/reporting'
    | '/crm/settings'
    | '/inspection/library'
    | '/inspection/sites'
    | '/inspection/templates'
    | '/inspection/upcoming'
    | '/member-portal/manage'
    | '/settings/audit'
    | '/settings/billing'
    | '/settings/meeting'
    | '/settings/roles'
    | '/chain/courses/$courseId/manage'
    | '/crm/settings/pipelines/$pipelineId'
    | '/inspection/inspections/$inspectionId/capture'
    | '/inspection/inspections/$inspectionId/captures'
    | '/inspection/inspections/$inspectionId/evidence'
    | '/inspection/inspections/$inspectionId/progress'
    | '/member-portal/campaigns/by-id/$id'
    | '/member-portal/manage/agreements/$id'
    | '/member-portal/manage/branding/$id'
    | '/member-portal/manage/campaigns/$id'
    | '/member-portal/manage/communications/$id'
    | '/member-portal/manage/contacts/$id'
    | '/member-portal/manage/suppliers/$id'
    | '/member-portal/manage/tools/$id'
    | '/record-and-send/video-types/$videoTypeId/requests'
    | '/record-and-send/video-types/$videoTypeId/settings'
    | '/record-and-send/video-types/$videoTypeId/videos'
    | '/settings/billing/pricing/checkout'
    | '/staffing/postings/$id/edit'
    | '/chain/companies/$memberId'
    | '/crm/settings/pipelines'
    | '/inspection/inspections/$inspectionId'
    | '/record-and-send/video-types/$videoTypeId'
    | '/settings/billing/pricing'
    | '/crm/deals/$dealId/offers/$versionId'
    | '/settings/audit/timeline/$targetType/$targetId'
    | '/chain/companies/$memberId/inspections/$inspectionId/progress'
    | '/crm/deals/$dealId/offers/$versionId/edit'
    | '/member-portal/manage/communications/$id/responses/$companyId'
    | '/chain/companies/$memberId/inspections/$inspectionId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_oauth'
    | '/customer'
    | '/prototype'
    | '/$'
    | '/accept-invitation'
    | '/accept-invitation-token'
    | '/calendar-callback'
    | '/forgot-password'
    | '/login'
    | '/meeting-end'
    | '/signup'
    | '/upgrades'
    | '/_authenticated/_app'
    | '/_authenticated/super-admin'
    | '/customer/_customer-authenticated'
    | '/.well-known/change-password'
    | '/_authenticated/connected-companies'
    | '/_authenticated/create-company'
    | '/_authenticated/link-account'
    | '/_authenticated/practice-call'
    | '/book-meeting/$slug'
    | '/cancel-booking/$slug'
    | '/customer/forgot-password'
    | '/customer/login'
    | '/customer/reset-password'
    | '/forms/$slug'
    | '/join/$meetingId'
    | '/meeting-summary/$token'
    | '/oauth/error'
    | '/offer/$token'
    | '/record/$meetingId'
    | '/recording/share'
    | '/unsubscribe-email/$email'
    | '/v/$secret'
    | '/video/$publicId'
    | '/itxframe/'
    | '/prototype/'
    | '/_authenticated/_app/bookings'
    | '/_authenticated/_app/chain'
    | '/_authenticated/_app/crm'
    | '/_authenticated/_app/forms'
    | '/_authenticated/_app/inspection'
    | '/_authenticated/_app/invoicing'
    | '/_authenticated/_app/member-portal'
    | '/_authenticated/_app/orders'
    | '/_authenticated/_app/settings'
    | '/_authenticated/_app/staffing'
    | '/_authenticated/_app/calendar'
    | '/_authenticated/_app/checklist'
    | '/_authenticated/_app/dashboard'
    | '/_authenticated/_app/getting-started'
    | '/_authenticated/_app/meetings'
    | '/_authenticated/_app/recording'
    | '/_authenticated/_app/resources'
    | '/_authenticated/_app/team-learning'
    | '/_authenticated/super-admin/admins'
    | '/_authenticated/super-admin/audit'
    | '/_authenticated/super-admin/company-activity'
    | '/_authenticated/super-admin/connected-apps'
    | '/_authenticated/super-admin/email-logs'
    | '/_authenticated/super-admin/feedback'
    | '/_authenticated/super-admin/impersonation-logs'
    | '/_authenticated/super-admin/inspection-library'
    | '/_authenticated/super-admin/mcp-activity'
    | '/_authenticated/super-admin/mcp-adoption'
    | '/_authenticated/super-admin/mobile-adoption'
    | '/_authenticated/super-admin/record-and-send'
    | '/_authenticated/super-admin/sms-logs'
    | '/_authenticated/super-admin/suppression-list'
    | '/_authenticated/super-admin/transcription-monitor'
    | '/_authenticated/super-admin/unsubscribe-list'
    | '/_oauth/oauth/consent'
    | '/_oauth/oauth/resume'
    | '/_oauth/oauth/select-company'
    | '/customer/_customer-authenticated/change-password'
    | '/customer/_customer-authenticated/profile'
    | '/forms/additional/$token'
    | '/prototype/$slug/$screen'
    | '/_authenticated/super-admin/'
    | '/_authenticated/_app/crm/settings'
    | '/_authenticated/_app/member-portal/manage'
    | '/_authenticated/_app/settings/audit'
    | '/_authenticated/_app/settings/billing'
    | '/_authenticated/_app/bookings/blackout-dates'
    | '/_authenticated/_app/bookings/customize'
    | '/_authenticated/_app/bookings/dashboard'
    | '/_authenticated/_app/bookings/manage'
    | '/_authenticated/_app/bookings/services'
    | '/_authenticated/_app/bookings/tracking'
    | '/_authenticated/_app/chain/analytics'
    | '/_authenticated/_app/chain/competence'
    | '/_authenticated/_app/chain/config-pushes'
    | '/_authenticated/_app/chain/coverage'
    | '/_authenticated/_app/chain/endorsement'
    | '/_authenticated/_app/chain/learning'
    | '/_authenticated/_app/chain/master-catalog'
    | '/_authenticated/_app/chain/members'
    | '/_authenticated/_app/chain/my-endorsement'
    | '/_authenticated/_app/chain/order-pipeline'
    | '/_authenticated/_app/chain/quick-links'
    | '/_authenticated/_app/chain/resources'
    | '/_authenticated/_app/chain/staffing'
    | '/_authenticated/_app/competence/approvals'
    | '/_authenticated/_app/competence/matrix'
    | '/_authenticated/_app/competence/me'
    | '/_authenticated/_app/competence/types'
    | '/_authenticated/_app/courses/$courseId'
    | '/_authenticated/_app/courses/create'
    | '/_authenticated/_app/history/$meetingID'
    | '/_authenticated/_app/invoicing/$invoiceId'
    | '/_authenticated/_app/member-portal/about'
    | '/_authenticated/_app/member-portal/agreements'
    | '/_authenticated/_app/member-portal/branding'
    | '/_authenticated/_app/member-portal/campaigns'
    | '/_authenticated/_app/member-portal/communications'
    | '/_authenticated/_app/member-portal/contacts'
    | '/_authenticated/_app/member-portal/overview'
    | '/_authenticated/_app/member-portal/suppliers'
    | '/_authenticated/_app/member-portal/tools'
    | '/_authenticated/_app/my/learning'
    | '/_authenticated/_app/orders/$orderId'
    | '/_authenticated/_app/orders/reports'
    | '/_authenticated/_app/settings/access'
    | '/_authenticated/_app/settings/ai-settings'
    | '/_authenticated/_app/settings/api-keys'
    | '/_authenticated/_app/settings/company'
    | '/_authenticated/_app/settings/connected-apps'
    | '/_authenticated/_app/settings/members'
    | '/_authenticated/_app/settings/notifications'
    | '/_authenticated/_app/settings/order-settings'
    | '/_authenticated/_app/settings/profile'
    | '/_authenticated/_app/settings/service-area'
    | '/_authenticated/_app/settings/service-types'
    | '/_authenticated/_app/settings/usage'
    | '/_authenticated/_app/settings/white-labeling'
    | '/_authenticated/_app/staffing/categories'
    | '/_authenticated/_app/staffing/my-interests'
    | '/_authenticated/_app/staffing/my-postings'
    | '/_authenticated/_app/staffing/pending-approvals'
    | '/_authenticated/_app/staffing/skill-levels'
    | '/_authenticated/_app/staffing/skills'
    | '/_authenticated/super-admin/ai-ops/cost'
    | '/_authenticated/super-admin/ai-ops/runs'
    | '/_authenticated/super-admin/chains/$parentCompanyId'
    | '/_authenticated/super-admin/companies/$companyId'
    | '/_authenticated/super-admin/industry-presets/$id'
    | '/_authenticated/super-admin/industry-presets/new'
    | '/_authenticated/super-admin/login-security/settings'
    | '/_authenticated/super-admin/meeting-telemetry/$meetingId'
    | '/_authenticated/super-admin/users/$userId'
    | '/customer/_customer-authenticated/orders/$orderId'
    | '/_authenticated/_app/bookings/'
    | '/_authenticated/_app/competence/'
    | '/_authenticated/_app/courses/'
    | '/_authenticated/_app/crm/'
    | '/_authenticated/_app/forms/'
    | '/_authenticated/_app/inspection/'
    | '/_authenticated/_app/invoicing/'
    | '/_authenticated/_app/member-portal/'
    | '/_authenticated/_app/orders/'
    | '/_authenticated/_app/record-and-send/'
    | '/_authenticated/_app/settings/'
    | '/_authenticated/_app/staffing/'
    | '/_authenticated/super-admin/ai-ops/'
    | '/_authenticated/super-admin/chains/'
    | '/_authenticated/super-admin/companies/'
    | '/_authenticated/super-admin/industry-presets/'
    | '/_authenticated/super-admin/login-security/'
    | '/_authenticated/super-admin/meeting-telemetry/'
    | '/_authenticated/super-admin/users/'
    | '/customer/_customer-authenticated/orders/'
    | '/_authenticated/_app/chain/companies/$memberId'
    | '/_authenticated/_app/inspection/inspections/$inspectionId'
    | '/_authenticated/_app/record-and-send/video-types/$videoTypeId'
    | '/_authenticated/_app/chain/announcements/$announcementId'
    | '/_authenticated/_app/competence/user/$userId'
    | '/_authenticated/_app/courses/$courseId_/edit'
    | '/_authenticated/_app/crm/chain/distribution'
    | '/_authenticated/_app/crm/chain/members'
    | '/_authenticated/_app/crm/chain/parent-incoming'
    | '/_authenticated/_app/crm/chain/pipeline'
    | '/_authenticated/_app/crm/companies/$id'
    | '/_authenticated/_app/crm/contacts/$contactId'
    | '/_authenticated/_app/crm/deals/$dealId'
    | '/_authenticated/_app/crm/leads/$leadId'
    | '/_authenticated/_app/crm/pipeline/$pipelineId'
    | '/_authenticated/_app/crm/settings/company-fields'
    | '/_authenticated/_app/crm/settings/contact-fields'
    | '/_authenticated/_app/crm/settings/deal-fields'
    | '/_authenticated/_app/crm/settings/lost-reasons'
    | '/_authenticated/_app/crm/settings/offer-defaults'
    | '/_authenticated/_app/crm/settings/order-pipeline'
    | '/_authenticated/_app/forms/$formId/analytics'
    | '/_authenticated/_app/forms/$formId/designer'
    | '/_authenticated/_app/forms/$formId/submissions'
    | '/_authenticated/_app/inspection/sites/$siteId'
    | '/_authenticated/_app/inspection/templates/$templateId'
    | '/_authenticated/_app/invoicing/prepare/$orderId'
    | '/_authenticated/_app/member-portal/agreements/$id'
    | '/_authenticated/_app/member-portal/branding_/$id'
    | '/_authenticated/_app/member-portal/campaigns/$slug'
    | '/_authenticated/_app/member-portal/communications/$id'
    | '/_authenticated/_app/member-portal/manage/about'
    | '/_authenticated/_app/member-portal/manage/agreements'
    | '/_authenticated/_app/member-portal/manage/branding'
    | '/_authenticated/_app/member-portal/manage/campaigns'
    | '/_authenticated/_app/member-portal/manage/communications'
    | '/_authenticated/_app/member-portal/manage/contacts'
    | '/_authenticated/_app/member-portal/manage/suppliers'
    | '/_authenticated/_app/member-portal/manage/tools'
    | '/_authenticated/_app/member-portal/suppliers/$id'
    | '/_authenticated/_app/member-portal/tools/$id'
    | '/_authenticated/_app/record-and-send/submissions/$submissionId'
    | '/_authenticated/_app/record-and-send/video-types/new'
    | '/_authenticated/_app/settings/billing/addons'
    | '/_authenticated/_app/settings/billing/payments'
    | '/_authenticated/_app/settings/invoicing/accounting'
    | '/_authenticated/_app/settings/meeting/background'
    | '/_authenticated/_app/settings/meeting/defaults'
    | '/_authenticated/_app/settings/meeting/recording'
    | '/_authenticated/_app/settings/orders/pipeline'
    | '/_authenticated/_app/settings/roles/$roleId'
    | '/_authenticated/_app/settings/roles/new'
    | '/_authenticated/_app/staffing/postings/$id'
    | '/_authenticated/_app/staffing/postings/new'
    | '/_authenticated/super-admin/companies/$companyId_/roles'
    | '/_authenticated/_app/chain/announcements/'
    | '/_authenticated/_app/chain/courses/'
    | '/_authenticated/_app/crm/catalog/'
    | '/_authenticated/_app/crm/companies/'
    | '/_authenticated/_app/crm/contacts/'
    | '/_authenticated/_app/crm/deals/'
    | '/_authenticated/_app/crm/duplicates/'
    | '/_authenticated/_app/crm/leads/'
    | '/_authenticated/_app/crm/my-work/'
    | '/_authenticated/_app/crm/pipeline/'
    | '/_authenticated/_app/crm/reporting/'
    | '/_authenticated/_app/crm/settings/'
    | '/_authenticated/_app/inspection/library/'
    | '/_authenticated/_app/inspection/sites/'
    | '/_authenticated/_app/inspection/templates/'
    | '/_authenticated/_app/inspection/upcoming/'
    | '/_authenticated/_app/member-portal/manage/'
    | '/_authenticated/_app/settings/audit/'
    | '/_authenticated/_app/settings/billing/'
    | '/_authenticated/_app/settings/meeting/'
    | '/_authenticated/_app/settings/roles/'
    | '/_authenticated/_app/chain/courses/$courseId/manage'
    | '/_authenticated/_app/crm/settings/pipelines/$pipelineId'
    | '/_authenticated/_app/inspection/inspections/$inspectionId/capture'
    | '/_authenticated/_app/inspection/inspections/$inspectionId/captures'
    | '/_authenticated/_app/inspection/inspections/$inspectionId/evidence'
    | '/_authenticated/_app/inspection/inspections/$inspectionId/progress'
    | '/_authenticated/_app/member-portal/campaigns/by-id/$id'
    | '/_authenticated/_app/member-portal/manage/agreements/$id'
    | '/_authenticated/_app/member-portal/manage/branding/$id'
    | '/_authenticated/_app/member-portal/manage/campaigns/$id'
    | '/_authenticated/_app/member-portal/manage/communications/$id'
    | '/_authenticated/_app/member-portal/manage/contacts/$id'
    | '/_authenticated/_app/member-portal/manage/suppliers/$id'
    | '/_authenticated/_app/member-portal/manage/tools/$id'
    | '/_authenticated/_app/record-and-send/video-types/$videoTypeId/requests'
    | '/_authenticated/_app/record-and-send/video-types/$videoTypeId/settings'
    | '/_authenticated/_app/record-and-send/video-types/$videoTypeId/videos'
    | '/_authenticated/_app/settings/billing/pricing/checkout'
    | '/_authenticated/_app/staffing/postings/$id_/edit'
    | '/_authenticated/_app/chain/companies/$memberId/'
    | '/_authenticated/_app/crm/settings/pipelines/'
    | '/_authenticated/_app/inspection/inspections/$inspectionId/'
    | '/_authenticated/_app/record-and-send/video-types/$videoTypeId/'
    | '/_authenticated/_app/settings/billing/pricing/'
    | '/_authenticated/_app/crm/deals/$dealId_/offers/$versionId'
    | '/_authenticated/_app/settings/audit/timeline/$targetType/$targetId'
    | '/_authenticated/_app/chain/companies/$memberId/inspections/$inspectionId/progress'
    | '/_authenticated/_app/crm/deals/$dealId_/offers/$versionId_/edit'
    | '/_authenticated/_app/member-portal/manage/communications/$id_/responses/$companyId'
    | '/_authenticated/_app/chain/companies/$memberId/inspections/$inspectionId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  OauthRouteRoute: typeof OauthRouteRouteWithChildren
  CustomerRouteRoute: typeof CustomerRouteRouteWithChildren
  PrototypeRouteRoute: typeof PrototypeRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
  AcceptInvitationRoute: typeof AcceptInvitationRoute
  AcceptInvitationTokenRoute: typeof AcceptInvitationTokenRoute
  CalendarCallbackRoute: typeof CalendarCallbackRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  MeetingEndRoute: typeof MeetingEndRoute
  SignupRoute: typeof SignupRoute
  UpgradesRoute: typeof UpgradesRoute
  DotwellKnownChangePasswordRoute: typeof DotwellKnownChangePasswordRoute
  BookMeetingSlugRoute: typeof BookMeetingSlugRoute
  CancelBookingSlugRoute: typeof CancelBookingSlugRoute
  FormsSlugRoute: typeof FormsSlugRoute
  JoinMeetingIdRoute: typeof JoinMeetingIdRoute
  MeetingSummaryTokenRoute: typeof MeetingSummaryTokenRoute
  OauthErrorRoute: typeof OauthErrorRoute
  OfferTokenRoute: typeof OfferTokenRoute
  RecordMeetingIdRoute: typeof RecordMeetingIdRoute
  RecordingShareRoute: typeof RecordingShareRoute
  UnsubscribeEmailEmailRoute: typeof UnsubscribeEmailEmailRoute
  VSecretRoute: typeof VSecretRoute
  VideoPublicIdRoute: typeof VideoPublicIdRoute
  ItxframeIndexRoute: typeof ItxframeIndexRoute
  FormsAdditionalTokenRoute: typeof FormsAdditionalTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/upgrades': {
      id: '/upgrades'
      path: '/upgrades'
      fullPath: '/upgrades'
      preLoaderRoute: typeof UpgradesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meeting-end': {
      id: '/meeting-end'
      path: '/meeting-end'
      fullPath: '/meeting-end'
      preLoaderRoute: typeof MeetingEndRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar-callback': {
      id: '/calendar-callback'
      path: '/calendar-callback'
      fullPath: '/calendar-callback'
      preLoaderRoute: typeof CalendarCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation-token': {
      id: '/accept-invitation-token'
      path: '/accept-invitation-token'
      fullPath: '/accept-invitation-token'
      preLoaderRoute: typeof AcceptInvitationTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation': {
      id: '/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototype': {
      id: '/prototype'
      path: '/prototype'
      fullPath: '/prototype'
      preLoaderRoute: typeof PrototypeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer': {
      id: '/customer'
      path: '/customer'
      fullPath: '/customer'
      preLoaderRoute: typeof CustomerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_oauth': {
      id: '/_oauth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof OauthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototype/': {
      id: '/prototype/'
      path: '/'
      fullPath: '/prototype/'
      preLoaderRoute: typeof PrototypeIndexRouteImport
      parentRoute: typeof PrototypeRouteRoute
    }
    '/itxframe/': {
      id: '/itxframe/'
      path: '/itxframe'
      fullPath: '/itxframe/'
      preLoaderRoute: typeof ItxframeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/video/$publicId': {
      id: '/video/$publicId'
      path: '/video/$publicId'
      fullPath: '/video/$publicId'
      preLoaderRoute: typeof VideoPublicIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/v/$secret': {
      id: '/v/$secret'
      path: '/v/$secret'
      fullPath: '/v/$secret'
      preLoaderRoute: typeof VSecretRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribe-email/$email': {
      id: '/unsubscribe-email/$email'
      path: '/unsubscribe-email/$email'
      fullPath: '/unsubscribe-email/$email'
      preLoaderRoute: typeof UnsubscribeEmailEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recording/share': {
      id: '/recording/share'
      path: '/recording/share'
      fullPath: '/recording/share'
      preLoaderRoute: typeof RecordingShareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/record/$meetingId': {
      id: '/record/$meetingId'
      path: '/record/$meetingId'
      fullPath: '/record/$meetingId'
      preLoaderRoute: typeof RecordMeetingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offer/$token': {
      id: '/offer/$token'
      path: '/offer/$token'
      fullPath: '/offer/$token'
      preLoaderRoute: typeof OfferTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/error': {
      id: '/oauth/error'
      path: '/oauth/error'
      fullPath: '/oauth/error'
      preLoaderRoute: typeof OauthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meeting-summary/$token': {
      id: '/meeting-summary/$token'
      path: '/meeting-summary/$token'
      fullPath: '/meeting-summary/$token'
      preLoaderRoute: typeof MeetingSummaryTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join/$meetingId': {
      id: '/join/$meetingId'
      path: '/join/$meetingId'
      fullPath: '/join/$meetingId'
      preLoaderRoute: typeof JoinMeetingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/$slug': {
      id: '/forms/$slug'
      path: '/forms/$slug'
      fullPath: '/forms/$slug'
      preLoaderRoute: typeof FormsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer/reset-password': {
      id: '/customer/reset-password'
      path: '/reset-password'
      fullPath: '/customer/reset-password'
      preLoaderRoute: typeof CustomerResetPasswordRouteImport
      parentRoute: typeof CustomerRouteRoute
    }
    '/customer/login': {
      id: '/customer/login'
      path: '/login'
      fullPath: '/customer/login'
      preLoaderRoute: typeof CustomerLoginRouteImport
      parentRoute: typeof CustomerRouteRoute
    }
    '/customer/forgot-password': {
      id: '/customer/forgot-password'
      path: '/forgot-password'
      fullPath: '/customer/forgot-password'
      preLoaderRoute: typeof CustomerForgotPasswordRouteImport
      parentRoute: typeof CustomerRouteRoute
    }
    '/cancel-booking/$slug': {
      id: '/cancel-booking/$slug'
      path: '/cancel-booking/$slug'
      fullPath: '/cancel-booking/$slug'
      preLoaderRoute: typeof CancelBookingSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/book-meeting/$slug': {
      id: '/book-meeting/$slug'
      path: '/book-meeting/$slug'
      fullPath: '/book-meeting/$slug'
      preLoaderRoute: typeof BookMeetingSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/practice-call': {
      id: '/_authenticated/practice-call'
      path: '/practice-call'
      fullPath: '/practice-call'
      preLoaderRoute: typeof AuthenticatedPracticeCallRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/link-account': {
      id: '/_authenticated/link-account'
      path: '/link-account'
      fullPath: '/link-account'
      preLoaderRoute: typeof AuthenticatedLinkAccountRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/create-company': {
      id: '/_authenticated/create-company'
      path: '/create-company'
      fullPath: '/create-company'
      preLoaderRoute: typeof AuthenticatedCreateCompanyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/connected-companies': {
      id: '/_authenticated/connected-companies'
      path: '/connected-companies'
      fullPath: '/connected-companies'
      preLoaderRoute: typeof AuthenticatedConnectedCompaniesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/.well-known/change-password': {
      id: '/.well-known/change-password'
      path: '/.well-known/change-password'
      fullPath: '/.well-known/change-password'
      preLoaderRoute: typeof DotwellKnownChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer/_customer-authenticated': {
      id: '/customer/_customer-authenticated'
      path: ''
      fullPath: '/customer'
      preLoaderRoute: typeof CustomerCustomerAuthenticatedRouteRouteImport
      parentRoute: typeof CustomerRouteRoute
    }
    '/_authenticated/super-admin': {
      id: '/_authenticated/super-admin'
      path: '/super-admin'
      fullPath: '/super-admin'
      preLoaderRoute: typeof AuthenticatedSuperAdminRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/_app': {
      id: '/_authenticated/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedAppRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin/': {
      id: '/_authenticated/super-admin/'
      path: '/'
      fullPath: '/super-admin/'
      preLoaderRoute: typeof AuthenticatedSuperAdminIndexRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/prototype/$slug/$screen': {
      id: '/prototype/$slug/$screen'
      path: '/$slug/$screen'
      fullPath: '/prototype/$slug/$screen'
      preLoaderRoute: typeof PrototypeSlugScreenRouteImport
      parentRoute: typeof PrototypeRouteRoute
    }
    '/forms/additional/$token': {
      id: '/forms/additional/$token'
      path: '/forms/additional/$token'
      fullPath: '/forms/additional/$token'
      preLoaderRoute: typeof FormsAdditionalTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer/_customer-authenticated/profile': {
      id: '/customer/_customer-authenticated/profile'
      path: '/profile'
      fullPath: '/customer/profile'
      preLoaderRoute: typeof CustomerCustomerAuthenticatedProfileRouteImport
      parentRoute: typeof CustomerCustomerAuthenticatedRouteRoute
    }
    '/customer/_customer-authenticated/change-password': {
      id: '/customer/_customer-authenticated/change-password'
      path: '/change-password'
      fullPath: '/customer/change-password'
      preLoaderRoute: typeof CustomerCustomerAuthenticatedChangePasswordRouteImport
      parentRoute: typeof CustomerCustomerAuthenticatedRouteRoute
    }
    '/_oauth/oauth/select-company': {
      id: '/_oauth/oauth/select-company'
      path: '/oauth/select-company'
      fullPath: '/oauth/select-company'
      preLoaderRoute: typeof OauthOauthSelectCompanyRouteImport
      parentRoute: typeof OauthRouteRoute
    }
    '/_oauth/oauth/resume': {
      id: '/_oauth/oauth/resume'
      path: '/oauth/resume'
      fullPath: '/oauth/resume'
      preLoaderRoute: typeof OauthOauthResumeRouteImport
      parentRoute: typeof OauthRouteRoute
    }
    '/_oauth/oauth/consent': {
      id: '/_oauth/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthOauthConsentRouteImport
      parentRoute: typeof OauthRouteRoute
    }
    '/_authenticated/super-admin/unsubscribe-list': {
      id: '/_authenticated/super-admin/unsubscribe-list'
      path: '/unsubscribe-list'
      fullPath: '/super-admin/unsubscribe-list'
      preLoaderRoute: typeof AuthenticatedSuperAdminUnsubscribeListRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/transcription-monitor': {
      id: '/_authenticated/super-admin/transcription-monitor'
      path: '/transcription-monitor'
      fullPath: '/super-admin/transcription-monitor'
      preLoaderRoute: typeof AuthenticatedSuperAdminTranscriptionMonitorRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/suppression-list': {
      id: '/_authenticated/super-admin/suppression-list'
      path: '/suppression-list'
      fullPath: '/super-admin/suppression-list'
      preLoaderRoute: typeof AuthenticatedSuperAdminSuppressionListRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/sms-logs': {
      id: '/_authenticated/super-admin/sms-logs'
      path: '/sms-logs'
      fullPath: '/super-admin/sms-logs'
      preLoaderRoute: typeof AuthenticatedSuperAdminSmsLogsRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/record-and-send': {
      id: '/_authenticated/super-admin/record-and-send'
      path: '/record-and-send'
      fullPath: '/super-admin/record-and-send'
      preLoaderRoute: typeof AuthenticatedSuperAdminRecordAndSendRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/mobile-adoption': {
      id: '/_authenticated/super-admin/mobile-adoption'
      path: '/mobile-adoption'
      fullPath: '/super-admin/mobile-adoption'
      preLoaderRoute: typeof AuthenticatedSuperAdminMobileAdoptionRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/mcp-adoption': {
      id: '/_authenticated/super-admin/mcp-adoption'
      path: '/mcp-adoption'
      fullPath: '/super-admin/mcp-adoption'
      preLoaderRoute: typeof AuthenticatedSuperAdminMcpAdoptionRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/mcp-activity': {
      id: '/_authenticated/super-admin/mcp-activity'
      path: '/mcp-activity'
      fullPath: '/super-admin/mcp-activity'
      preLoaderRoute: typeof AuthenticatedSuperAdminMcpActivityRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/inspection-library': {
      id: '/_authenticated/super-admin/inspection-library'
      path: '/inspection-library'
      fullPath: '/super-admin/inspection-library'
      preLoaderRoute: typeof AuthenticatedSuperAdminInspectionLibraryRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/impersonation-logs': {
      id: '/_authenticated/super-admin/impersonation-logs'
      path: '/impersonation-logs'
      fullPath: '/super-admin/impersonation-logs'
      preLoaderRoute: typeof AuthenticatedSuperAdminImpersonationLogsRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/feedback': {
      id: '/_authenticated/super-admin/feedback'
      path: '/feedback'
      fullPath: '/super-admin/feedback'
      preLoaderRoute: typeof AuthenticatedSuperAdminFeedbackRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/email-logs': {
      id: '/_authenticated/super-admin/email-logs'
      path: '/email-logs'
      fullPath: '/super-admin/email-logs'
      preLoaderRoute: typeof AuthenticatedSuperAdminEmailLogsRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/connected-apps': {
      id: '/_authenticated/super-admin/connected-apps'
      path: '/connected-apps'
      fullPath: '/super-admin/connected-apps'
      preLoaderRoute: typeof AuthenticatedSuperAdminConnectedAppsRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/company-activity': {
      id: '/_authenticated/super-admin/company-activity'
      path: '/company-activity'
      fullPath: '/super-admin/company-activity'
      preLoaderRoute: typeof AuthenticatedSuperAdminCompanyActivityRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/audit': {
      id: '/_authenticated/super-admin/audit'
      path: '/audit'
      fullPath: '/super-admin/audit'
      preLoaderRoute: typeof AuthenticatedSuperAdminAuditRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/admins': {
      id: '/_authenticated/super-admin/admins'
      path: '/admins'
      fullPath: '/super-admin/admins'
      preLoaderRoute: typeof AuthenticatedSuperAdminAdminsRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/_app/team-learning': {
      id: '/_authenticated/_app/team-learning'
      path: '/team-learning'
      fullPath: '/team-learning'
      preLoaderRoute: typeof AuthenticatedAppTeamLearningRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/resources': {
      id: '/_authenticated/_app/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof AuthenticatedAppResourcesRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/recording': {
      id: '/_authenticated/_app/recording'
      path: '/recording'
      fullPath: '/recording'
      preLoaderRoute: typeof AuthenticatedAppRecordingRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/meetings': {
      id: '/_authenticated/_app/meetings'
      path: '/meetings'
      fullPath: '/meetings'
      preLoaderRoute: typeof AuthenticatedAppMeetingsRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/getting-started': {
      id: '/_authenticated/_app/getting-started'
      path: '/getting-started'
      fullPath: '/getting-started'
      preLoaderRoute: typeof AuthenticatedAppGettingStartedRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/dashboard': {
      id: '/_authenticated/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedAppDashboardRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/checklist': {
      id: '/_authenticated/_app/checklist'
      path: '/checklist'
      fullPath: '/checklist'
      preLoaderRoute: typeof AuthenticatedAppChecklistRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/calendar': {
      id: '/_authenticated/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AuthenticatedAppCalendarRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/staffing': {
      id: '/_authenticated/_app/staffing'
      path: '/staffing'
      fullPath: '/staffing'
      preLoaderRoute: typeof AuthenticatedAppStaffingRouteRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/settings': {
      id: '/_authenticated/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedAppSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/orders': {
      id: '/_authenticated/_app/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AuthenticatedAppOrdersRouteRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/member-portal': {
      id: '/_authenticated/_app/member-portal'
      path: '/member-portal'
      fullPath: '/member-portal'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalRouteRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/invoicing': {
      id: '/_authenticated/_app/invoicing'
      path: '/invoicing'
      fullPath: '/invoicing'
      preLoaderRoute: typeof AuthenticatedAppInvoicingRouteRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/inspection': {
      id: '/_authenticated/_app/inspection'
      path: '/inspection'
      fullPath: '/inspection'
      preLoaderRoute: typeof AuthenticatedAppInspectionRouteRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/forms': {
      id: '/_authenticated/_app/forms'
      path: '/forms'
      fullPath: '/forms'
      preLoaderRoute: typeof AuthenticatedAppFormsRouteRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/crm': {
      id: '/_authenticated/_app/crm'
      path: '/crm'
      fullPath: '/crm'
      preLoaderRoute: typeof AuthenticatedAppCrmRouteRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/chain': {
      id: '/_authenticated/_app/chain'
      path: '/chain'
      fullPath: '/chain'
      preLoaderRoute: typeof AuthenticatedAppChainRouteRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/bookings': {
      id: '/_authenticated/_app/bookings'
      path: '/bookings'
      fullPath: '/bookings'
      preLoaderRoute: typeof AuthenticatedAppBookingsRouteRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/customer/_customer-authenticated/orders/': {
      id: '/customer/_customer-authenticated/orders/'
      path: '/orders'
      fullPath: '/customer/orders/'
      preLoaderRoute: typeof CustomerCustomerAuthenticatedOrdersIndexRouteImport
      parentRoute: typeof CustomerCustomerAuthenticatedRouteRoute
    }
    '/_authenticated/super-admin/users/': {
      id: '/_authenticated/super-admin/users/'
      path: '/users'
      fullPath: '/super-admin/users/'
      preLoaderRoute: typeof AuthenticatedSuperAdminUsersIndexRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/meeting-telemetry/': {
      id: '/_authenticated/super-admin/meeting-telemetry/'
      path: '/meeting-telemetry'
      fullPath: '/super-admin/meeting-telemetry/'
      preLoaderRoute: typeof AuthenticatedSuperAdminMeetingTelemetryIndexRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/login-security/': {
      id: '/_authenticated/super-admin/login-security/'
      path: '/login-security'
      fullPath: '/super-admin/login-security/'
      preLoaderRoute: typeof AuthenticatedSuperAdminLoginSecurityIndexRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/industry-presets/': {
      id: '/_authenticated/super-admin/industry-presets/'
      path: '/industry-presets'
      fullPath: '/super-admin/industry-presets/'
      preLoaderRoute: typeof AuthenticatedSuperAdminIndustryPresetsIndexRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/companies/': {
      id: '/_authenticated/super-admin/companies/'
      path: '/companies'
      fullPath: '/super-admin/companies/'
      preLoaderRoute: typeof AuthenticatedSuperAdminCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/chains/': {
      id: '/_authenticated/super-admin/chains/'
      path: '/chains'
      fullPath: '/super-admin/chains/'
      preLoaderRoute: typeof AuthenticatedSuperAdminChainsIndexRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/ai-ops/': {
      id: '/_authenticated/super-admin/ai-ops/'
      path: '/ai-ops'
      fullPath: '/super-admin/ai-ops/'
      preLoaderRoute: typeof AuthenticatedSuperAdminAiOpsIndexRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/_app/staffing/': {
      id: '/_authenticated/_app/staffing/'
      path: '/'
      fullPath: '/staffing/'
      preLoaderRoute: typeof AuthenticatedAppStaffingIndexRouteImport
      parentRoute: typeof AuthenticatedAppStaffingRouteRoute
    }
    '/_authenticated/_app/settings/': {
      id: '/_authenticated/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedAppSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/record-and-send/': {
      id: '/_authenticated/_app/record-and-send/'
      path: '/record-and-send'
      fullPath: '/record-and-send/'
      preLoaderRoute: typeof AuthenticatedAppRecordAndSendIndexRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/orders/': {
      id: '/_authenticated/_app/orders/'
      path: '/'
      fullPath: '/orders/'
      preLoaderRoute: typeof AuthenticatedAppOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedAppOrdersRouteRoute
    }
    '/_authenticated/_app/member-portal/': {
      id: '/_authenticated/_app/member-portal/'
      path: '/'
      fullPath: '/member-portal/'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalIndexRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalRouteRoute
    }
    '/_authenticated/_app/invoicing/': {
      id: '/_authenticated/_app/invoicing/'
      path: '/'
      fullPath: '/invoicing/'
      preLoaderRoute: typeof AuthenticatedAppInvoicingIndexRouteImport
      parentRoute: typeof AuthenticatedAppInvoicingRouteRoute
    }
    '/_authenticated/_app/inspection/': {
      id: '/_authenticated/_app/inspection/'
      path: '/'
      fullPath: '/inspection/'
      preLoaderRoute: typeof AuthenticatedAppInspectionIndexRouteImport
      parentRoute: typeof AuthenticatedAppInspectionRouteRoute
    }
    '/_authenticated/_app/forms/': {
      id: '/_authenticated/_app/forms/'
      path: '/'
      fullPath: '/forms/'
      preLoaderRoute: typeof AuthenticatedAppFormsIndexRouteImport
      parentRoute: typeof AuthenticatedAppFormsRouteRoute
    }
    '/_authenticated/_app/crm/': {
      id: '/_authenticated/_app/crm/'
      path: '/'
      fullPath: '/crm/'
      preLoaderRoute: typeof AuthenticatedAppCrmIndexRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/courses/': {
      id: '/_authenticated/_app/courses/'
      path: '/courses'
      fullPath: '/courses/'
      preLoaderRoute: typeof AuthenticatedAppCoursesIndexRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/competence/': {
      id: '/_authenticated/_app/competence/'
      path: '/competence'
      fullPath: '/competence/'
      preLoaderRoute: typeof AuthenticatedAppCompetenceIndexRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/bookings/': {
      id: '/_authenticated/_app/bookings/'
      path: '/'
      fullPath: '/bookings/'
      preLoaderRoute: typeof AuthenticatedAppBookingsIndexRouteImport
      parentRoute: typeof AuthenticatedAppBookingsRouteRoute
    }
    '/customer/_customer-authenticated/orders/$orderId': {
      id: '/customer/_customer-authenticated/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/customer/orders/$orderId'
      preLoaderRoute: typeof CustomerCustomerAuthenticatedOrdersOrderIdRouteImport
      parentRoute: typeof CustomerCustomerAuthenticatedRouteRoute
    }
    '/_authenticated/super-admin/users/$userId': {
      id: '/_authenticated/super-admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/super-admin/users/$userId'
      preLoaderRoute: typeof AuthenticatedSuperAdminUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/meeting-telemetry/$meetingId': {
      id: '/_authenticated/super-admin/meeting-telemetry/$meetingId'
      path: '/meeting-telemetry/$meetingId'
      fullPath: '/super-admin/meeting-telemetry/$meetingId'
      preLoaderRoute: typeof AuthenticatedSuperAdminMeetingTelemetryMeetingIdRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/login-security/settings': {
      id: '/_authenticated/super-admin/login-security/settings'
      path: '/login-security/settings'
      fullPath: '/super-admin/login-security/settings'
      preLoaderRoute: typeof AuthenticatedSuperAdminLoginSecuritySettingsRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/industry-presets/new': {
      id: '/_authenticated/super-admin/industry-presets/new'
      path: '/industry-presets/new'
      fullPath: '/super-admin/industry-presets/new'
      preLoaderRoute: typeof AuthenticatedSuperAdminIndustryPresetsNewRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/industry-presets/$id': {
      id: '/_authenticated/super-admin/industry-presets/$id'
      path: '/industry-presets/$id'
      fullPath: '/super-admin/industry-presets/$id'
      preLoaderRoute: typeof AuthenticatedSuperAdminIndustryPresetsIdRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/companies/$companyId': {
      id: '/_authenticated/super-admin/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/super-admin/companies/$companyId'
      preLoaderRoute: typeof AuthenticatedSuperAdminCompaniesCompanyIdRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/chains/$parentCompanyId': {
      id: '/_authenticated/super-admin/chains/$parentCompanyId'
      path: '/chains/$parentCompanyId'
      fullPath: '/super-admin/chains/$parentCompanyId'
      preLoaderRoute: typeof AuthenticatedSuperAdminChainsParentCompanyIdRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/ai-ops/runs': {
      id: '/_authenticated/super-admin/ai-ops/runs'
      path: '/ai-ops/runs'
      fullPath: '/super-admin/ai-ops/runs'
      preLoaderRoute: typeof AuthenticatedSuperAdminAiOpsRunsRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/super-admin/ai-ops/cost': {
      id: '/_authenticated/super-admin/ai-ops/cost'
      path: '/ai-ops/cost'
      fullPath: '/super-admin/ai-ops/cost'
      preLoaderRoute: typeof AuthenticatedSuperAdminAiOpsCostRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/_app/staffing/skills': {
      id: '/_authenticated/_app/staffing/skills'
      path: '/skills'
      fullPath: '/staffing/skills'
      preLoaderRoute: typeof AuthenticatedAppStaffingSkillsRouteImport
      parentRoute: typeof AuthenticatedAppStaffingRouteRoute
    }
    '/_authenticated/_app/staffing/skill-levels': {
      id: '/_authenticated/_app/staffing/skill-levels'
      path: '/skill-levels'
      fullPath: '/staffing/skill-levels'
      preLoaderRoute: typeof AuthenticatedAppStaffingSkillLevelsRouteImport
      parentRoute: typeof AuthenticatedAppStaffingRouteRoute
    }
    '/_authenticated/_app/staffing/pending-approvals': {
      id: '/_authenticated/_app/staffing/pending-approvals'
      path: '/pending-approvals'
      fullPath: '/staffing/pending-approvals'
      preLoaderRoute: typeof AuthenticatedAppStaffingPendingApprovalsRouteImport
      parentRoute: typeof AuthenticatedAppStaffingRouteRoute
    }
    '/_authenticated/_app/staffing/my-postings': {
      id: '/_authenticated/_app/staffing/my-postings'
      path: '/my-postings'
      fullPath: '/staffing/my-postings'
      preLoaderRoute: typeof AuthenticatedAppStaffingMyPostingsRouteImport
      parentRoute: typeof AuthenticatedAppStaffingRouteRoute
    }
    '/_authenticated/_app/staffing/my-interests': {
      id: '/_authenticated/_app/staffing/my-interests'
      path: '/my-interests'
      fullPath: '/staffing/my-interests'
      preLoaderRoute: typeof AuthenticatedAppStaffingMyInterestsRouteImport
      parentRoute: typeof AuthenticatedAppStaffingRouteRoute
    }
    '/_authenticated/_app/staffing/categories': {
      id: '/_authenticated/_app/staffing/categories'
      path: '/categories'
      fullPath: '/staffing/categories'
      preLoaderRoute: typeof AuthenticatedAppStaffingCategoriesRouteImport
      parentRoute: typeof AuthenticatedAppStaffingRouteRoute
    }
    '/_authenticated/_app/settings/white-labeling': {
      id: '/_authenticated/_app/settings/white-labeling'
      path: '/white-labeling'
      fullPath: '/settings/white-labeling'
      preLoaderRoute: typeof AuthenticatedAppSettingsWhiteLabelingRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/usage': {
      id: '/_authenticated/_app/settings/usage'
      path: '/usage'
      fullPath: '/settings/usage'
      preLoaderRoute: typeof AuthenticatedAppSettingsUsageRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/service-types': {
      id: '/_authenticated/_app/settings/service-types'
      path: '/service-types'
      fullPath: '/settings/service-types'
      preLoaderRoute: typeof AuthenticatedAppSettingsServiceTypesRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/service-area': {
      id: '/_authenticated/_app/settings/service-area'
      path: '/service-area'
      fullPath: '/settings/service-area'
      preLoaderRoute: typeof AuthenticatedAppSettingsServiceAreaRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/profile': {
      id: '/_authenticated/_app/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedAppSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/order-settings': {
      id: '/_authenticated/_app/settings/order-settings'
      path: '/order-settings'
      fullPath: '/settings/order-settings'
      preLoaderRoute: typeof AuthenticatedAppSettingsOrderSettingsRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/notifications': {
      id: '/_authenticated/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedAppSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/members': {
      id: '/_authenticated/_app/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AuthenticatedAppSettingsMembersRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/connected-apps': {
      id: '/_authenticated/_app/settings/connected-apps'
      path: '/connected-apps'
      fullPath: '/settings/connected-apps'
      preLoaderRoute: typeof AuthenticatedAppSettingsConnectedAppsRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/company': {
      id: '/_authenticated/_app/settings/company'
      path: '/company'
      fullPath: '/settings/company'
      preLoaderRoute: typeof AuthenticatedAppSettingsCompanyRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/api-keys': {
      id: '/_authenticated/_app/settings/api-keys'
      path: '/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof AuthenticatedAppSettingsApiKeysRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/ai-settings': {
      id: '/_authenticated/_app/settings/ai-settings'
      path: '/ai-settings'
      fullPath: '/settings/ai-settings'
      preLoaderRoute: typeof AuthenticatedAppSettingsAiSettingsRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/access': {
      id: '/_authenticated/_app/settings/access'
      path: '/access'
      fullPath: '/settings/access'
      preLoaderRoute: typeof AuthenticatedAppSettingsAccessRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/orders/reports': {
      id: '/_authenticated/_app/orders/reports'
      path: '/reports'
      fullPath: '/orders/reports'
      preLoaderRoute: typeof AuthenticatedAppOrdersReportsRouteImport
      parentRoute: typeof AuthenticatedAppOrdersRouteRoute
    }
    '/_authenticated/_app/orders/$orderId': {
      id: '/_authenticated/_app/orders/$orderId'
      path: '/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AuthenticatedAppOrdersOrderIdRouteImport
      parentRoute: typeof AuthenticatedAppOrdersRouteRoute
    }
    '/_authenticated/_app/my/learning': {
      id: '/_authenticated/_app/my/learning'
      path: '/my/learning'
      fullPath: '/my/learning'
      preLoaderRoute: typeof AuthenticatedAppMyLearningRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/member-portal/tools': {
      id: '/_authenticated/_app/member-portal/tools'
      path: '/tools'
      fullPath: '/member-portal/tools'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalToolsRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalRouteRoute
    }
    '/_authenticated/_app/member-portal/suppliers': {
      id: '/_authenticated/_app/member-portal/suppliers'
      path: '/suppliers'
      fullPath: '/member-portal/suppliers'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalSuppliersRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalRouteRoute
    }
    '/_authenticated/_app/member-portal/overview': {
      id: '/_authenticated/_app/member-portal/overview'
      path: '/overview'
      fullPath: '/member-portal/overview'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalOverviewRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalRouteRoute
    }
    '/_authenticated/_app/member-portal/contacts': {
      id: '/_authenticated/_app/member-portal/contacts'
      path: '/contacts'
      fullPath: '/member-portal/contacts'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalContactsRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalRouteRoute
    }
    '/_authenticated/_app/member-portal/communications': {
      id: '/_authenticated/_app/member-portal/communications'
      path: '/communications'
      fullPath: '/member-portal/communications'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalCommunicationsRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalRouteRoute
    }
    '/_authenticated/_app/member-portal/campaigns': {
      id: '/_authenticated/_app/member-portal/campaigns'
      path: '/campaigns'
      fullPath: '/member-portal/campaigns'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalCampaignsRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalRouteRoute
    }
    '/_authenticated/_app/member-portal/branding': {
      id: '/_authenticated/_app/member-portal/branding'
      path: '/branding'
      fullPath: '/member-portal/branding'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalBrandingRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalRouteRoute
    }
    '/_authenticated/_app/member-portal/agreements': {
      id: '/_authenticated/_app/member-portal/agreements'
      path: '/agreements'
      fullPath: '/member-portal/agreements'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalAgreementsRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalRouteRoute
    }
    '/_authenticated/_app/member-portal/about': {
      id: '/_authenticated/_app/member-portal/about'
      path: '/about'
      fullPath: '/member-portal/about'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalAboutRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalRouteRoute
    }
    '/_authenticated/_app/invoicing/$invoiceId': {
      id: '/_authenticated/_app/invoicing/$invoiceId'
      path: '/$invoiceId'
      fullPath: '/invoicing/$invoiceId'
      preLoaderRoute: typeof AuthenticatedAppInvoicingInvoiceIdRouteImport
      parentRoute: typeof AuthenticatedAppInvoicingRouteRoute
    }
    '/_authenticated/_app/history/$meetingID': {
      id: '/_authenticated/_app/history/$meetingID'
      path: '/history/$meetingID'
      fullPath: '/history/$meetingID'
      preLoaderRoute: typeof AuthenticatedAppHistoryMeetingIDRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/courses/create': {
      id: '/_authenticated/_app/courses/create'
      path: '/courses/create'
      fullPath: '/courses/create'
      preLoaderRoute: typeof AuthenticatedAppCoursesCreateRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/courses/$courseId': {
      id: '/_authenticated/_app/courses/$courseId'
      path: '/courses/$courseId'
      fullPath: '/courses/$courseId'
      preLoaderRoute: typeof AuthenticatedAppCoursesCourseIdRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/competence/types': {
      id: '/_authenticated/_app/competence/types'
      path: '/competence/types'
      fullPath: '/competence/types'
      preLoaderRoute: typeof AuthenticatedAppCompetenceTypesRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/competence/me': {
      id: '/_authenticated/_app/competence/me'
      path: '/competence/me'
      fullPath: '/competence/me'
      preLoaderRoute: typeof AuthenticatedAppCompetenceMeRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/competence/matrix': {
      id: '/_authenticated/_app/competence/matrix'
      path: '/competence/matrix'
      fullPath: '/competence/matrix'
      preLoaderRoute: typeof AuthenticatedAppCompetenceMatrixRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/competence/approvals': {
      id: '/_authenticated/_app/competence/approvals'
      path: '/competence/approvals'
      fullPath: '/competence/approvals'
      preLoaderRoute: typeof AuthenticatedAppCompetenceApprovalsRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/chain/staffing': {
      id: '/_authenticated/_app/chain/staffing'
      path: '/staffing'
      fullPath: '/chain/staffing'
      preLoaderRoute: typeof AuthenticatedAppChainStaffingRouteImport
      parentRoute: typeof AuthenticatedAppChainRouteRoute
    }
    '/_authenticated/_app/chain/resources': {
      id: '/_authenticated/_app/chain/resources'
      path: '/resources'
      fullPath: '/chain/resources'
      preLoaderRoute: typeof AuthenticatedAppChainResourcesRouteImport
      parentRoute: typeof AuthenticatedAppChainRouteRoute
    }
    '/_authenticated/_app/chain/quick-links': {
      id: '/_authenticated/_app/chain/quick-links'
      path: '/quick-links'
      fullPath: '/chain/quick-links'
      preLoaderRoute: typeof AuthenticatedAppChainQuickLinksRouteImport
      parentRoute: typeof AuthenticatedAppChainRouteRoute
    }
    '/_authenticated/_app/chain/order-pipeline': {
      id: '/_authenticated/_app/chain/order-pipeline'
      path: '/order-pipeline'
      fullPath: '/chain/order-pipeline'
      preLoaderRoute: typeof AuthenticatedAppChainOrderPipelineRouteImport
      parentRoute: typeof AuthenticatedAppChainRouteRoute
    }
    '/_authenticated/_app/chain/my-endorsement': {
      id: '/_authenticated/_app/chain/my-endorsement'
      path: '/my-endorsement'
      fullPath: '/chain/my-endorsement'
      preLoaderRoute: typeof AuthenticatedAppChainMyEndorsementRouteImport
      parentRoute: typeof AuthenticatedAppChainRouteRoute
    }
    '/_authenticated/_app/chain/members': {
      id: '/_authenticated/_app/chain/members'
      path: '/members'
      fullPath: '/chain/members'
      preLoaderRoute: typeof AuthenticatedAppChainMembersRouteImport
      parentRoute: typeof AuthenticatedAppChainRouteRoute
    }
    '/_authenticated/_app/chain/master-catalog': {
      id: '/_authenticated/_app/chain/master-catalog'
      path: '/master-catalog'
      fullPath: '/chain/master-catalog'
      preLoaderRoute: typeof AuthenticatedAppChainMasterCatalogRouteImport
      parentRoute: typeof AuthenticatedAppChainRouteRoute
    }
    '/_authenticated/_app/chain/learning': {
      id: '/_authenticated/_app/chain/learning'
      path: '/learning'
      fullPath: '/chain/learning'
      preLoaderRoute: typeof AuthenticatedAppChainLearningRouteImport
      parentRoute: typeof AuthenticatedAppChainRouteRoute
    }
    '/_authenticated/_app/chain/endorsement': {
      id: '/_authenticated/_app/chain/endorsement'
      path: '/endorsement'
      fullPath: '/chain/endorsement'
      preLoaderRoute: typeof AuthenticatedAppChainEndorsementRouteImport
      parentRoute: typeof AuthenticatedAppChainRouteRoute
    }
    '/_authenticated/_app/chain/coverage': {
      id: '/_authenticated/_app/chain/coverage'
      path: '/coverage'
      fullPath: '/chain/coverage'
      preLoaderRoute: typeof AuthenticatedAppChainCoverageRouteImport
      parentRoute: typeof AuthenticatedAppChainRouteRoute
    }
    '/_authenticated/_app/chain/config-pushes': {
      id: '/_authenticated/_app/chain/config-pushes'
      path: '/config-pushes'
      fullPath: '/chain/config-pushes'
      preLoaderRoute: typeof AuthenticatedAppChainConfigPushesRouteImport
      parentRoute: typeof AuthenticatedAppChainRouteRoute
    }
    '/_authenticated/_app/chain/competence': {
      id: '/_authenticated/_app/chain/competence'
      path: '/competence'
      fullPath: '/chain/competence'
      preLoaderRoute: typeof AuthenticatedAppChainCompetenceRouteImport
      parentRoute: typeof AuthenticatedAppChainRouteRoute
    }
    '/_authenticated/_app/chain/analytics': {
      id: '/_authenticated/_app/chain/analytics'
      path: '/analytics'
      fullPath: '/chain/analytics'
      preLoaderRoute: typeof AuthenticatedAppChainAnalyticsRouteImport
      parentRoute: typeof AuthenticatedAppChainRouteRoute
    }
    '/_authenticated/_app/bookings/tracking': {
      id: '/_authenticated/_app/bookings/tracking'
      path: '/tracking'
      fullPath: '/bookings/tracking'
      preLoaderRoute: typeof AuthenticatedAppBookingsTrackingRouteImport
      parentRoute: typeof AuthenticatedAppBookingsRouteRoute
    }
    '/_authenticated/_app/bookings/services': {
      id: '/_authenticated/_app/bookings/services'
      path: '/services'
      fullPath: '/bookings/services'
      preLoaderRoute: typeof AuthenticatedAppBookingsServicesRouteImport
      parentRoute: typeof AuthenticatedAppBookingsRouteRoute
    }
    '/_authenticated/_app/bookings/manage': {
      id: '/_authenticated/_app/bookings/manage'
      path: '/manage'
      fullPath: '/bookings/manage'
      preLoaderRoute: typeof AuthenticatedAppBookingsManageRouteImport
      parentRoute: typeof AuthenticatedAppBookingsRouteRoute
    }
    '/_authenticated/_app/bookings/dashboard': {
      id: '/_authenticated/_app/bookings/dashboard'
      path: '/dashboard'
      fullPath: '/bookings/dashboard'
      preLoaderRoute: typeof AuthenticatedAppBookingsDashboardRouteImport
      parentRoute: typeof AuthenticatedAppBookingsRouteRoute
    }
    '/_authenticated/_app/bookings/customize': {
      id: '/_authenticated/_app/bookings/customize'
      path: '/customize'
      fullPath: '/bookings/customize'
      preLoaderRoute: typeof AuthenticatedAppBookingsCustomizeRouteImport
      parentRoute: typeof AuthenticatedAppBookingsRouteRoute
    }
    '/_authenticated/_app/bookings/blackout-dates': {
      id: '/_authenticated/_app/bookings/blackout-dates'
      path: '/blackout-dates'
      fullPath: '/bookings/blackout-dates'
      preLoaderRoute: typeof AuthenticatedAppBookingsBlackoutDatesRouteImport
      parentRoute: typeof AuthenticatedAppBookingsRouteRoute
    }
    '/_authenticated/_app/settings/billing': {
      id: '/_authenticated/_app/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthenticatedAppSettingsBillingRouteRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/audit': {
      id: '/_authenticated/_app/settings/audit'
      path: '/audit'
      fullPath: '/settings/audit'
      preLoaderRoute: typeof AuthenticatedAppSettingsAuditRouteRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/member-portal/manage': {
      id: '/_authenticated/_app/member-portal/manage'
      path: '/manage'
      fullPath: '/member-portal/manage'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalManageRouteRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalRouteRoute
    }
    '/_authenticated/_app/crm/settings': {
      id: '/_authenticated/_app/crm/settings'
      path: '/settings'
      fullPath: '/crm/settings'
      preLoaderRoute: typeof AuthenticatedAppCrmSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/settings/roles/': {
      id: '/_authenticated/_app/settings/roles/'
      path: '/roles'
      fullPath: '/settings/roles/'
      preLoaderRoute: typeof AuthenticatedAppSettingsRolesIndexRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/meeting/': {
      id: '/_authenticated/_app/settings/meeting/'
      path: '/meeting'
      fullPath: '/settings/meeting/'
      preLoaderRoute: typeof AuthenticatedAppSettingsMeetingIndexRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/billing/': {
      id: '/_authenticated/_app/settings/billing/'
      path: '/'
      fullPath: '/settings/billing/'
      preLoaderRoute: typeof AuthenticatedAppSettingsBillingIndexRouteImport
      parentRoute: typeof AuthenticatedAppSettingsBillingRouteRoute
    }
    '/_authenticated/_app/settings/audit/': {
      id: '/_authenticated/_app/settings/audit/'
      path: '/'
      fullPath: '/settings/audit/'
      preLoaderRoute: typeof AuthenticatedAppSettingsAuditIndexRouteImport
      parentRoute: typeof AuthenticatedAppSettingsAuditRouteRoute
    }
    '/_authenticated/_app/member-portal/manage/': {
      id: '/_authenticated/_app/member-portal/manage/'
      path: '/'
      fullPath: '/member-portal/manage/'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalManageIndexRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalManageRouteRoute
    }
    '/_authenticated/_app/inspection/upcoming/': {
      id: '/_authenticated/_app/inspection/upcoming/'
      path: '/upcoming'
      fullPath: '/inspection/upcoming/'
      preLoaderRoute: typeof AuthenticatedAppInspectionUpcomingIndexRouteImport
      parentRoute: typeof AuthenticatedAppInspectionRouteRoute
    }
    '/_authenticated/_app/inspection/templates/': {
      id: '/_authenticated/_app/inspection/templates/'
      path: '/templates'
      fullPath: '/inspection/templates/'
      preLoaderRoute: typeof AuthenticatedAppInspectionTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedAppInspectionRouteRoute
    }
    '/_authenticated/_app/inspection/sites/': {
      id: '/_authenticated/_app/inspection/sites/'
      path: '/sites'
      fullPath: '/inspection/sites/'
      preLoaderRoute: typeof AuthenticatedAppInspectionSitesIndexRouteImport
      parentRoute: typeof AuthenticatedAppInspectionRouteRoute
    }
    '/_authenticated/_app/inspection/library/': {
      id: '/_authenticated/_app/inspection/library/'
      path: '/library'
      fullPath: '/inspection/library/'
      preLoaderRoute: typeof AuthenticatedAppInspectionLibraryIndexRouteImport
      parentRoute: typeof AuthenticatedAppInspectionRouteRoute
    }
    '/_authenticated/_app/crm/settings/': {
      id: '/_authenticated/_app/crm/settings/'
      path: '/'
      fullPath: '/crm/settings/'
      preLoaderRoute: typeof AuthenticatedAppCrmSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedAppCrmSettingsRouteRoute
    }
    '/_authenticated/_app/crm/reporting/': {
      id: '/_authenticated/_app/crm/reporting/'
      path: '/reporting'
      fullPath: '/crm/reporting/'
      preLoaderRoute: typeof AuthenticatedAppCrmReportingIndexRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/crm/pipeline/': {
      id: '/_authenticated/_app/crm/pipeline/'
      path: '/pipeline'
      fullPath: '/crm/pipeline/'
      preLoaderRoute: typeof AuthenticatedAppCrmPipelineIndexRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/crm/my-work/': {
      id: '/_authenticated/_app/crm/my-work/'
      path: '/my-work'
      fullPath: '/crm/my-work/'
      preLoaderRoute: typeof AuthenticatedAppCrmMyWorkIndexRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/crm/leads/': {
      id: '/_authenticated/_app/crm/leads/'
      path: '/leads'
      fullPath: '/crm/leads/'
      preLoaderRoute: typeof AuthenticatedAppCrmLeadsIndexRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/crm/duplicates/': {
      id: '/_authenticated/_app/crm/duplicates/'
      path: '/duplicates'
      fullPath: '/crm/duplicates/'
      preLoaderRoute: typeof AuthenticatedAppCrmDuplicatesIndexRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/crm/deals/': {
      id: '/_authenticated/_app/crm/deals/'
      path: '/deals'
      fullPath: '/crm/deals/'
      preLoaderRoute: typeof AuthenticatedAppCrmDealsIndexRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/crm/contacts/': {
      id: '/_authenticated/_app/crm/contacts/'
      path: '/contacts'
      fullPath: '/crm/contacts/'
      preLoaderRoute: typeof AuthenticatedAppCrmContactsIndexRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/crm/companies/': {
      id: '/_authenticated/_app/crm/companies/'
      path: '/companies'
      fullPath: '/crm/companies/'
      preLoaderRoute: typeof AuthenticatedAppCrmCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/crm/catalog/': {
      id: '/_authenticated/_app/crm/catalog/'
      path: '/catalog'
      fullPath: '/crm/catalog/'
      preLoaderRoute: typeof AuthenticatedAppCrmCatalogIndexRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/chain/courses/': {
      id: '/_authenticated/_app/chain/courses/'
      path: '/courses'
      fullPath: '/chain/courses/'
      preLoaderRoute: typeof AuthenticatedAppChainCoursesIndexRouteImport
      parentRoute: typeof AuthenticatedAppChainRouteRoute
    }
    '/_authenticated/_app/chain/announcements/': {
      id: '/_authenticated/_app/chain/announcements/'
      path: '/announcements'
      fullPath: '/chain/announcements/'
      preLoaderRoute: typeof AuthenticatedAppChainAnnouncementsIndexRouteImport
      parentRoute: typeof AuthenticatedAppChainRouteRoute
    }
    '/_authenticated/super-admin/companies/$companyId_/roles': {
      id: '/_authenticated/super-admin/companies/$companyId_/roles'
      path: '/companies/$companyId/roles'
      fullPath: '/super-admin/companies/$companyId/roles'
      preLoaderRoute: typeof AuthenticatedSuperAdminCompaniesCompanyIdRolesRouteImport
      parentRoute: typeof AuthenticatedSuperAdminRouteRoute
    }
    '/_authenticated/_app/staffing/postings/new': {
      id: '/_authenticated/_app/staffing/postings/new'
      path: '/postings/new'
      fullPath: '/staffing/postings/new'
      preLoaderRoute: typeof AuthenticatedAppStaffingPostingsNewRouteImport
      parentRoute: typeof AuthenticatedAppStaffingRouteRoute
    }
    '/_authenticated/_app/staffing/postings/$id': {
      id: '/_authenticated/_app/staffing/postings/$id'
      path: '/postings/$id'
      fullPath: '/staffing/postings/$id'
      preLoaderRoute: typeof AuthenticatedAppStaffingPostingsIdRouteImport
      parentRoute: typeof AuthenticatedAppStaffingRouteRoute
    }
    '/_authenticated/_app/settings/roles/new': {
      id: '/_authenticated/_app/settings/roles/new'
      path: '/roles/new'
      fullPath: '/settings/roles/new'
      preLoaderRoute: typeof AuthenticatedAppSettingsRolesNewRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/roles/$roleId': {
      id: '/_authenticated/_app/settings/roles/$roleId'
      path: '/roles/$roleId'
      fullPath: '/settings/roles/$roleId'
      preLoaderRoute: typeof AuthenticatedAppSettingsRolesRoleIdRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/orders/pipeline': {
      id: '/_authenticated/_app/settings/orders/pipeline'
      path: '/orders/pipeline'
      fullPath: '/settings/orders/pipeline'
      preLoaderRoute: typeof AuthenticatedAppSettingsOrdersPipelineRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/meeting/recording': {
      id: '/_authenticated/_app/settings/meeting/recording'
      path: '/meeting/recording'
      fullPath: '/settings/meeting/recording'
      preLoaderRoute: typeof AuthenticatedAppSettingsMeetingRecordingRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/meeting/defaults': {
      id: '/_authenticated/_app/settings/meeting/defaults'
      path: '/meeting/defaults'
      fullPath: '/settings/meeting/defaults'
      preLoaderRoute: typeof AuthenticatedAppSettingsMeetingDefaultsRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/meeting/background': {
      id: '/_authenticated/_app/settings/meeting/background'
      path: '/meeting/background'
      fullPath: '/settings/meeting/background'
      preLoaderRoute: typeof AuthenticatedAppSettingsMeetingBackgroundRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/invoicing/accounting': {
      id: '/_authenticated/_app/settings/invoicing/accounting'
      path: '/invoicing/accounting'
      fullPath: '/settings/invoicing/accounting'
      preLoaderRoute: typeof AuthenticatedAppSettingsInvoicingAccountingRouteImport
      parentRoute: typeof AuthenticatedAppSettingsRouteRoute
    }
    '/_authenticated/_app/settings/billing/payments': {
      id: '/_authenticated/_app/settings/billing/payments'
      path: '/payments'
      fullPath: '/settings/billing/payments'
      preLoaderRoute: typeof AuthenticatedAppSettingsBillingPaymentsRouteImport
      parentRoute: typeof AuthenticatedAppSettingsBillingRouteRoute
    }
    '/_authenticated/_app/settings/billing/addons': {
      id: '/_authenticated/_app/settings/billing/addons'
      path: '/addons'
      fullPath: '/settings/billing/addons'
      preLoaderRoute: typeof AuthenticatedAppSettingsBillingAddonsRouteImport
      parentRoute: typeof AuthenticatedAppSettingsBillingRouteRoute
    }
    '/_authenticated/_app/record-and-send/video-types/new': {
      id: '/_authenticated/_app/record-and-send/video-types/new'
      path: '/record-and-send/video-types/new'
      fullPath: '/record-and-send/video-types/new'
      preLoaderRoute: typeof AuthenticatedAppRecordAndSendVideoTypesNewRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/record-and-send/submissions/$submissionId': {
      id: '/_authenticated/_app/record-and-send/submissions/$submissionId'
      path: '/record-and-send/submissions/$submissionId'
      fullPath: '/record-and-send/submissions/$submissionId'
      preLoaderRoute: typeof AuthenticatedAppRecordAndSendSubmissionsSubmissionIdRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/member-portal/tools/$id': {
      id: '/_authenticated/_app/member-portal/tools/$id'
      path: '/$id'
      fullPath: '/member-portal/tools/$id'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalToolsIdRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalToolsRoute
    }
    '/_authenticated/_app/member-portal/suppliers/$id': {
      id: '/_authenticated/_app/member-portal/suppliers/$id'
      path: '/$id'
      fullPath: '/member-portal/suppliers/$id'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalSuppliersIdRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalSuppliersRoute
    }
    '/_authenticated/_app/member-portal/manage/tools': {
      id: '/_authenticated/_app/member-portal/manage/tools'
      path: '/tools'
      fullPath: '/member-portal/manage/tools'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalManageToolsRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalManageRouteRoute
    }
    '/_authenticated/_app/member-portal/manage/suppliers': {
      id: '/_authenticated/_app/member-portal/manage/suppliers'
      path: '/suppliers'
      fullPath: '/member-portal/manage/suppliers'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalManageSuppliersRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalManageRouteRoute
    }
    '/_authenticated/_app/member-portal/manage/contacts': {
      id: '/_authenticated/_app/member-portal/manage/contacts'
      path: '/contacts'
      fullPath: '/member-portal/manage/contacts'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalManageContactsRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalManageRouteRoute
    }
    '/_authenticated/_app/member-portal/manage/communications': {
      id: '/_authenticated/_app/member-portal/manage/communications'
      path: '/communications'
      fullPath: '/member-portal/manage/communications'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalManageCommunicationsRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalManageRouteRoute
    }
    '/_authenticated/_app/member-portal/manage/campaigns': {
      id: '/_authenticated/_app/member-portal/manage/campaigns'
      path: '/campaigns'
      fullPath: '/member-portal/manage/campaigns'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalManageCampaignsRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalManageRouteRoute
    }
    '/_authenticated/_app/member-portal/manage/branding': {
      id: '/_authenticated/_app/member-portal/manage/branding'
      path: '/branding'
      fullPath: '/member-portal/manage/branding'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalManageBrandingRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalManageRouteRoute
    }
    '/_authenticated/_app/member-portal/manage/agreements': {
      id: '/_authenticated/_app/member-portal/manage/agreements'
      path: '/agreements'
      fullPath: '/member-portal/manage/agreements'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalManageAgreementsRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalManageRouteRoute
    }
    '/_authenticated/_app/member-portal/manage/about': {
      id: '/_authenticated/_app/member-portal/manage/about'
      path: '/about'
      fullPath: '/member-portal/manage/about'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalManageAboutRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalManageRouteRoute
    }
    '/_authenticated/_app/member-portal/communications/$id': {
      id: '/_authenticated/_app/member-portal/communications/$id'
      path: '/$id'
      fullPath: '/member-portal/communications/$id'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalCommunicationsIdRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalCommunicationsRoute
    }
    '/_authenticated/_app/member-portal/campaigns/$slug': {
      id: '/_authenticated/_app/member-portal/campaigns/$slug'
      path: '/$slug'
      fullPath: '/member-portal/campaigns/$slug'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalCampaignsSlugRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalCampaignsRoute
    }
    '/_authenticated/_app/member-portal/branding_/$id': {
      id: '/_authenticated/_app/member-portal/branding_/$id'
      path: '/branding/$id'
      fullPath: '/member-portal/branding/$id'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalBrandingIdRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalRouteRoute
    }
    '/_authenticated/_app/member-portal/agreements/$id': {
      id: '/_authenticated/_app/member-portal/agreements/$id'
      path: '/$id'
      fullPath: '/member-portal/agreements/$id'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalAgreementsIdRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalAgreementsRoute
    }
    '/_authenticated/_app/invoicing/prepare/$orderId': {
      id: '/_authenticated/_app/invoicing/prepare/$orderId'
      path: '/prepare/$orderId'
      fullPath: '/invoicing/prepare/$orderId'
      preLoaderRoute: typeof AuthenticatedAppInvoicingPrepareOrderIdRouteImport
      parentRoute: typeof AuthenticatedAppInvoicingRouteRoute
    }
    '/_authenticated/_app/inspection/templates/$templateId': {
      id: '/_authenticated/_app/inspection/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/inspection/templates/$templateId'
      preLoaderRoute: typeof AuthenticatedAppInspectionTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedAppInspectionRouteRoute
    }
    '/_authenticated/_app/inspection/sites/$siteId': {
      id: '/_authenticated/_app/inspection/sites/$siteId'
      path: '/sites/$siteId'
      fullPath: '/inspection/sites/$siteId'
      preLoaderRoute: typeof AuthenticatedAppInspectionSitesSiteIdRouteImport
      parentRoute: typeof AuthenticatedAppInspectionRouteRoute
    }
    '/_authenticated/_app/forms/$formId/submissions': {
      id: '/_authenticated/_app/forms/$formId/submissions'
      path: '/$formId/submissions'
      fullPath: '/forms/$formId/submissions'
      preLoaderRoute: typeof AuthenticatedAppFormsFormIdSubmissionsRouteImport
      parentRoute: typeof AuthenticatedAppFormsRouteRoute
    }
    '/_authenticated/_app/forms/$formId/designer': {
      id: '/_authenticated/_app/forms/$formId/designer'
      path: '/$formId/designer'
      fullPath: '/forms/$formId/designer'
      preLoaderRoute: typeof AuthenticatedAppFormsFormIdDesignerRouteImport
      parentRoute: typeof AuthenticatedAppFormsRouteRoute
    }
    '/_authenticated/_app/forms/$formId/analytics': {
      id: '/_authenticated/_app/forms/$formId/analytics'
      path: '/$formId/analytics'
      fullPath: '/forms/$formId/analytics'
      preLoaderRoute: typeof AuthenticatedAppFormsFormIdAnalyticsRouteImport
      parentRoute: typeof AuthenticatedAppFormsRouteRoute
    }
    '/_authenticated/_app/crm/settings/order-pipeline': {
      id: '/_authenticated/_app/crm/settings/order-pipeline'
      path: '/order-pipeline'
      fullPath: '/crm/settings/order-pipeline'
      preLoaderRoute: typeof AuthenticatedAppCrmSettingsOrderPipelineRouteImport
      parentRoute: typeof AuthenticatedAppCrmSettingsRouteRoute
    }
    '/_authenticated/_app/crm/settings/offer-defaults': {
      id: '/_authenticated/_app/crm/settings/offer-defaults'
      path: '/offer-defaults'
      fullPath: '/crm/settings/offer-defaults'
      preLoaderRoute: typeof AuthenticatedAppCrmSettingsOfferDefaultsRouteImport
      parentRoute: typeof AuthenticatedAppCrmSettingsRouteRoute
    }
    '/_authenticated/_app/crm/settings/lost-reasons': {
      id: '/_authenticated/_app/crm/settings/lost-reasons'
      path: '/lost-reasons'
      fullPath: '/crm/settings/lost-reasons'
      preLoaderRoute: typeof AuthenticatedAppCrmSettingsLostReasonsRouteImport
      parentRoute: typeof AuthenticatedAppCrmSettingsRouteRoute
    }
    '/_authenticated/_app/crm/settings/deal-fields': {
      id: '/_authenticated/_app/crm/settings/deal-fields'
      path: '/deal-fields'
      fullPath: '/crm/settings/deal-fields'
      preLoaderRoute: typeof AuthenticatedAppCrmSettingsDealFieldsRouteImport
      parentRoute: typeof AuthenticatedAppCrmSettingsRouteRoute
    }
    '/_authenticated/_app/crm/settings/contact-fields': {
      id: '/_authenticated/_app/crm/settings/contact-fields'
      path: '/contact-fields'
      fullPath: '/crm/settings/contact-fields'
      preLoaderRoute: typeof AuthenticatedAppCrmSettingsContactFieldsRouteImport
      parentRoute: typeof AuthenticatedAppCrmSettingsRouteRoute
    }
    '/_authenticated/_app/crm/settings/company-fields': {
      id: '/_authenticated/_app/crm/settings/company-fields'
      path: '/company-fields'
      fullPath: '/crm/settings/company-fields'
      preLoaderRoute: typeof AuthenticatedAppCrmSettingsCompanyFieldsRouteImport
      parentRoute: typeof AuthenticatedAppCrmSettingsRouteRoute
    }
    '/_authenticated/_app/crm/pipeline/$pipelineId': {
      id: '/_authenticated/_app/crm/pipeline/$pipelineId'
      path: '/pipeline/$pipelineId'
      fullPath: '/crm/pipeline/$pipelineId'
      preLoaderRoute: typeof AuthenticatedAppCrmPipelinePipelineIdRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/crm/leads/$leadId': {
      id: '/_authenticated/_app/crm/leads/$leadId'
      path: '/leads/$leadId'
      fullPath: '/crm/leads/$leadId'
      preLoaderRoute: typeof AuthenticatedAppCrmLeadsLeadIdRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/crm/deals/$dealId': {
      id: '/_authenticated/_app/crm/deals/$dealId'
      path: '/deals/$dealId'
      fullPath: '/crm/deals/$dealId'
      preLoaderRoute: typeof AuthenticatedAppCrmDealsDealIdRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/crm/contacts/$contactId': {
      id: '/_authenticated/_app/crm/contacts/$contactId'
      path: '/contacts/$contactId'
      fullPath: '/crm/contacts/$contactId'
      preLoaderRoute: typeof AuthenticatedAppCrmContactsContactIdRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/crm/companies/$id': {
      id: '/_authenticated/_app/crm/companies/$id'
      path: '/companies/$id'
      fullPath: '/crm/companies/$id'
      preLoaderRoute: typeof AuthenticatedAppCrmCompaniesIdRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/crm/chain/pipeline': {
      id: '/_authenticated/_app/crm/chain/pipeline'
      path: '/chain/pipeline'
      fullPath: '/crm/chain/pipeline'
      preLoaderRoute: typeof AuthenticatedAppCrmChainPipelineRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/crm/chain/parent-incoming': {
      id: '/_authenticated/_app/crm/chain/parent-incoming'
      path: '/chain/parent-incoming'
      fullPath: '/crm/chain/parent-incoming'
      preLoaderRoute: typeof AuthenticatedAppCrmChainParentIncomingRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/crm/chain/members': {
      id: '/_authenticated/_app/crm/chain/members'
      path: '/chain/members'
      fullPath: '/crm/chain/members'
      preLoaderRoute: typeof AuthenticatedAppCrmChainMembersRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/crm/chain/distribution': {
      id: '/_authenticated/_app/crm/chain/distribution'
      path: '/chain/distribution'
      fullPath: '/crm/chain/distribution'
      preLoaderRoute: typeof AuthenticatedAppCrmChainDistributionRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/courses/$courseId_/edit': {
      id: '/_authenticated/_app/courses/$courseId_/edit'
      path: '/courses/$courseId/edit'
      fullPath: '/courses/$courseId/edit'
      preLoaderRoute: typeof AuthenticatedAppCoursesCourseIdEditRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/competence/user/$userId': {
      id: '/_authenticated/_app/competence/user/$userId'
      path: '/competence/user/$userId'
      fullPath: '/competence/user/$userId'
      preLoaderRoute: typeof AuthenticatedAppCompetenceUserUserIdRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/chain/announcements/$announcementId': {
      id: '/_authenticated/_app/chain/announcements/$announcementId'
      path: '/announcements/$announcementId'
      fullPath: '/chain/announcements/$announcementId'
      preLoaderRoute: typeof AuthenticatedAppChainAnnouncementsAnnouncementIdRouteImport
      parentRoute: typeof AuthenticatedAppChainRouteRoute
    }
    '/_authenticated/_app/record-and-send/video-types/$videoTypeId': {
      id: '/_authenticated/_app/record-and-send/video-types/$videoTypeId'
      path: '/record-and-send/video-types/$videoTypeId'
      fullPath: '/record-and-send/video-types/$videoTypeId'
      preLoaderRoute: typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRouteImport
      parentRoute: typeof AuthenticatedAppRouteRoute
    }
    '/_authenticated/_app/inspection/inspections/$inspectionId': {
      id: '/_authenticated/_app/inspection/inspections/$inspectionId'
      path: '/inspections/$inspectionId'
      fullPath: '/inspection/inspections/$inspectionId'
      preLoaderRoute: typeof AuthenticatedAppInspectionInspectionsInspectionIdRouteRouteImport
      parentRoute: typeof AuthenticatedAppInspectionRouteRoute
    }
    '/_authenticated/_app/chain/companies/$memberId': {
      id: '/_authenticated/_app/chain/companies/$memberId'
      path: '/companies/$memberId'
      fullPath: '/chain/companies/$memberId'
      preLoaderRoute: typeof AuthenticatedAppChainCompaniesMemberIdRouteRouteImport
      parentRoute: typeof AuthenticatedAppChainRouteRoute
    }
    '/_authenticated/_app/settings/billing/pricing/': {
      id: '/_authenticated/_app/settings/billing/pricing/'
      path: '/pricing'
      fullPath: '/settings/billing/pricing/'
      preLoaderRoute: typeof AuthenticatedAppSettingsBillingPricingIndexRouteImport
      parentRoute: typeof AuthenticatedAppSettingsBillingRouteRoute
    }
    '/_authenticated/_app/record-and-send/video-types/$videoTypeId/': {
      id: '/_authenticated/_app/record-and-send/video-types/$videoTypeId/'
      path: '/'
      fullPath: '/record-and-send/video-types/$videoTypeId/'
      preLoaderRoute: typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdIndexRouteImport
      parentRoute: typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRoute
    }
    '/_authenticated/_app/inspection/inspections/$inspectionId/': {
      id: '/_authenticated/_app/inspection/inspections/$inspectionId/'
      path: '/'
      fullPath: '/inspection/inspections/$inspectionId/'
      preLoaderRoute: typeof AuthenticatedAppInspectionInspectionsInspectionIdIndexRouteImport
      parentRoute: typeof AuthenticatedAppInspectionInspectionsInspectionIdRouteRoute
    }
    '/_authenticated/_app/crm/settings/pipelines/': {
      id: '/_authenticated/_app/crm/settings/pipelines/'
      path: '/pipelines'
      fullPath: '/crm/settings/pipelines/'
      preLoaderRoute: typeof AuthenticatedAppCrmSettingsPipelinesIndexRouteImport
      parentRoute: typeof AuthenticatedAppCrmSettingsRouteRoute
    }
    '/_authenticated/_app/chain/companies/$memberId/': {
      id: '/_authenticated/_app/chain/companies/$memberId/'
      path: '/'
      fullPath: '/chain/companies/$memberId/'
      preLoaderRoute: typeof AuthenticatedAppChainCompaniesMemberIdIndexRouteImport
      parentRoute: typeof AuthenticatedAppChainCompaniesMemberIdRouteRoute
    }
    '/_authenticated/_app/staffing/postings/$id_/edit': {
      id: '/_authenticated/_app/staffing/postings/$id_/edit'
      path: '/postings/$id/edit'
      fullPath: '/staffing/postings/$id/edit'
      preLoaderRoute: typeof AuthenticatedAppStaffingPostingsIdEditRouteImport
      parentRoute: typeof AuthenticatedAppStaffingRouteRoute
    }
    '/_authenticated/_app/settings/billing/pricing/checkout': {
      id: '/_authenticated/_app/settings/billing/pricing/checkout'
      path: '/pricing/checkout'
      fullPath: '/settings/billing/pricing/checkout'
      preLoaderRoute: typeof AuthenticatedAppSettingsBillingPricingCheckoutRouteImport
      parentRoute: typeof AuthenticatedAppSettingsBillingRouteRoute
    }
    '/_authenticated/_app/record-and-send/video-types/$videoTypeId/videos': {
      id: '/_authenticated/_app/record-and-send/video-types/$videoTypeId/videos'
      path: '/videos'
      fullPath: '/record-and-send/video-types/$videoTypeId/videos'
      preLoaderRoute: typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdVideosRouteImport
      parentRoute: typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRoute
    }
    '/_authenticated/_app/record-and-send/video-types/$videoTypeId/settings': {
      id: '/_authenticated/_app/record-and-send/video-types/$videoTypeId/settings'
      path: '/settings'
      fullPath: '/record-and-send/video-types/$videoTypeId/settings'
      preLoaderRoute: typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdSettingsRouteImport
      parentRoute: typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRoute
    }
    '/_authenticated/_app/record-and-send/video-types/$videoTypeId/requests': {
      id: '/_authenticated/_app/record-and-send/video-types/$videoTypeId/requests'
      path: '/requests'
      fullPath: '/record-and-send/video-types/$videoTypeId/requests'
      preLoaderRoute: typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRequestsRouteImport
      parentRoute: typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRoute
    }
    '/_authenticated/_app/member-portal/manage/tools/$id': {
      id: '/_authenticated/_app/member-portal/manage/tools/$id'
      path: '/$id'
      fullPath: '/member-portal/manage/tools/$id'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalManageToolsIdRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalManageToolsRoute
    }
    '/_authenticated/_app/member-portal/manage/suppliers/$id': {
      id: '/_authenticated/_app/member-portal/manage/suppliers/$id'
      path: '/$id'
      fullPath: '/member-portal/manage/suppliers/$id'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalManageSuppliersIdRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalManageSuppliersRoute
    }
    '/_authenticated/_app/member-portal/manage/contacts/$id': {
      id: '/_authenticated/_app/member-portal/manage/contacts/$id'
      path: '/$id'
      fullPath: '/member-portal/manage/contacts/$id'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalManageContactsIdRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalManageContactsRoute
    }
    '/_authenticated/_app/member-portal/manage/communications/$id': {
      id: '/_authenticated/_app/member-portal/manage/communications/$id'
      path: '/$id'
      fullPath: '/member-portal/manage/communications/$id'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalManageCommunicationsIdRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalManageCommunicationsRoute
    }
    '/_authenticated/_app/member-portal/manage/campaigns/$id': {
      id: '/_authenticated/_app/member-portal/manage/campaigns/$id'
      path: '/$id'
      fullPath: '/member-portal/manage/campaigns/$id'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalManageCampaignsIdRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalManageCampaignsRoute
    }
    '/_authenticated/_app/member-portal/manage/branding/$id': {
      id: '/_authenticated/_app/member-portal/manage/branding/$id'
      path: '/$id'
      fullPath: '/member-portal/manage/branding/$id'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalManageBrandingIdRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalManageBrandingRoute
    }
    '/_authenticated/_app/member-portal/manage/agreements/$id': {
      id: '/_authenticated/_app/member-portal/manage/agreements/$id'
      path: '/$id'
      fullPath: '/member-portal/manage/agreements/$id'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalManageAgreementsIdRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalManageAgreementsRoute
    }
    '/_authenticated/_app/member-portal/campaigns/by-id/$id': {
      id: '/_authenticated/_app/member-portal/campaigns/by-id/$id'
      path: '/by-id/$id'
      fullPath: '/member-portal/campaigns/by-id/$id'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalCampaignsByIdIdRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalCampaignsRoute
    }
    '/_authenticated/_app/inspection/inspections/$inspectionId/progress': {
      id: '/_authenticated/_app/inspection/inspections/$inspectionId/progress'
      path: '/progress'
      fullPath: '/inspection/inspections/$inspectionId/progress'
      preLoaderRoute: typeof AuthenticatedAppInspectionInspectionsInspectionIdProgressRouteImport
      parentRoute: typeof AuthenticatedAppInspectionInspectionsInspectionIdRouteRoute
    }
    '/_authenticated/_app/inspection/inspections/$inspectionId/evidence': {
      id: '/_authenticated/_app/inspection/inspections/$inspectionId/evidence'
      path: '/evidence'
      fullPath: '/inspection/inspections/$inspectionId/evidence'
      preLoaderRoute: typeof AuthenticatedAppInspectionInspectionsInspectionIdEvidenceRouteImport
      parentRoute: typeof AuthenticatedAppInspectionInspectionsInspectionIdRouteRoute
    }
    '/_authenticated/_app/inspection/inspections/$inspectionId/captures': {
      id: '/_authenticated/_app/inspection/inspections/$inspectionId/captures'
      path: '/captures'
      fullPath: '/inspection/inspections/$inspectionId/captures'
      preLoaderRoute: typeof AuthenticatedAppInspectionInspectionsInspectionIdCapturesRouteImport
      parentRoute: typeof AuthenticatedAppInspectionInspectionsInspectionIdRouteRoute
    }
    '/_authenticated/_app/inspection/inspections/$inspectionId/capture': {
      id: '/_authenticated/_app/inspection/inspections/$inspectionId/capture'
      path: '/capture'
      fullPath: '/inspection/inspections/$inspectionId/capture'
      preLoaderRoute: typeof AuthenticatedAppInspectionInspectionsInspectionIdCaptureRouteImport
      parentRoute: typeof AuthenticatedAppInspectionInspectionsInspectionIdRouteRoute
    }
    '/_authenticated/_app/crm/settings/pipelines/$pipelineId': {
      id: '/_authenticated/_app/crm/settings/pipelines/$pipelineId'
      path: '/pipelines/$pipelineId'
      fullPath: '/crm/settings/pipelines/$pipelineId'
      preLoaderRoute: typeof AuthenticatedAppCrmSettingsPipelinesPipelineIdRouteImport
      parentRoute: typeof AuthenticatedAppCrmSettingsRouteRoute
    }
    '/_authenticated/_app/chain/courses/$courseId/manage': {
      id: '/_authenticated/_app/chain/courses/$courseId/manage'
      path: '/courses/$courseId/manage'
      fullPath: '/chain/courses/$courseId/manage'
      preLoaderRoute: typeof AuthenticatedAppChainCoursesCourseIdManageRouteImport
      parentRoute: typeof AuthenticatedAppChainRouteRoute
    }
    '/_authenticated/_app/settings/audit/timeline/$targetType/$targetId': {
      id: '/_authenticated/_app/settings/audit/timeline/$targetType/$targetId'
      path: '/timeline/$targetType/$targetId'
      fullPath: '/settings/audit/timeline/$targetType/$targetId'
      preLoaderRoute: typeof AuthenticatedAppSettingsAuditTimelineTargetTypeTargetIdRouteImport
      parentRoute: typeof AuthenticatedAppSettingsAuditRouteRoute
    }
    '/_authenticated/_app/crm/deals/$dealId_/offers/$versionId': {
      id: '/_authenticated/_app/crm/deals/$dealId_/offers/$versionId'
      path: '/deals/$dealId/offers/$versionId'
      fullPath: '/crm/deals/$dealId/offers/$versionId'
      preLoaderRoute: typeof AuthenticatedAppCrmDealsDealIdOffersVersionIdRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/chain/companies/$memberId/inspections/$inspectionId/': {
      id: '/_authenticated/_app/chain/companies/$memberId/inspections/$inspectionId/'
      path: '/inspections/$inspectionId'
      fullPath: '/chain/companies/$memberId/inspections/$inspectionId/'
      preLoaderRoute: typeof AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdIndexRouteImport
      parentRoute: typeof AuthenticatedAppChainCompaniesMemberIdRouteRoute
    }
    '/_authenticated/_app/member-portal/manage/communications/$id_/responses/$companyId': {
      id: '/_authenticated/_app/member-portal/manage/communications/$id_/responses/$companyId'
      path: '/$id/responses/$companyId'
      fullPath: '/member-portal/manage/communications/$id/responses/$companyId'
      preLoaderRoute: typeof AuthenticatedAppMemberPortalManageCommunicationsIdResponsesCompanyIdRouteImport
      parentRoute: typeof AuthenticatedAppMemberPortalManageCommunicationsRoute
    }
    '/_authenticated/_app/crm/deals/$dealId_/offers/$versionId_/edit': {
      id: '/_authenticated/_app/crm/deals/$dealId_/offers/$versionId_/edit'
      path: '/deals/$dealId/offers/$versionId/edit'
      fullPath: '/crm/deals/$dealId/offers/$versionId/edit'
      preLoaderRoute: typeof AuthenticatedAppCrmDealsDealIdOffersVersionIdEditRouteImport
      parentRoute: typeof AuthenticatedAppCrmRouteRoute
    }
    '/_authenticated/_app/chain/companies/$memberId/inspections/$inspectionId/progress': {
      id: '/_authenticated/_app/chain/companies/$memberId/inspections/$inspectionId/progress'
      path: '/inspections/$inspectionId/progress'
      fullPath: '/chain/companies/$memberId/inspections/$inspectionId/progress'
      preLoaderRoute: typeof AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdProgressRouteImport
      parentRoute: typeof AuthenticatedAppChainCompaniesMemberIdRouteRoute
    }
  }
}

interface AuthenticatedAppBookingsRouteRouteChildren {
  AuthenticatedAppBookingsBlackoutDatesRoute: typeof AuthenticatedAppBookingsBlackoutDatesRoute
  AuthenticatedAppBookingsCustomizeRoute: typeof AuthenticatedAppBookingsCustomizeRoute
  AuthenticatedAppBookingsDashboardRoute: typeof AuthenticatedAppBookingsDashboardRoute
  AuthenticatedAppBookingsManageRoute: typeof AuthenticatedAppBookingsManageRoute
  AuthenticatedAppBookingsServicesRoute: typeof AuthenticatedAppBookingsServicesRoute
  AuthenticatedAppBookingsTrackingRoute: typeof AuthenticatedAppBookingsTrackingRoute
  AuthenticatedAppBookingsIndexRoute: typeof AuthenticatedAppBookingsIndexRoute
}

const AuthenticatedAppBookingsRouteRouteChildren: AuthenticatedAppBookingsRouteRouteChildren =
  {
    AuthenticatedAppBookingsBlackoutDatesRoute:
      AuthenticatedAppBookingsBlackoutDatesRoute,
    AuthenticatedAppBookingsCustomizeRoute:
      AuthenticatedAppBookingsCustomizeRoute,
    AuthenticatedAppBookingsDashboardRoute:
      AuthenticatedAppBookingsDashboardRoute,
    AuthenticatedAppBookingsManageRoute: AuthenticatedAppBookingsManageRoute,
    AuthenticatedAppBookingsServicesRoute:
      AuthenticatedAppBookingsServicesRoute,
    AuthenticatedAppBookingsTrackingRoute:
      AuthenticatedAppBookingsTrackingRoute,
    AuthenticatedAppBookingsIndexRoute: AuthenticatedAppBookingsIndexRoute,
  }

const AuthenticatedAppBookingsRouteRouteWithChildren =
  AuthenticatedAppBookingsRouteRoute._addFileChildren(
    AuthenticatedAppBookingsRouteRouteChildren,
  )

interface AuthenticatedAppChainCompaniesMemberIdRouteRouteChildren {
  AuthenticatedAppChainCompaniesMemberIdIndexRoute: typeof AuthenticatedAppChainCompaniesMemberIdIndexRoute
  AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdProgressRoute: typeof AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdProgressRoute
  AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdIndexRoute: typeof AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdIndexRoute
}

const AuthenticatedAppChainCompaniesMemberIdRouteRouteChildren: AuthenticatedAppChainCompaniesMemberIdRouteRouteChildren =
  {
    AuthenticatedAppChainCompaniesMemberIdIndexRoute:
      AuthenticatedAppChainCompaniesMemberIdIndexRoute,
    AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdProgressRoute:
      AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdProgressRoute,
    AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdIndexRoute:
      AuthenticatedAppChainCompaniesMemberIdInspectionsInspectionIdIndexRoute,
  }

const AuthenticatedAppChainCompaniesMemberIdRouteRouteWithChildren =
  AuthenticatedAppChainCompaniesMemberIdRouteRoute._addFileChildren(
    AuthenticatedAppChainCompaniesMemberIdRouteRouteChildren,
  )

interface AuthenticatedAppChainRouteRouteChildren {
  AuthenticatedAppChainAnalyticsRoute: typeof AuthenticatedAppChainAnalyticsRoute
  AuthenticatedAppChainCompetenceRoute: typeof AuthenticatedAppChainCompetenceRoute
  AuthenticatedAppChainConfigPushesRoute: typeof AuthenticatedAppChainConfigPushesRoute
  AuthenticatedAppChainCoverageRoute: typeof AuthenticatedAppChainCoverageRoute
  AuthenticatedAppChainEndorsementRoute: typeof AuthenticatedAppChainEndorsementRoute
  AuthenticatedAppChainLearningRoute: typeof AuthenticatedAppChainLearningRoute
  AuthenticatedAppChainMasterCatalogRoute: typeof AuthenticatedAppChainMasterCatalogRoute
  AuthenticatedAppChainMembersRoute: typeof AuthenticatedAppChainMembersRoute
  AuthenticatedAppChainMyEndorsementRoute: typeof AuthenticatedAppChainMyEndorsementRoute
  AuthenticatedAppChainOrderPipelineRoute: typeof AuthenticatedAppChainOrderPipelineRoute
  AuthenticatedAppChainQuickLinksRoute: typeof AuthenticatedAppChainQuickLinksRoute
  AuthenticatedAppChainResourcesRoute: typeof AuthenticatedAppChainResourcesRoute
  AuthenticatedAppChainStaffingRoute: typeof AuthenticatedAppChainStaffingRoute
  AuthenticatedAppChainCompaniesMemberIdRouteRoute: typeof AuthenticatedAppChainCompaniesMemberIdRouteRouteWithChildren
  AuthenticatedAppChainAnnouncementsAnnouncementIdRoute: typeof AuthenticatedAppChainAnnouncementsAnnouncementIdRoute
  AuthenticatedAppChainAnnouncementsIndexRoute: typeof AuthenticatedAppChainAnnouncementsIndexRoute
  AuthenticatedAppChainCoursesIndexRoute: typeof AuthenticatedAppChainCoursesIndexRoute
  AuthenticatedAppChainCoursesCourseIdManageRoute: typeof AuthenticatedAppChainCoursesCourseIdManageRoute
}

const AuthenticatedAppChainRouteRouteChildren: AuthenticatedAppChainRouteRouteChildren =
  {
    AuthenticatedAppChainAnalyticsRoute: AuthenticatedAppChainAnalyticsRoute,
    AuthenticatedAppChainCompetenceRoute: AuthenticatedAppChainCompetenceRoute,
    AuthenticatedAppChainConfigPushesRoute:
      AuthenticatedAppChainConfigPushesRoute,
    AuthenticatedAppChainCoverageRoute: AuthenticatedAppChainCoverageRoute,
    AuthenticatedAppChainEndorsementRoute:
      AuthenticatedAppChainEndorsementRoute,
    AuthenticatedAppChainLearningRoute: AuthenticatedAppChainLearningRoute,
    AuthenticatedAppChainMasterCatalogRoute:
      AuthenticatedAppChainMasterCatalogRoute,
    AuthenticatedAppChainMembersRoute: AuthenticatedAppChainMembersRoute,
    AuthenticatedAppChainMyEndorsementRoute:
      AuthenticatedAppChainMyEndorsementRoute,
    AuthenticatedAppChainOrderPipelineRoute:
      AuthenticatedAppChainOrderPipelineRoute,
    AuthenticatedAppChainQuickLinksRoute: AuthenticatedAppChainQuickLinksRoute,
    AuthenticatedAppChainResourcesRoute: AuthenticatedAppChainResourcesRoute,
    AuthenticatedAppChainStaffingRoute: AuthenticatedAppChainStaffingRoute,
    AuthenticatedAppChainCompaniesMemberIdRouteRoute:
      AuthenticatedAppChainCompaniesMemberIdRouteRouteWithChildren,
    AuthenticatedAppChainAnnouncementsAnnouncementIdRoute:
      AuthenticatedAppChainAnnouncementsAnnouncementIdRoute,
    AuthenticatedAppChainAnnouncementsIndexRoute:
      AuthenticatedAppChainAnnouncementsIndexRoute,
    AuthenticatedAppChainCoursesIndexRoute:
      AuthenticatedAppChainCoursesIndexRoute,
    AuthenticatedAppChainCoursesCourseIdManageRoute:
      AuthenticatedAppChainCoursesCourseIdManageRoute,
  }

const AuthenticatedAppChainRouteRouteWithChildren =
  AuthenticatedAppChainRouteRoute._addFileChildren(
    AuthenticatedAppChainRouteRouteChildren,
  )

interface AuthenticatedAppCrmSettingsRouteRouteChildren {
  AuthenticatedAppCrmSettingsCompanyFieldsRoute: typeof AuthenticatedAppCrmSettingsCompanyFieldsRoute
  AuthenticatedAppCrmSettingsContactFieldsRoute: typeof AuthenticatedAppCrmSettingsContactFieldsRoute
  AuthenticatedAppCrmSettingsDealFieldsRoute: typeof AuthenticatedAppCrmSettingsDealFieldsRoute
  AuthenticatedAppCrmSettingsLostReasonsRoute: typeof AuthenticatedAppCrmSettingsLostReasonsRoute
  AuthenticatedAppCrmSettingsOfferDefaultsRoute: typeof AuthenticatedAppCrmSettingsOfferDefaultsRoute
  AuthenticatedAppCrmSettingsOrderPipelineRoute: typeof AuthenticatedAppCrmSettingsOrderPipelineRoute
  AuthenticatedAppCrmSettingsIndexRoute: typeof AuthenticatedAppCrmSettingsIndexRoute
  AuthenticatedAppCrmSettingsPipelinesPipelineIdRoute: typeof AuthenticatedAppCrmSettingsPipelinesPipelineIdRoute
  AuthenticatedAppCrmSettingsPipelinesIndexRoute: typeof AuthenticatedAppCrmSettingsPipelinesIndexRoute
}

const AuthenticatedAppCrmSettingsRouteRouteChildren: AuthenticatedAppCrmSettingsRouteRouteChildren =
  {
    AuthenticatedAppCrmSettingsCompanyFieldsRoute:
      AuthenticatedAppCrmSettingsCompanyFieldsRoute,
    AuthenticatedAppCrmSettingsContactFieldsRoute:
      AuthenticatedAppCrmSettingsContactFieldsRoute,
    AuthenticatedAppCrmSettingsDealFieldsRoute:
      AuthenticatedAppCrmSettingsDealFieldsRoute,
    AuthenticatedAppCrmSettingsLostReasonsRoute:
      AuthenticatedAppCrmSettingsLostReasonsRoute,
    AuthenticatedAppCrmSettingsOfferDefaultsRoute:
      AuthenticatedAppCrmSettingsOfferDefaultsRoute,
    AuthenticatedAppCrmSettingsOrderPipelineRoute:
      AuthenticatedAppCrmSettingsOrderPipelineRoute,
    AuthenticatedAppCrmSettingsIndexRoute:
      AuthenticatedAppCrmSettingsIndexRoute,
    AuthenticatedAppCrmSettingsPipelinesPipelineIdRoute:
      AuthenticatedAppCrmSettingsPipelinesPipelineIdRoute,
    AuthenticatedAppCrmSettingsPipelinesIndexRoute:
      AuthenticatedAppCrmSettingsPipelinesIndexRoute,
  }

const AuthenticatedAppCrmSettingsRouteRouteWithChildren =
  AuthenticatedAppCrmSettingsRouteRoute._addFileChildren(
    AuthenticatedAppCrmSettingsRouteRouteChildren,
  )

interface AuthenticatedAppCrmRouteRouteChildren {
  AuthenticatedAppCrmSettingsRouteRoute: typeof AuthenticatedAppCrmSettingsRouteRouteWithChildren
  AuthenticatedAppCrmIndexRoute: typeof AuthenticatedAppCrmIndexRoute
  AuthenticatedAppCrmChainDistributionRoute: typeof AuthenticatedAppCrmChainDistributionRoute
  AuthenticatedAppCrmChainMembersRoute: typeof AuthenticatedAppCrmChainMembersRoute
  AuthenticatedAppCrmChainParentIncomingRoute: typeof AuthenticatedAppCrmChainParentIncomingRoute
  AuthenticatedAppCrmChainPipelineRoute: typeof AuthenticatedAppCrmChainPipelineRoute
  AuthenticatedAppCrmCompaniesIdRoute: typeof AuthenticatedAppCrmCompaniesIdRoute
  AuthenticatedAppCrmContactsContactIdRoute: typeof AuthenticatedAppCrmContactsContactIdRoute
  AuthenticatedAppCrmDealsDealIdRoute: typeof AuthenticatedAppCrmDealsDealIdRoute
  AuthenticatedAppCrmLeadsLeadIdRoute: typeof AuthenticatedAppCrmLeadsLeadIdRoute
  AuthenticatedAppCrmPipelinePipelineIdRoute: typeof AuthenticatedAppCrmPipelinePipelineIdRoute
  AuthenticatedAppCrmCatalogIndexRoute: typeof AuthenticatedAppCrmCatalogIndexRoute
  AuthenticatedAppCrmCompaniesIndexRoute: typeof AuthenticatedAppCrmCompaniesIndexRoute
  AuthenticatedAppCrmContactsIndexRoute: typeof AuthenticatedAppCrmContactsIndexRoute
  AuthenticatedAppCrmDealsIndexRoute: typeof AuthenticatedAppCrmDealsIndexRoute
  AuthenticatedAppCrmDuplicatesIndexRoute: typeof AuthenticatedAppCrmDuplicatesIndexRoute
  AuthenticatedAppCrmLeadsIndexRoute: typeof AuthenticatedAppCrmLeadsIndexRoute
  AuthenticatedAppCrmMyWorkIndexRoute: typeof AuthenticatedAppCrmMyWorkIndexRoute
  AuthenticatedAppCrmPipelineIndexRoute: typeof AuthenticatedAppCrmPipelineIndexRoute
  AuthenticatedAppCrmReportingIndexRoute: typeof AuthenticatedAppCrmReportingIndexRoute
  AuthenticatedAppCrmDealsDealIdOffersVersionIdRoute: typeof AuthenticatedAppCrmDealsDealIdOffersVersionIdRoute
  AuthenticatedAppCrmDealsDealIdOffersVersionIdEditRoute: typeof AuthenticatedAppCrmDealsDealIdOffersVersionIdEditRoute
}

const AuthenticatedAppCrmRouteRouteChildren: AuthenticatedAppCrmRouteRouteChildren =
  {
    AuthenticatedAppCrmSettingsRouteRoute:
      AuthenticatedAppCrmSettingsRouteRouteWithChildren,
    AuthenticatedAppCrmIndexRoute: AuthenticatedAppCrmIndexRoute,
    AuthenticatedAppCrmChainDistributionRoute:
      AuthenticatedAppCrmChainDistributionRoute,
    AuthenticatedAppCrmChainMembersRoute: AuthenticatedAppCrmChainMembersRoute,
    AuthenticatedAppCrmChainParentIncomingRoute:
      AuthenticatedAppCrmChainParentIncomingRoute,
    AuthenticatedAppCrmChainPipelineRoute:
      AuthenticatedAppCrmChainPipelineRoute,
    AuthenticatedAppCrmCompaniesIdRoute: AuthenticatedAppCrmCompaniesIdRoute,
    AuthenticatedAppCrmContactsContactIdRoute:
      AuthenticatedAppCrmContactsContactIdRoute,
    AuthenticatedAppCrmDealsDealIdRoute: AuthenticatedAppCrmDealsDealIdRoute,
    AuthenticatedAppCrmLeadsLeadIdRoute: AuthenticatedAppCrmLeadsLeadIdRoute,
    AuthenticatedAppCrmPipelinePipelineIdRoute:
      AuthenticatedAppCrmPipelinePipelineIdRoute,
    AuthenticatedAppCrmCatalogIndexRoute: AuthenticatedAppCrmCatalogIndexRoute,
    AuthenticatedAppCrmCompaniesIndexRoute:
      AuthenticatedAppCrmCompaniesIndexRoute,
    AuthenticatedAppCrmContactsIndexRoute:
      AuthenticatedAppCrmContactsIndexRoute,
    AuthenticatedAppCrmDealsIndexRoute: AuthenticatedAppCrmDealsIndexRoute,
    AuthenticatedAppCrmDuplicatesIndexRoute:
      AuthenticatedAppCrmDuplicatesIndexRoute,
    AuthenticatedAppCrmLeadsIndexRoute: AuthenticatedAppCrmLeadsIndexRoute,
    AuthenticatedAppCrmMyWorkIndexRoute: AuthenticatedAppCrmMyWorkIndexRoute,
    AuthenticatedAppCrmPipelineIndexRoute:
      AuthenticatedAppCrmPipelineIndexRoute,
    AuthenticatedAppCrmReportingIndexRoute:
      AuthenticatedAppCrmReportingIndexRoute,
    AuthenticatedAppCrmDealsDealIdOffersVersionIdRoute:
      AuthenticatedAppCrmDealsDealIdOffersVersionIdRoute,
    AuthenticatedAppCrmDealsDealIdOffersVersionIdEditRoute:
      AuthenticatedAppCrmDealsDealIdOffersVersionIdEditRoute,
  }

const AuthenticatedAppCrmRouteRouteWithChildren =
  AuthenticatedAppCrmRouteRoute._addFileChildren(
    AuthenticatedAppCrmRouteRouteChildren,
  )

interface AuthenticatedAppFormsRouteRouteChildren {
  AuthenticatedAppFormsIndexRoute: typeof AuthenticatedAppFormsIndexRoute
  AuthenticatedAppFormsFormIdAnalyticsRoute: typeof AuthenticatedAppFormsFormIdAnalyticsRoute
  AuthenticatedAppFormsFormIdDesignerRoute: typeof AuthenticatedAppFormsFormIdDesignerRoute
  AuthenticatedAppFormsFormIdSubmissionsRoute: typeof AuthenticatedAppFormsFormIdSubmissionsRoute
}

const AuthenticatedAppFormsRouteRouteChildren: AuthenticatedAppFormsRouteRouteChildren =
  {
    AuthenticatedAppFormsIndexRoute: AuthenticatedAppFormsIndexRoute,
    AuthenticatedAppFormsFormIdAnalyticsRoute:
      AuthenticatedAppFormsFormIdAnalyticsRoute,
    AuthenticatedAppFormsFormIdDesignerRoute:
      AuthenticatedAppFormsFormIdDesignerRoute,
    AuthenticatedAppFormsFormIdSubmissionsRoute:
      AuthenticatedAppFormsFormIdSubmissionsRoute,
  }

const AuthenticatedAppFormsRouteRouteWithChildren =
  AuthenticatedAppFormsRouteRoute._addFileChildren(
    AuthenticatedAppFormsRouteRouteChildren,
  )

interface AuthenticatedAppInspectionInspectionsInspectionIdRouteRouteChildren {
  AuthenticatedAppInspectionInspectionsInspectionIdCaptureRoute: typeof AuthenticatedAppInspectionInspectionsInspectionIdCaptureRoute
  AuthenticatedAppInspectionInspectionsInspectionIdCapturesRoute: typeof AuthenticatedAppInspectionInspectionsInspectionIdCapturesRoute
  AuthenticatedAppInspectionInspectionsInspectionIdEvidenceRoute: typeof AuthenticatedAppInspectionInspectionsInspectionIdEvidenceRoute
  AuthenticatedAppInspectionInspectionsInspectionIdProgressRoute: typeof AuthenticatedAppInspectionInspectionsInspectionIdProgressRoute
  AuthenticatedAppInspectionInspectionsInspectionIdIndexRoute: typeof AuthenticatedAppInspectionInspectionsInspectionIdIndexRoute
}

const AuthenticatedAppInspectionInspectionsInspectionIdRouteRouteChildren: AuthenticatedAppInspectionInspectionsInspectionIdRouteRouteChildren =
  {
    AuthenticatedAppInspectionInspectionsInspectionIdCaptureRoute:
      AuthenticatedAppInspectionInspectionsInspectionIdCaptureRoute,
    AuthenticatedAppInspectionInspectionsInspectionIdCapturesRoute:
      AuthenticatedAppInspectionInspectionsInspectionIdCapturesRoute,
    AuthenticatedAppInspectionInspectionsInspectionIdEvidenceRoute:
      AuthenticatedAppInspectionInspectionsInspectionIdEvidenceRoute,
    AuthenticatedAppInspectionInspectionsInspectionIdProgressRoute:
      AuthenticatedAppInspectionInspectionsInspectionIdProgressRoute,
    AuthenticatedAppInspectionInspectionsInspectionIdIndexRoute:
      AuthenticatedAppInspectionInspectionsInspectionIdIndexRoute,
  }

const AuthenticatedAppInspectionInspectionsInspectionIdRouteRouteWithChildren =
  AuthenticatedAppInspectionInspectionsInspectionIdRouteRoute._addFileChildren(
    AuthenticatedAppInspectionInspectionsInspectionIdRouteRouteChildren,
  )

interface AuthenticatedAppInspectionRouteRouteChildren {
  AuthenticatedAppInspectionIndexRoute: typeof AuthenticatedAppInspectionIndexRoute
  AuthenticatedAppInspectionInspectionsInspectionIdRouteRoute: typeof AuthenticatedAppInspectionInspectionsInspectionIdRouteRouteWithChildren
  AuthenticatedAppInspectionSitesSiteIdRoute: typeof AuthenticatedAppInspectionSitesSiteIdRoute
  AuthenticatedAppInspectionTemplatesTemplateIdRoute: typeof AuthenticatedAppInspectionTemplatesTemplateIdRoute
  AuthenticatedAppInspectionLibraryIndexRoute: typeof AuthenticatedAppInspectionLibraryIndexRoute
  AuthenticatedAppInspectionSitesIndexRoute: typeof AuthenticatedAppInspectionSitesIndexRoute
  AuthenticatedAppInspectionTemplatesIndexRoute: typeof AuthenticatedAppInspectionTemplatesIndexRoute
  AuthenticatedAppInspectionUpcomingIndexRoute: typeof AuthenticatedAppInspectionUpcomingIndexRoute
}

const AuthenticatedAppInspectionRouteRouteChildren: AuthenticatedAppInspectionRouteRouteChildren =
  {
    AuthenticatedAppInspectionIndexRoute: AuthenticatedAppInspectionIndexRoute,
    AuthenticatedAppInspectionInspectionsInspectionIdRouteRoute:
      AuthenticatedAppInspectionInspectionsInspectionIdRouteRouteWithChildren,
    AuthenticatedAppInspectionSitesSiteIdRoute:
      AuthenticatedAppInspectionSitesSiteIdRoute,
    AuthenticatedAppInspectionTemplatesTemplateIdRoute:
      AuthenticatedAppInspectionTemplatesTemplateIdRoute,
    AuthenticatedAppInspectionLibraryIndexRoute:
      AuthenticatedAppInspectionLibraryIndexRoute,
    AuthenticatedAppInspectionSitesIndexRoute:
      AuthenticatedAppInspectionSitesIndexRoute,
    AuthenticatedAppInspectionTemplatesIndexRoute:
      AuthenticatedAppInspectionTemplatesIndexRoute,
    AuthenticatedAppInspectionUpcomingIndexRoute:
      AuthenticatedAppInspectionUpcomingIndexRoute,
  }

const AuthenticatedAppInspectionRouteRouteWithChildren =
  AuthenticatedAppInspectionRouteRoute._addFileChildren(
    AuthenticatedAppInspectionRouteRouteChildren,
  )

interface AuthenticatedAppInvoicingRouteRouteChildren {
  AuthenticatedAppInvoicingInvoiceIdRoute: typeof AuthenticatedAppInvoicingInvoiceIdRoute
  AuthenticatedAppInvoicingIndexRoute: typeof AuthenticatedAppInvoicingIndexRoute
  AuthenticatedAppInvoicingPrepareOrderIdRoute: typeof AuthenticatedAppInvoicingPrepareOrderIdRoute
}

const AuthenticatedAppInvoicingRouteRouteChildren: AuthenticatedAppInvoicingRouteRouteChildren =
  {
    AuthenticatedAppInvoicingInvoiceIdRoute:
      AuthenticatedAppInvoicingInvoiceIdRoute,
    AuthenticatedAppInvoicingIndexRoute: AuthenticatedAppInvoicingIndexRoute,
    AuthenticatedAppInvoicingPrepareOrderIdRoute:
      AuthenticatedAppInvoicingPrepareOrderIdRoute,
  }

const AuthenticatedAppInvoicingRouteRouteWithChildren =
  AuthenticatedAppInvoicingRouteRoute._addFileChildren(
    AuthenticatedAppInvoicingRouteRouteChildren,
  )

interface AuthenticatedAppMemberPortalManageAgreementsRouteChildren {
  AuthenticatedAppMemberPortalManageAgreementsIdRoute: typeof AuthenticatedAppMemberPortalManageAgreementsIdRoute
}

const AuthenticatedAppMemberPortalManageAgreementsRouteChildren: AuthenticatedAppMemberPortalManageAgreementsRouteChildren =
  {
    AuthenticatedAppMemberPortalManageAgreementsIdRoute:
      AuthenticatedAppMemberPortalManageAgreementsIdRoute,
  }

const AuthenticatedAppMemberPortalManageAgreementsRouteWithChildren =
  AuthenticatedAppMemberPortalManageAgreementsRoute._addFileChildren(
    AuthenticatedAppMemberPortalManageAgreementsRouteChildren,
  )

interface AuthenticatedAppMemberPortalManageBrandingRouteChildren {
  AuthenticatedAppMemberPortalManageBrandingIdRoute: typeof AuthenticatedAppMemberPortalManageBrandingIdRoute
}

const AuthenticatedAppMemberPortalManageBrandingRouteChildren: AuthenticatedAppMemberPortalManageBrandingRouteChildren =
  {
    AuthenticatedAppMemberPortalManageBrandingIdRoute:
      AuthenticatedAppMemberPortalManageBrandingIdRoute,
  }

const AuthenticatedAppMemberPortalManageBrandingRouteWithChildren =
  AuthenticatedAppMemberPortalManageBrandingRoute._addFileChildren(
    AuthenticatedAppMemberPortalManageBrandingRouteChildren,
  )

interface AuthenticatedAppMemberPortalManageCampaignsRouteChildren {
  AuthenticatedAppMemberPortalManageCampaignsIdRoute: typeof AuthenticatedAppMemberPortalManageCampaignsIdRoute
}

const AuthenticatedAppMemberPortalManageCampaignsRouteChildren: AuthenticatedAppMemberPortalManageCampaignsRouteChildren =
  {
    AuthenticatedAppMemberPortalManageCampaignsIdRoute:
      AuthenticatedAppMemberPortalManageCampaignsIdRoute,
  }

const AuthenticatedAppMemberPortalManageCampaignsRouteWithChildren =
  AuthenticatedAppMemberPortalManageCampaignsRoute._addFileChildren(
    AuthenticatedAppMemberPortalManageCampaignsRouteChildren,
  )

interface AuthenticatedAppMemberPortalManageCommunicationsRouteChildren {
  AuthenticatedAppMemberPortalManageCommunicationsIdRoute: typeof AuthenticatedAppMemberPortalManageCommunicationsIdRoute
  AuthenticatedAppMemberPortalManageCommunicationsIdResponsesCompanyIdRoute: typeof AuthenticatedAppMemberPortalManageCommunicationsIdResponsesCompanyIdRoute
}

const AuthenticatedAppMemberPortalManageCommunicationsRouteChildren: AuthenticatedAppMemberPortalManageCommunicationsRouteChildren =
  {
    AuthenticatedAppMemberPortalManageCommunicationsIdRoute:
      AuthenticatedAppMemberPortalManageCommunicationsIdRoute,
    AuthenticatedAppMemberPortalManageCommunicationsIdResponsesCompanyIdRoute:
      AuthenticatedAppMemberPortalManageCommunicationsIdResponsesCompanyIdRoute,
  }

const AuthenticatedAppMemberPortalManageCommunicationsRouteWithChildren =
  AuthenticatedAppMemberPortalManageCommunicationsRoute._addFileChildren(
    AuthenticatedAppMemberPortalManageCommunicationsRouteChildren,
  )

interface AuthenticatedAppMemberPortalManageContactsRouteChildren {
  AuthenticatedAppMemberPortalManageContactsIdRoute: typeof AuthenticatedAppMemberPortalManageContactsIdRoute
}

const AuthenticatedAppMemberPortalManageContactsRouteChildren: AuthenticatedAppMemberPortalManageContactsRouteChildren =
  {
    AuthenticatedAppMemberPortalManageContactsIdRoute:
      AuthenticatedAppMemberPortalManageContactsIdRoute,
  }

const AuthenticatedAppMemberPortalManageContactsRouteWithChildren =
  AuthenticatedAppMemberPortalManageContactsRoute._addFileChildren(
    AuthenticatedAppMemberPortalManageContactsRouteChildren,
  )

interface AuthenticatedAppMemberPortalManageSuppliersRouteChildren {
  AuthenticatedAppMemberPortalManageSuppliersIdRoute: typeof AuthenticatedAppMemberPortalManageSuppliersIdRoute
}

const AuthenticatedAppMemberPortalManageSuppliersRouteChildren: AuthenticatedAppMemberPortalManageSuppliersRouteChildren =
  {
    AuthenticatedAppMemberPortalManageSuppliersIdRoute:
      AuthenticatedAppMemberPortalManageSuppliersIdRoute,
  }

const AuthenticatedAppMemberPortalManageSuppliersRouteWithChildren =
  AuthenticatedAppMemberPortalManageSuppliersRoute._addFileChildren(
    AuthenticatedAppMemberPortalManageSuppliersRouteChildren,
  )

interface AuthenticatedAppMemberPortalManageToolsRouteChildren {
  AuthenticatedAppMemberPortalManageToolsIdRoute: typeof AuthenticatedAppMemberPortalManageToolsIdRoute
}

const AuthenticatedAppMemberPortalManageToolsRouteChildren: AuthenticatedAppMemberPortalManageToolsRouteChildren =
  {
    AuthenticatedAppMemberPortalManageToolsIdRoute:
      AuthenticatedAppMemberPortalManageToolsIdRoute,
  }

const AuthenticatedAppMemberPortalManageToolsRouteWithChildren =
  AuthenticatedAppMemberPortalManageToolsRoute._addFileChildren(
    AuthenticatedAppMemberPortalManageToolsRouteChildren,
  )

interface AuthenticatedAppMemberPortalManageRouteRouteChildren {
  AuthenticatedAppMemberPortalManageAboutRoute: typeof AuthenticatedAppMemberPortalManageAboutRoute
  AuthenticatedAppMemberPortalManageAgreementsRoute: typeof AuthenticatedAppMemberPortalManageAgreementsRouteWithChildren
  AuthenticatedAppMemberPortalManageBrandingRoute: typeof AuthenticatedAppMemberPortalManageBrandingRouteWithChildren
  AuthenticatedAppMemberPortalManageCampaignsRoute: typeof AuthenticatedAppMemberPortalManageCampaignsRouteWithChildren
  AuthenticatedAppMemberPortalManageCommunicationsRoute: typeof AuthenticatedAppMemberPortalManageCommunicationsRouteWithChildren
  AuthenticatedAppMemberPortalManageContactsRoute: typeof AuthenticatedAppMemberPortalManageContactsRouteWithChildren
  AuthenticatedAppMemberPortalManageSuppliersRoute: typeof AuthenticatedAppMemberPortalManageSuppliersRouteWithChildren
  AuthenticatedAppMemberPortalManageToolsRoute: typeof AuthenticatedAppMemberPortalManageToolsRouteWithChildren
  AuthenticatedAppMemberPortalManageIndexRoute: typeof AuthenticatedAppMemberPortalManageIndexRoute
}

const AuthenticatedAppMemberPortalManageRouteRouteChildren: AuthenticatedAppMemberPortalManageRouteRouteChildren =
  {
    AuthenticatedAppMemberPortalManageAboutRoute:
      AuthenticatedAppMemberPortalManageAboutRoute,
    AuthenticatedAppMemberPortalManageAgreementsRoute:
      AuthenticatedAppMemberPortalManageAgreementsRouteWithChildren,
    AuthenticatedAppMemberPortalManageBrandingRoute:
      AuthenticatedAppMemberPortalManageBrandingRouteWithChildren,
    AuthenticatedAppMemberPortalManageCampaignsRoute:
      AuthenticatedAppMemberPortalManageCampaignsRouteWithChildren,
    AuthenticatedAppMemberPortalManageCommunicationsRoute:
      AuthenticatedAppMemberPortalManageCommunicationsRouteWithChildren,
    AuthenticatedAppMemberPortalManageContactsRoute:
      AuthenticatedAppMemberPortalManageContactsRouteWithChildren,
    AuthenticatedAppMemberPortalManageSuppliersRoute:
      AuthenticatedAppMemberPortalManageSuppliersRouteWithChildren,
    AuthenticatedAppMemberPortalManageToolsRoute:
      AuthenticatedAppMemberPortalManageToolsRouteWithChildren,
    AuthenticatedAppMemberPortalManageIndexRoute:
      AuthenticatedAppMemberPortalManageIndexRoute,
  }

const AuthenticatedAppMemberPortalManageRouteRouteWithChildren =
  AuthenticatedAppMemberPortalManageRouteRoute._addFileChildren(
    AuthenticatedAppMemberPortalManageRouteRouteChildren,
  )

interface AuthenticatedAppMemberPortalAgreementsRouteChildren {
  AuthenticatedAppMemberPortalAgreementsIdRoute: typeof AuthenticatedAppMemberPortalAgreementsIdRoute
}

const AuthenticatedAppMemberPortalAgreementsRouteChildren: AuthenticatedAppMemberPortalAgreementsRouteChildren =
  {
    AuthenticatedAppMemberPortalAgreementsIdRoute:
      AuthenticatedAppMemberPortalAgreementsIdRoute,
  }

const AuthenticatedAppMemberPortalAgreementsRouteWithChildren =
  AuthenticatedAppMemberPortalAgreementsRoute._addFileChildren(
    AuthenticatedAppMemberPortalAgreementsRouteChildren,
  )

interface AuthenticatedAppMemberPortalCampaignsRouteChildren {
  AuthenticatedAppMemberPortalCampaignsSlugRoute: typeof AuthenticatedAppMemberPortalCampaignsSlugRoute
  AuthenticatedAppMemberPortalCampaignsByIdIdRoute: typeof AuthenticatedAppMemberPortalCampaignsByIdIdRoute
}

const AuthenticatedAppMemberPortalCampaignsRouteChildren: AuthenticatedAppMemberPortalCampaignsRouteChildren =
  {
    AuthenticatedAppMemberPortalCampaignsSlugRoute:
      AuthenticatedAppMemberPortalCampaignsSlugRoute,
    AuthenticatedAppMemberPortalCampaignsByIdIdRoute:
      AuthenticatedAppMemberPortalCampaignsByIdIdRoute,
  }

const AuthenticatedAppMemberPortalCampaignsRouteWithChildren =
  AuthenticatedAppMemberPortalCampaignsRoute._addFileChildren(
    AuthenticatedAppMemberPortalCampaignsRouteChildren,
  )

interface AuthenticatedAppMemberPortalCommunicationsRouteChildren {
  AuthenticatedAppMemberPortalCommunicationsIdRoute: typeof AuthenticatedAppMemberPortalCommunicationsIdRoute
}

const AuthenticatedAppMemberPortalCommunicationsRouteChildren: AuthenticatedAppMemberPortalCommunicationsRouteChildren =
  {
    AuthenticatedAppMemberPortalCommunicationsIdRoute:
      AuthenticatedAppMemberPortalCommunicationsIdRoute,
  }

const AuthenticatedAppMemberPortalCommunicationsRouteWithChildren =
  AuthenticatedAppMemberPortalCommunicationsRoute._addFileChildren(
    AuthenticatedAppMemberPortalCommunicationsRouteChildren,
  )

interface AuthenticatedAppMemberPortalSuppliersRouteChildren {
  AuthenticatedAppMemberPortalSuppliersIdRoute: typeof AuthenticatedAppMemberPortalSuppliersIdRoute
}

const AuthenticatedAppMemberPortalSuppliersRouteChildren: AuthenticatedAppMemberPortalSuppliersRouteChildren =
  {
    AuthenticatedAppMemberPortalSuppliersIdRoute:
      AuthenticatedAppMemberPortalSuppliersIdRoute,
  }

const AuthenticatedAppMemberPortalSuppliersRouteWithChildren =
  AuthenticatedAppMemberPortalSuppliersRoute._addFileChildren(
    AuthenticatedAppMemberPortalSuppliersRouteChildren,
  )

interface AuthenticatedAppMemberPortalToolsRouteChildren {
  AuthenticatedAppMemberPortalToolsIdRoute: typeof AuthenticatedAppMemberPortalToolsIdRoute
}

const AuthenticatedAppMemberPortalToolsRouteChildren: AuthenticatedAppMemberPortalToolsRouteChildren =
  {
    AuthenticatedAppMemberPortalToolsIdRoute:
      AuthenticatedAppMemberPortalToolsIdRoute,
  }

const AuthenticatedAppMemberPortalToolsRouteWithChildren =
  AuthenticatedAppMemberPortalToolsRoute._addFileChildren(
    AuthenticatedAppMemberPortalToolsRouteChildren,
  )

interface AuthenticatedAppMemberPortalRouteRouteChildren {
  AuthenticatedAppMemberPortalManageRouteRoute: typeof AuthenticatedAppMemberPortalManageRouteRouteWithChildren
  AuthenticatedAppMemberPortalAboutRoute: typeof AuthenticatedAppMemberPortalAboutRoute
  AuthenticatedAppMemberPortalAgreementsRoute: typeof AuthenticatedAppMemberPortalAgreementsRouteWithChildren
  AuthenticatedAppMemberPortalBrandingRoute: typeof AuthenticatedAppMemberPortalBrandingRoute
  AuthenticatedAppMemberPortalCampaignsRoute: typeof AuthenticatedAppMemberPortalCampaignsRouteWithChildren
  AuthenticatedAppMemberPortalCommunicationsRoute: typeof AuthenticatedAppMemberPortalCommunicationsRouteWithChildren
  AuthenticatedAppMemberPortalContactsRoute: typeof AuthenticatedAppMemberPortalContactsRoute
  AuthenticatedAppMemberPortalOverviewRoute: typeof AuthenticatedAppMemberPortalOverviewRoute
  AuthenticatedAppMemberPortalSuppliersRoute: typeof AuthenticatedAppMemberPortalSuppliersRouteWithChildren
  AuthenticatedAppMemberPortalToolsRoute: typeof AuthenticatedAppMemberPortalToolsRouteWithChildren
  AuthenticatedAppMemberPortalIndexRoute: typeof AuthenticatedAppMemberPortalIndexRoute
  AuthenticatedAppMemberPortalBrandingIdRoute: typeof AuthenticatedAppMemberPortalBrandingIdRoute
}

const AuthenticatedAppMemberPortalRouteRouteChildren: AuthenticatedAppMemberPortalRouteRouteChildren =
  {
    AuthenticatedAppMemberPortalManageRouteRoute:
      AuthenticatedAppMemberPortalManageRouteRouteWithChildren,
    AuthenticatedAppMemberPortalAboutRoute:
      AuthenticatedAppMemberPortalAboutRoute,
    AuthenticatedAppMemberPortalAgreementsRoute:
      AuthenticatedAppMemberPortalAgreementsRouteWithChildren,
    AuthenticatedAppMemberPortalBrandingRoute:
      AuthenticatedAppMemberPortalBrandingRoute,
    AuthenticatedAppMemberPortalCampaignsRoute:
      AuthenticatedAppMemberPortalCampaignsRouteWithChildren,
    AuthenticatedAppMemberPortalCommunicationsRoute:
      AuthenticatedAppMemberPortalCommunicationsRouteWithChildren,
    AuthenticatedAppMemberPortalContactsRoute:
      AuthenticatedAppMemberPortalContactsRoute,
    AuthenticatedAppMemberPortalOverviewRoute:
      AuthenticatedAppMemberPortalOverviewRoute,
    AuthenticatedAppMemberPortalSuppliersRoute:
      AuthenticatedAppMemberPortalSuppliersRouteWithChildren,
    AuthenticatedAppMemberPortalToolsRoute:
      AuthenticatedAppMemberPortalToolsRouteWithChildren,
    AuthenticatedAppMemberPortalIndexRoute:
      AuthenticatedAppMemberPortalIndexRoute,
    AuthenticatedAppMemberPortalBrandingIdRoute:
      AuthenticatedAppMemberPortalBrandingIdRoute,
  }

const AuthenticatedAppMemberPortalRouteRouteWithChildren =
  AuthenticatedAppMemberPortalRouteRoute._addFileChildren(
    AuthenticatedAppMemberPortalRouteRouteChildren,
  )

interface AuthenticatedAppOrdersRouteRouteChildren {
  AuthenticatedAppOrdersOrderIdRoute: typeof AuthenticatedAppOrdersOrderIdRoute
  AuthenticatedAppOrdersReportsRoute: typeof AuthenticatedAppOrdersReportsRoute
  AuthenticatedAppOrdersIndexRoute: typeof AuthenticatedAppOrdersIndexRoute
}

const AuthenticatedAppOrdersRouteRouteChildren: AuthenticatedAppOrdersRouteRouteChildren =
  {
    AuthenticatedAppOrdersOrderIdRoute: AuthenticatedAppOrdersOrderIdRoute,
    AuthenticatedAppOrdersReportsRoute: AuthenticatedAppOrdersReportsRoute,
    AuthenticatedAppOrdersIndexRoute: AuthenticatedAppOrdersIndexRoute,
  }

const AuthenticatedAppOrdersRouteRouteWithChildren =
  AuthenticatedAppOrdersRouteRoute._addFileChildren(
    AuthenticatedAppOrdersRouteRouteChildren,
  )

interface AuthenticatedAppSettingsAuditRouteRouteChildren {
  AuthenticatedAppSettingsAuditIndexRoute: typeof AuthenticatedAppSettingsAuditIndexRoute
  AuthenticatedAppSettingsAuditTimelineTargetTypeTargetIdRoute: typeof AuthenticatedAppSettingsAuditTimelineTargetTypeTargetIdRoute
}

const AuthenticatedAppSettingsAuditRouteRouteChildren: AuthenticatedAppSettingsAuditRouteRouteChildren =
  {
    AuthenticatedAppSettingsAuditIndexRoute:
      AuthenticatedAppSettingsAuditIndexRoute,
    AuthenticatedAppSettingsAuditTimelineTargetTypeTargetIdRoute:
      AuthenticatedAppSettingsAuditTimelineTargetTypeTargetIdRoute,
  }

const AuthenticatedAppSettingsAuditRouteRouteWithChildren =
  AuthenticatedAppSettingsAuditRouteRoute._addFileChildren(
    AuthenticatedAppSettingsAuditRouteRouteChildren,
  )

interface AuthenticatedAppSettingsBillingRouteRouteChildren {
  AuthenticatedAppSettingsBillingAddonsRoute: typeof AuthenticatedAppSettingsBillingAddonsRoute
  AuthenticatedAppSettingsBillingPaymentsRoute: typeof AuthenticatedAppSettingsBillingPaymentsRoute
  AuthenticatedAppSettingsBillingIndexRoute: typeof AuthenticatedAppSettingsBillingIndexRoute
  AuthenticatedAppSettingsBillingPricingCheckoutRoute: typeof AuthenticatedAppSettingsBillingPricingCheckoutRoute
  AuthenticatedAppSettingsBillingPricingIndexRoute: typeof AuthenticatedAppSettingsBillingPricingIndexRoute
}

const AuthenticatedAppSettingsBillingRouteRouteChildren: AuthenticatedAppSettingsBillingRouteRouteChildren =
  {
    AuthenticatedAppSettingsBillingAddonsRoute:
      AuthenticatedAppSettingsBillingAddonsRoute,
    AuthenticatedAppSettingsBillingPaymentsRoute:
      AuthenticatedAppSettingsBillingPaymentsRoute,
    AuthenticatedAppSettingsBillingIndexRoute:
      AuthenticatedAppSettingsBillingIndexRoute,
    AuthenticatedAppSettingsBillingPricingCheckoutRoute:
      AuthenticatedAppSettingsBillingPricingCheckoutRoute,
    AuthenticatedAppSettingsBillingPricingIndexRoute:
      AuthenticatedAppSettingsBillingPricingIndexRoute,
  }

const AuthenticatedAppSettingsBillingRouteRouteWithChildren =
  AuthenticatedAppSettingsBillingRouteRoute._addFileChildren(
    AuthenticatedAppSettingsBillingRouteRouteChildren,
  )

interface AuthenticatedAppSettingsRouteRouteChildren {
  AuthenticatedAppSettingsAuditRouteRoute: typeof AuthenticatedAppSettingsAuditRouteRouteWithChildren
  AuthenticatedAppSettingsBillingRouteRoute: typeof AuthenticatedAppSettingsBillingRouteRouteWithChildren
  AuthenticatedAppSettingsAccessRoute: typeof AuthenticatedAppSettingsAccessRoute
  AuthenticatedAppSettingsAiSettingsRoute: typeof AuthenticatedAppSettingsAiSettingsRoute
  AuthenticatedAppSettingsApiKeysRoute: typeof AuthenticatedAppSettingsApiKeysRoute
  AuthenticatedAppSettingsCompanyRoute: typeof AuthenticatedAppSettingsCompanyRoute
  AuthenticatedAppSettingsConnectedAppsRoute: typeof AuthenticatedAppSettingsConnectedAppsRoute
  AuthenticatedAppSettingsMembersRoute: typeof AuthenticatedAppSettingsMembersRoute
  AuthenticatedAppSettingsNotificationsRoute: typeof AuthenticatedAppSettingsNotificationsRoute
  AuthenticatedAppSettingsOrderSettingsRoute: typeof AuthenticatedAppSettingsOrderSettingsRoute
  AuthenticatedAppSettingsProfileRoute: typeof AuthenticatedAppSettingsProfileRoute
  AuthenticatedAppSettingsServiceAreaRoute: typeof AuthenticatedAppSettingsServiceAreaRoute
  AuthenticatedAppSettingsServiceTypesRoute: typeof AuthenticatedAppSettingsServiceTypesRoute
  AuthenticatedAppSettingsUsageRoute: typeof AuthenticatedAppSettingsUsageRoute
  AuthenticatedAppSettingsWhiteLabelingRoute: typeof AuthenticatedAppSettingsWhiteLabelingRoute
  AuthenticatedAppSettingsIndexRoute: typeof AuthenticatedAppSettingsIndexRoute
  AuthenticatedAppSettingsInvoicingAccountingRoute: typeof AuthenticatedAppSettingsInvoicingAccountingRoute
  AuthenticatedAppSettingsMeetingBackgroundRoute: typeof AuthenticatedAppSettingsMeetingBackgroundRoute
  AuthenticatedAppSettingsMeetingDefaultsRoute: typeof AuthenticatedAppSettingsMeetingDefaultsRoute
  AuthenticatedAppSettingsMeetingRecordingRoute: typeof AuthenticatedAppSettingsMeetingRecordingRoute
  AuthenticatedAppSettingsOrdersPipelineRoute: typeof AuthenticatedAppSettingsOrdersPipelineRoute
  AuthenticatedAppSettingsRolesRoleIdRoute: typeof AuthenticatedAppSettingsRolesRoleIdRoute
  AuthenticatedAppSettingsRolesNewRoute: typeof AuthenticatedAppSettingsRolesNewRoute
  AuthenticatedAppSettingsMeetingIndexRoute: typeof AuthenticatedAppSettingsMeetingIndexRoute
  AuthenticatedAppSettingsRolesIndexRoute: typeof AuthenticatedAppSettingsRolesIndexRoute
}

const AuthenticatedAppSettingsRouteRouteChildren: AuthenticatedAppSettingsRouteRouteChildren =
  {
    AuthenticatedAppSettingsAuditRouteRoute:
      AuthenticatedAppSettingsAuditRouteRouteWithChildren,
    AuthenticatedAppSettingsBillingRouteRoute:
      AuthenticatedAppSettingsBillingRouteRouteWithChildren,
    AuthenticatedAppSettingsAccessRoute: AuthenticatedAppSettingsAccessRoute,
    AuthenticatedAppSettingsAiSettingsRoute:
      AuthenticatedAppSettingsAiSettingsRoute,
    AuthenticatedAppSettingsApiKeysRoute: AuthenticatedAppSettingsApiKeysRoute,
    AuthenticatedAppSettingsCompanyRoute: AuthenticatedAppSettingsCompanyRoute,
    AuthenticatedAppSettingsConnectedAppsRoute:
      AuthenticatedAppSettingsConnectedAppsRoute,
    AuthenticatedAppSettingsMembersRoute: AuthenticatedAppSettingsMembersRoute,
    AuthenticatedAppSettingsNotificationsRoute:
      AuthenticatedAppSettingsNotificationsRoute,
    AuthenticatedAppSettingsOrderSettingsRoute:
      AuthenticatedAppSettingsOrderSettingsRoute,
    AuthenticatedAppSettingsProfileRoute: AuthenticatedAppSettingsProfileRoute,
    AuthenticatedAppSettingsServiceAreaRoute:
      AuthenticatedAppSettingsServiceAreaRoute,
    AuthenticatedAppSettingsServiceTypesRoute:
      AuthenticatedAppSettingsServiceTypesRoute,
    AuthenticatedAppSettingsUsageRoute: AuthenticatedAppSettingsUsageRoute,
    AuthenticatedAppSettingsWhiteLabelingRoute:
      AuthenticatedAppSettingsWhiteLabelingRoute,
    AuthenticatedAppSettingsIndexRoute: AuthenticatedAppSettingsIndexRoute,
    AuthenticatedAppSettingsInvoicingAccountingRoute:
      AuthenticatedAppSettingsInvoicingAccountingRoute,
    AuthenticatedAppSettingsMeetingBackgroundRoute:
      AuthenticatedAppSettingsMeetingBackgroundRoute,
    AuthenticatedAppSettingsMeetingDefaultsRoute:
      AuthenticatedAppSettingsMeetingDefaultsRoute,
    AuthenticatedAppSettingsMeetingRecordingRoute:
      AuthenticatedAppSettingsMeetingRecordingRoute,
    AuthenticatedAppSettingsOrdersPipelineRoute:
      AuthenticatedAppSettingsOrdersPipelineRoute,
    AuthenticatedAppSettingsRolesRoleIdRoute:
      AuthenticatedAppSettingsRolesRoleIdRoute,
    AuthenticatedAppSettingsRolesNewRoute:
      AuthenticatedAppSettingsRolesNewRoute,
    AuthenticatedAppSettingsMeetingIndexRoute:
      AuthenticatedAppSettingsMeetingIndexRoute,
    AuthenticatedAppSettingsRolesIndexRoute:
      AuthenticatedAppSettingsRolesIndexRoute,
  }

const AuthenticatedAppSettingsRouteRouteWithChildren =
  AuthenticatedAppSettingsRouteRoute._addFileChildren(
    AuthenticatedAppSettingsRouteRouteChildren,
  )

interface AuthenticatedAppStaffingRouteRouteChildren {
  AuthenticatedAppStaffingCategoriesRoute: typeof AuthenticatedAppStaffingCategoriesRoute
  AuthenticatedAppStaffingMyInterestsRoute: typeof AuthenticatedAppStaffingMyInterestsRoute
  AuthenticatedAppStaffingMyPostingsRoute: typeof AuthenticatedAppStaffingMyPostingsRoute
  AuthenticatedAppStaffingPendingApprovalsRoute: typeof AuthenticatedAppStaffingPendingApprovalsRoute
  AuthenticatedAppStaffingSkillLevelsRoute: typeof AuthenticatedAppStaffingSkillLevelsRoute
  AuthenticatedAppStaffingSkillsRoute: typeof AuthenticatedAppStaffingSkillsRoute
  AuthenticatedAppStaffingIndexRoute: typeof AuthenticatedAppStaffingIndexRoute
  AuthenticatedAppStaffingPostingsIdRoute: typeof AuthenticatedAppStaffingPostingsIdRoute
  AuthenticatedAppStaffingPostingsNewRoute: typeof AuthenticatedAppStaffingPostingsNewRoute
  AuthenticatedAppStaffingPostingsIdEditRoute: typeof AuthenticatedAppStaffingPostingsIdEditRoute
}

const AuthenticatedAppStaffingRouteRouteChildren: AuthenticatedAppStaffingRouteRouteChildren =
  {
    AuthenticatedAppStaffingCategoriesRoute:
      AuthenticatedAppStaffingCategoriesRoute,
    AuthenticatedAppStaffingMyInterestsRoute:
      AuthenticatedAppStaffingMyInterestsRoute,
    AuthenticatedAppStaffingMyPostingsRoute:
      AuthenticatedAppStaffingMyPostingsRoute,
    AuthenticatedAppStaffingPendingApprovalsRoute:
      AuthenticatedAppStaffingPendingApprovalsRoute,
    AuthenticatedAppStaffingSkillLevelsRoute:
      AuthenticatedAppStaffingSkillLevelsRoute,
    AuthenticatedAppStaffingSkillsRoute: AuthenticatedAppStaffingSkillsRoute,
    AuthenticatedAppStaffingIndexRoute: AuthenticatedAppStaffingIndexRoute,
    AuthenticatedAppStaffingPostingsIdRoute:
      AuthenticatedAppStaffingPostingsIdRoute,
    AuthenticatedAppStaffingPostingsNewRoute:
      AuthenticatedAppStaffingPostingsNewRoute,
    AuthenticatedAppStaffingPostingsIdEditRoute:
      AuthenticatedAppStaffingPostingsIdEditRoute,
  }

const AuthenticatedAppStaffingRouteRouteWithChildren =
  AuthenticatedAppStaffingRouteRoute._addFileChildren(
    AuthenticatedAppStaffingRouteRouteChildren,
  )

interface AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRouteChildren {
  AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRequestsRoute: typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRequestsRoute
  AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdSettingsRoute: typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdSettingsRoute
  AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdVideosRoute: typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdVideosRoute
  AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdIndexRoute: typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdIndexRoute
}

const AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRouteChildren: AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRouteChildren =
  {
    AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRequestsRoute:
      AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRequestsRoute,
    AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdSettingsRoute:
      AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdSettingsRoute,
    AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdVideosRoute:
      AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdVideosRoute,
    AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdIndexRoute:
      AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdIndexRoute,
  }

const AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRouteWithChildren =
  AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRoute._addFileChildren(
    AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRouteChildren,
  )

interface AuthenticatedAppRouteRouteChildren {
  AuthenticatedAppBookingsRouteRoute: typeof AuthenticatedAppBookingsRouteRouteWithChildren
  AuthenticatedAppChainRouteRoute: typeof AuthenticatedAppChainRouteRouteWithChildren
  AuthenticatedAppCrmRouteRoute: typeof AuthenticatedAppCrmRouteRouteWithChildren
  AuthenticatedAppFormsRouteRoute: typeof AuthenticatedAppFormsRouteRouteWithChildren
  AuthenticatedAppInspectionRouteRoute: typeof AuthenticatedAppInspectionRouteRouteWithChildren
  AuthenticatedAppInvoicingRouteRoute: typeof AuthenticatedAppInvoicingRouteRouteWithChildren
  AuthenticatedAppMemberPortalRouteRoute: typeof AuthenticatedAppMemberPortalRouteRouteWithChildren
  AuthenticatedAppOrdersRouteRoute: typeof AuthenticatedAppOrdersRouteRouteWithChildren
  AuthenticatedAppSettingsRouteRoute: typeof AuthenticatedAppSettingsRouteRouteWithChildren
  AuthenticatedAppStaffingRouteRoute: typeof AuthenticatedAppStaffingRouteRouteWithChildren
  AuthenticatedAppCalendarRoute: typeof AuthenticatedAppCalendarRoute
  AuthenticatedAppChecklistRoute: typeof AuthenticatedAppChecklistRoute
  AuthenticatedAppDashboardRoute: typeof AuthenticatedAppDashboardRoute
  AuthenticatedAppGettingStartedRoute: typeof AuthenticatedAppGettingStartedRoute
  AuthenticatedAppMeetingsRoute: typeof AuthenticatedAppMeetingsRoute
  AuthenticatedAppRecordingRoute: typeof AuthenticatedAppRecordingRoute
  AuthenticatedAppResourcesRoute: typeof AuthenticatedAppResourcesRoute
  AuthenticatedAppTeamLearningRoute: typeof AuthenticatedAppTeamLearningRoute
  AuthenticatedAppCompetenceApprovalsRoute: typeof AuthenticatedAppCompetenceApprovalsRoute
  AuthenticatedAppCompetenceMatrixRoute: typeof AuthenticatedAppCompetenceMatrixRoute
  AuthenticatedAppCompetenceMeRoute: typeof AuthenticatedAppCompetenceMeRoute
  AuthenticatedAppCompetenceTypesRoute: typeof AuthenticatedAppCompetenceTypesRoute
  AuthenticatedAppCoursesCourseIdRoute: typeof AuthenticatedAppCoursesCourseIdRoute
  AuthenticatedAppCoursesCreateRoute: typeof AuthenticatedAppCoursesCreateRoute
  AuthenticatedAppHistoryMeetingIDRoute: typeof AuthenticatedAppHistoryMeetingIDRoute
  AuthenticatedAppMyLearningRoute: typeof AuthenticatedAppMyLearningRoute
  AuthenticatedAppCompetenceIndexRoute: typeof AuthenticatedAppCompetenceIndexRoute
  AuthenticatedAppCoursesIndexRoute: typeof AuthenticatedAppCoursesIndexRoute
  AuthenticatedAppRecordAndSendIndexRoute: typeof AuthenticatedAppRecordAndSendIndexRoute
  AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRoute: typeof AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRouteWithChildren
  AuthenticatedAppCompetenceUserUserIdRoute: typeof AuthenticatedAppCompetenceUserUserIdRoute
  AuthenticatedAppCoursesCourseIdEditRoute: typeof AuthenticatedAppCoursesCourseIdEditRoute
  AuthenticatedAppRecordAndSendSubmissionsSubmissionIdRoute: typeof AuthenticatedAppRecordAndSendSubmissionsSubmissionIdRoute
  AuthenticatedAppRecordAndSendVideoTypesNewRoute: typeof AuthenticatedAppRecordAndSendVideoTypesNewRoute
}

const AuthenticatedAppRouteRouteChildren: AuthenticatedAppRouteRouteChildren = {
  AuthenticatedAppBookingsRouteRoute:
    AuthenticatedAppBookingsRouteRouteWithChildren,
  AuthenticatedAppChainRouteRoute: AuthenticatedAppChainRouteRouteWithChildren,
  AuthenticatedAppCrmRouteRoute: AuthenticatedAppCrmRouteRouteWithChildren,
  AuthenticatedAppFormsRouteRoute: AuthenticatedAppFormsRouteRouteWithChildren,
  AuthenticatedAppInspectionRouteRoute:
    AuthenticatedAppInspectionRouteRouteWithChildren,
  AuthenticatedAppInvoicingRouteRoute:
    AuthenticatedAppInvoicingRouteRouteWithChildren,
  AuthenticatedAppMemberPortalRouteRoute:
    AuthenticatedAppMemberPortalRouteRouteWithChildren,
  AuthenticatedAppOrdersRouteRoute:
    AuthenticatedAppOrdersRouteRouteWithChildren,
  AuthenticatedAppSettingsRouteRoute:
    AuthenticatedAppSettingsRouteRouteWithChildren,
  AuthenticatedAppStaffingRouteRoute:
    AuthenticatedAppStaffingRouteRouteWithChildren,
  AuthenticatedAppCalendarRoute: AuthenticatedAppCalendarRoute,
  AuthenticatedAppChecklistRoute: AuthenticatedAppChecklistRoute,
  AuthenticatedAppDashboardRoute: AuthenticatedAppDashboardRoute,
  AuthenticatedAppGettingStartedRoute: AuthenticatedAppGettingStartedRoute,
  AuthenticatedAppMeetingsRoute: AuthenticatedAppMeetingsRoute,
  AuthenticatedAppRecordingRoute: AuthenticatedAppRecordingRoute,
  AuthenticatedAppResourcesRoute: AuthenticatedAppResourcesRoute,
  AuthenticatedAppTeamLearningRoute: AuthenticatedAppTeamLearningRoute,
  AuthenticatedAppCompetenceApprovalsRoute:
    AuthenticatedAppCompetenceApprovalsRoute,
  AuthenticatedAppCompetenceMatrixRoute: AuthenticatedAppCompetenceMatrixRoute,
  AuthenticatedAppCompetenceMeRoute: AuthenticatedAppCompetenceMeRoute,
  AuthenticatedAppCompetenceTypesRoute: AuthenticatedAppCompetenceTypesRoute,
  AuthenticatedAppCoursesCourseIdRoute: AuthenticatedAppCoursesCourseIdRoute,
  AuthenticatedAppCoursesCreateRoute: AuthenticatedAppCoursesCreateRoute,
  AuthenticatedAppHistoryMeetingIDRoute: AuthenticatedAppHistoryMeetingIDRoute,
  AuthenticatedAppMyLearningRoute: AuthenticatedAppMyLearningRoute,
  AuthenticatedAppCompetenceIndexRoute: AuthenticatedAppCompetenceIndexRoute,
  AuthenticatedAppCoursesIndexRoute: AuthenticatedAppCoursesIndexRoute,
  AuthenticatedAppRecordAndSendIndexRoute:
    AuthenticatedAppRecordAndSendIndexRoute,
  AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRoute:
    AuthenticatedAppRecordAndSendVideoTypesVideoTypeIdRouteRouteWithChildren,
  AuthenticatedAppCompetenceUserUserIdRoute:
    AuthenticatedAppCompetenceUserUserIdRoute,
  AuthenticatedAppCoursesCourseIdEditRoute:
    AuthenticatedAppCoursesCourseIdEditRoute,
  AuthenticatedAppRecordAndSendSubmissionsSubmissionIdRoute:
    AuthenticatedAppRecordAndSendSubmissionsSubmissionIdRoute,
  AuthenticatedAppRecordAndSendVideoTypesNewRoute:
    AuthenticatedAppRecordAndSendVideoTypesNewRoute,
}

const AuthenticatedAppRouteRouteWithChildren =
  AuthenticatedAppRouteRoute._addFileChildren(
    AuthenticatedAppRouteRouteChildren,
  )

interface AuthenticatedSuperAdminRouteRouteChildren {
  AuthenticatedSuperAdminAdminsRoute: typeof AuthenticatedSuperAdminAdminsRoute
  AuthenticatedSuperAdminAuditRoute: typeof AuthenticatedSuperAdminAuditRoute
  AuthenticatedSuperAdminCompanyActivityRoute: typeof AuthenticatedSuperAdminCompanyActivityRoute
  AuthenticatedSuperAdminConnectedAppsRoute: typeof AuthenticatedSuperAdminConnectedAppsRoute
  AuthenticatedSuperAdminEmailLogsRoute: typeof AuthenticatedSuperAdminEmailLogsRoute
  AuthenticatedSuperAdminFeedbackRoute: typeof AuthenticatedSuperAdminFeedbackRoute
  AuthenticatedSuperAdminImpersonationLogsRoute: typeof AuthenticatedSuperAdminImpersonationLogsRoute
  AuthenticatedSuperAdminInspectionLibraryRoute: typeof AuthenticatedSuperAdminInspectionLibraryRoute
  AuthenticatedSuperAdminMcpActivityRoute: typeof AuthenticatedSuperAdminMcpActivityRoute
  AuthenticatedSuperAdminMcpAdoptionRoute: typeof AuthenticatedSuperAdminMcpAdoptionRoute
  AuthenticatedSuperAdminMobileAdoptionRoute: typeof AuthenticatedSuperAdminMobileAdoptionRoute
  AuthenticatedSuperAdminRecordAndSendRoute: typeof AuthenticatedSuperAdminRecordAndSendRoute
  AuthenticatedSuperAdminSmsLogsRoute: typeof AuthenticatedSuperAdminSmsLogsRoute
  AuthenticatedSuperAdminSuppressionListRoute: typeof AuthenticatedSuperAdminSuppressionListRoute
  AuthenticatedSuperAdminTranscriptionMonitorRoute: typeof AuthenticatedSuperAdminTranscriptionMonitorRoute
  AuthenticatedSuperAdminUnsubscribeListRoute: typeof AuthenticatedSuperAdminUnsubscribeListRoute
  AuthenticatedSuperAdminIndexRoute: typeof AuthenticatedSuperAdminIndexRoute
  AuthenticatedSuperAdminAiOpsCostRoute: typeof AuthenticatedSuperAdminAiOpsCostRoute
  AuthenticatedSuperAdminAiOpsRunsRoute: typeof AuthenticatedSuperAdminAiOpsRunsRoute
  AuthenticatedSuperAdminChainsParentCompanyIdRoute: typeof AuthenticatedSuperAdminChainsParentCompanyIdRoute
  AuthenticatedSuperAdminCompaniesCompanyIdRoute: typeof AuthenticatedSuperAdminCompaniesCompanyIdRoute
  AuthenticatedSuperAdminIndustryPresetsIdRoute: typeof AuthenticatedSuperAdminIndustryPresetsIdRoute
  AuthenticatedSuperAdminIndustryPresetsNewRoute: typeof AuthenticatedSuperAdminIndustryPresetsNewRoute
  AuthenticatedSuperAdminLoginSecuritySettingsRoute: typeof AuthenticatedSuperAdminLoginSecuritySettingsRoute
  AuthenticatedSuperAdminMeetingTelemetryMeetingIdRoute: typeof AuthenticatedSuperAdminMeetingTelemetryMeetingIdRoute
  AuthenticatedSuperAdminUsersUserIdRoute: typeof AuthenticatedSuperAdminUsersUserIdRoute
  AuthenticatedSuperAdminAiOpsIndexRoute: typeof AuthenticatedSuperAdminAiOpsIndexRoute
  AuthenticatedSuperAdminChainsIndexRoute: typeof AuthenticatedSuperAdminChainsIndexRoute
  AuthenticatedSuperAdminCompaniesIndexRoute: typeof AuthenticatedSuperAdminCompaniesIndexRoute
  AuthenticatedSuperAdminIndustryPresetsIndexRoute: typeof AuthenticatedSuperAdminIndustryPresetsIndexRoute
  AuthenticatedSuperAdminLoginSecurityIndexRoute: typeof AuthenticatedSuperAdminLoginSecurityIndexRoute
  AuthenticatedSuperAdminMeetingTelemetryIndexRoute: typeof AuthenticatedSuperAdminMeetingTelemetryIndexRoute
  AuthenticatedSuperAdminUsersIndexRoute: typeof AuthenticatedSuperAdminUsersIndexRoute
  AuthenticatedSuperAdminCompaniesCompanyIdRolesRoute: typeof AuthenticatedSuperAdminCompaniesCompanyIdRolesRoute
}

const AuthenticatedSuperAdminRouteRouteChildren: AuthenticatedSuperAdminRouteRouteChildren =
  {
    AuthenticatedSuperAdminAdminsRoute: AuthenticatedSuperAdminAdminsRoute,
    AuthenticatedSuperAdminAuditRoute: AuthenticatedSuperAdminAuditRoute,
    AuthenticatedSuperAdminCompanyActivityRoute:
      AuthenticatedSuperAdminCompanyActivityRoute,
    AuthenticatedSuperAdminConnectedAppsRoute:
      AuthenticatedSuperAdminConnectedAppsRoute,
    AuthenticatedSuperAdminEmailLogsRoute:
      AuthenticatedSuperAdminEmailLogsRoute,
    AuthenticatedSuperAdminFeedbackRoute: AuthenticatedSuperAdminFeedbackRoute,
    AuthenticatedSuperAdminImpersonationLogsRoute:
      AuthenticatedSuperAdminImpersonationLogsRoute,
    AuthenticatedSuperAdminInspectionLibraryRoute:
      AuthenticatedSuperAdminInspectionLibraryRoute,
    AuthenticatedSuperAdminMcpActivityRoute:
      AuthenticatedSuperAdminMcpActivityRoute,
    AuthenticatedSuperAdminMcpAdoptionRoute:
      AuthenticatedSuperAdminMcpAdoptionRoute,
    AuthenticatedSuperAdminMobileAdoptionRoute:
      AuthenticatedSuperAdminMobileAdoptionRoute,
    AuthenticatedSuperAdminRecordAndSendRoute:
      AuthenticatedSuperAdminRecordAndSendRoute,
    AuthenticatedSuperAdminSmsLogsRoute: AuthenticatedSuperAdminSmsLogsRoute,
    AuthenticatedSuperAdminSuppressionListRoute:
      AuthenticatedSuperAdminSuppressionListRoute,
    AuthenticatedSuperAdminTranscriptionMonitorRoute:
      AuthenticatedSuperAdminTranscriptionMonitorRoute,
    AuthenticatedSuperAdminUnsubscribeListRoute:
      AuthenticatedSuperAdminUnsubscribeListRoute,
    AuthenticatedSuperAdminIndexRoute: AuthenticatedSuperAdminIndexRoute,
    AuthenticatedSuperAdminAiOpsCostRoute:
      AuthenticatedSuperAdminAiOpsCostRoute,
    AuthenticatedSuperAdminAiOpsRunsRoute:
      AuthenticatedSuperAdminAiOpsRunsRoute,
    AuthenticatedSuperAdminChainsParentCompanyIdRoute:
      AuthenticatedSuperAdminChainsParentCompanyIdRoute,
    AuthenticatedSuperAdminCompaniesCompanyIdRoute:
      AuthenticatedSuperAdminCompaniesCompanyIdRoute,
    AuthenticatedSuperAdminIndustryPresetsIdRoute:
      AuthenticatedSuperAdminIndustryPresetsIdRoute,
    AuthenticatedSuperAdminIndustryPresetsNewRoute:
      AuthenticatedSuperAdminIndustryPresetsNewRoute,
    AuthenticatedSuperAdminLoginSecuritySettingsRoute:
      AuthenticatedSuperAdminLoginSecuritySettingsRoute,
    AuthenticatedSuperAdminMeetingTelemetryMeetingIdRoute:
      AuthenticatedSuperAdminMeetingTelemetryMeetingIdRoute,
    AuthenticatedSuperAdminUsersUserIdRoute:
      AuthenticatedSuperAdminUsersUserIdRoute,
    AuthenticatedSuperAdminAiOpsIndexRoute:
      AuthenticatedSuperAdminAiOpsIndexRoute,
    AuthenticatedSuperAdminChainsIndexRoute:
      AuthenticatedSuperAdminChainsIndexRoute,
    AuthenticatedSuperAdminCompaniesIndexRoute:
      AuthenticatedSuperAdminCompaniesIndexRoute,
    AuthenticatedSuperAdminIndustryPresetsIndexRoute:
      AuthenticatedSuperAdminIndustryPresetsIndexRoute,
    AuthenticatedSuperAdminLoginSecurityIndexRoute:
      AuthenticatedSuperAdminLoginSecurityIndexRoute,
    AuthenticatedSuperAdminMeetingTelemetryIndexRoute:
      AuthenticatedSuperAdminMeetingTelemetryIndexRoute,
    AuthenticatedSuperAdminUsersIndexRoute:
      AuthenticatedSuperAdminUsersIndexRoute,
    AuthenticatedSuperAdminCompaniesCompanyIdRolesRoute:
      AuthenticatedSuperAdminCompaniesCompanyIdRolesRoute,
  }

const AuthenticatedSuperAdminRouteRouteWithChildren =
  AuthenticatedSuperAdminRouteRoute._addFileChildren(
    AuthenticatedSuperAdminRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAppRouteRoute: typeof AuthenticatedAppRouteRouteWithChildren
  AuthenticatedSuperAdminRouteRoute: typeof AuthenticatedSuperAdminRouteRouteWithChildren
  AuthenticatedConnectedCompaniesRoute: typeof AuthenticatedConnectedCompaniesRoute
  AuthenticatedCreateCompanyRoute: typeof AuthenticatedCreateCompanyRoute
  AuthenticatedLinkAccountRoute: typeof AuthenticatedLinkAccountRoute
  AuthenticatedPracticeCallRoute: typeof AuthenticatedPracticeCallRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAppRouteRoute: AuthenticatedAppRouteRouteWithChildren,
  AuthenticatedSuperAdminRouteRoute:
    AuthenticatedSuperAdminRouteRouteWithChildren,
  AuthenticatedConnectedCompaniesRoute: AuthenticatedConnectedCompaniesRoute,
  AuthenticatedCreateCompanyRoute: AuthenticatedCreateCompanyRoute,
  AuthenticatedLinkAccountRoute: AuthenticatedLinkAccountRoute,
  AuthenticatedPracticeCallRoute: AuthenticatedPracticeCallRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface OauthRouteRouteChildren {
  OauthOauthConsentRoute: typeof OauthOauthConsentRoute
  OauthOauthResumeRoute: typeof OauthOauthResumeRoute
  OauthOauthSelectCompanyRoute: typeof OauthOauthSelectCompanyRoute
}

const OauthRouteRouteChildren: OauthRouteRouteChildren = {
  OauthOauthConsentRoute: OauthOauthConsentRoute,
  OauthOauthResumeRoute: OauthOauthResumeRoute,
  OauthOauthSelectCompanyRoute: OauthOauthSelectCompanyRoute,
}

const OauthRouteRouteWithChildren = OauthRouteRoute._addFileChildren(
  OauthRouteRouteChildren,
)

interface CustomerCustomerAuthenticatedRouteRouteChildren {
  CustomerCustomerAuthenticatedChangePasswordRoute: typeof CustomerCustomerAuthenticatedChangePasswordRoute
  CustomerCustomerAuthenticatedProfileRoute: typeof CustomerCustomerAuthenticatedProfileRoute
  CustomerCustomerAuthenticatedOrdersOrderIdRoute: typeof CustomerCustomerAuthenticatedOrdersOrderIdRoute
  CustomerCustomerAuthenticatedOrdersIndexRoute: typeof CustomerCustomerAuthenticatedOrdersIndexRoute
}

const CustomerCustomerAuthenticatedRouteRouteChildren: CustomerCustomerAuthenticatedRouteRouteChildren =
  {
    CustomerCustomerAuthenticatedChangePasswordRoute:
      CustomerCustomerAuthenticatedChangePasswordRoute,
    CustomerCustomerAuthenticatedProfileRoute:
      CustomerCustomerAuthenticatedProfileRoute,
    CustomerCustomerAuthenticatedOrdersOrderIdRoute:
      CustomerCustomerAuthenticatedOrdersOrderIdRoute,
    CustomerCustomerAuthenticatedOrdersIndexRoute:
      CustomerCustomerAuthenticatedOrdersIndexRoute,
  }

const CustomerCustomerAuthenticatedRouteRouteWithChildren =
  CustomerCustomerAuthenticatedRouteRoute._addFileChildren(
    CustomerCustomerAuthenticatedRouteRouteChildren,
  )

interface CustomerRouteRouteChildren {
  CustomerCustomerAuthenticatedRouteRoute: typeof CustomerCustomerAuthenticatedRouteRouteWithChildren
  CustomerForgotPasswordRoute: typeof CustomerForgotPasswordRoute
  CustomerLoginRoute: typeof CustomerLoginRoute
  CustomerResetPasswordRoute: typeof CustomerResetPasswordRoute
}

const CustomerRouteRouteChildren: CustomerRouteRouteChildren = {
  CustomerCustomerAuthenticatedRouteRoute:
    CustomerCustomerAuthenticatedRouteRouteWithChildren,
  CustomerForgotPasswordRoute: CustomerForgotPasswordRoute,
  CustomerLoginRoute: CustomerLoginRoute,
  CustomerResetPasswordRoute: CustomerResetPasswordRoute,
}

const CustomerRouteRouteWithChildren = CustomerRouteRoute._addFileChildren(
  CustomerRouteRouteChildren,
)

interface PrototypeRouteRouteChildren {
  PrototypeIndexRoute: typeof PrototypeIndexRoute
  PrototypeSlugScreenRoute: typeof PrototypeSlugScreenRoute
}

const PrototypeRouteRouteChildren: PrototypeRouteRouteChildren = {
  PrototypeIndexRoute: PrototypeIndexRoute,
  PrototypeSlugScreenRoute: PrototypeSlugScreenRoute,
}

const PrototypeRouteRouteWithChildren = PrototypeRouteRoute._addFileChildren(
  PrototypeRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  OauthRouteRoute: OauthRouteRouteWithChildren,
  CustomerRouteRoute: CustomerRouteRouteWithChildren,
  PrototypeRouteRoute: PrototypeRouteRouteWithChildren,
  SplatRoute: SplatRoute,
  AcceptInvitationRoute: AcceptInvitationRoute,
  AcceptInvitationTokenRoute: AcceptInvitationTokenRoute,
  CalendarCallbackRoute: CalendarCallbackRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  MeetingEndRoute: MeetingEndRoute,
  SignupRoute: SignupRoute,
  UpgradesRoute: UpgradesRoute,
  DotwellKnownChangePasswordRoute: DotwellKnownChangePasswordRoute,
  BookMeetingSlugRoute: BookMeetingSlugRoute,
  CancelBookingSlugRoute: CancelBookingSlugRoute,
  FormsSlugRoute: FormsSlugRoute,
  JoinMeetingIdRoute: JoinMeetingIdRoute,
  MeetingSummaryTokenRoute: MeetingSummaryTokenRoute,
  OauthErrorRoute: OauthErrorRoute,
  OfferTokenRoute: OfferTokenRoute,
  RecordMeetingIdRoute: RecordMeetingIdRoute,
  RecordingShareRoute: RecordingShareRoute,
  UnsubscribeEmailEmailRoute: UnsubscribeEmailEmailRoute,
  VSecretRoute: VSecretRoute,
  VideoPublicIdRoute: VideoPublicIdRoute,
  ItxframeIndexRoute: ItxframeIndexRoute,
  FormsAdditionalTokenRoute: FormsAdditionalTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
